import { defineComponent as ke, openBlock as $, createElementBlock as j, normalizeClass as pe, createElementVNode as te, toDisplayString as Ie, createCommentVNode as se, renderSlot as he, createBlock as we, unref as Z, createVNode as Re, mergeProps as Ce, shallowRef as Sn, computed as W, toValue as nt, watch as He, reactive as ii, h as qs, getCurrentInstance as li, inject as Xn, resolveComponent as Pa, createPropsRestProxy as ba, resolveDynamicComponent as Ft, withCtx as _e, ref as ge, onMounted as St, Transition as xn, normalizeProps as Ot, guardReactiveProps as Pt, createTextVNode as kt, toRef as Hi, normalizeStyle as Et, Teleport as pa, useSlots as cn, onUpdated as fo, onUnmounted as Ln, withModifiers as ca, Fragment as at, renderList as yt, useModel as Ya, mergeModels as _n, effectScope as js, useTemplateRef as ct, nextTick as Ga, createSlots as Ka, isRef as Ui, onBeforeUnmount as oi, provide as si, withDirectives as Qt, withKeys as ci, vModelCheckbox as ho, vModelDynamic as qi, readonly as vo, vShow as ui, createStaticVNode as Zs, TransitionGroup as Ws, getCurrentScope as Xs, onScopeDispose as Ys, shallowReadonly as On, version as Gs, vModelRadio as Ks, toRefs as Ea, onServerPrefetch as Js, onBeforeMount as Qs, vModelText as ec, watchEffect as tc } from "vue";
import { toArray as nc, unrefElement as mo, tryOnScopeDispose as go, refDebounced as ac, useTransition as rc, TransitionPresets as ic, useScrollLock as bo, onClickOutside as Ja, onKeyStroke as po, useEventListener as qt, useMediaQuery as lc, usePreferredReducedMotion as yo, useVibrate as wo, useTimeoutFn as na, useIntervalFn as xo, useDebounceFn as oc, useElementSize as Nn, useResizeObserver as sc, usePointerSwipe as cc } from "@vueuse/core";
import { isNotNestedPath as uc, cleanupNonNestedPath as dc, useForm as fc, useField as hc } from "vee-validate";
const Zr = /* @__PURE__ */ ke({
  __name: "LcCountBubble",
  props: {
    count: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), j("div", {
      key: 0,
      class: pe(["lc-count-bubble", e.variant && `lc-count-bubble--${e.variant}`])
    }, [
      te("span", null, Ie(e.count), 1)
    ], 2)) : se("", !0);
  }
}), wg = ["info", "success", "warning"], vc = "medium", xg = ["large", "medium", "small"], Je = /* @__PURE__ */ ke({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: () => vc }
  },
  setup(e) {
    return (t, n) => ($(), j("i", {
      "aria-hidden": "true",
      class: pe(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), kg = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clear",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "connection-slow",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "wifi-off",
  "winning",
  "winning-correction",
  "zoom"
], mc = { class: "lc-badge" }, Sg = /* @__PURE__ */ ke({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", mc, [
      he(t.$slots, "icon", {}, () => [
        e.icon ? ($(), we(Z(Je), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : se("", !0)
      ]),
      Re(Z(Zr), Ce({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      he(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gc = (e) => e != null;
var ko = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Ba = /* @__PURE__ */ ko.join(","), So = typeof Element > "u", Cn = So ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, za = !So && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Va = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : Va(t.parentNode));
  return a;
}, bc = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, _o = function(t, n, r) {
  if (Va(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Ba));
  return n && Cn.call(t, Ba) && o.unshift(t), o = o.filter(r), o;
}, Ha = function(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!Va(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, h = Ha(l, !0, r);
        r.flatten ? o.push.apply(o, h) : o.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = Cn.call(a, Ba);
        v && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !Va(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (u && f) {
          var m = Ha(u === !0 ? a.children : u.children, !0, r);
          r.flatten ? o.push.apply(o, m) : o.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, Co = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, yn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || bc(t)) && !Co(t) ? 0 : t.tabIndex;
}, pc = function(t, n) {
  var r = yn(t);
  return r < 0 && n && !Co(t) ? 0 : r;
}, yc = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Eo = function(t) {
  return t.tagName === "INPUT";
}, wc = function(t) {
  return Eo(t) && t.type === "hidden";
}, xc = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, kc = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Sc = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || za(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = kc(o, t.form);
  return !i || i === t;
}, _c = function(t) {
  return Eo(t) && t.type === "radio";
}, Cc = function(t) {
  return _c(t) && !Sc(t);
}, Ec = function(t) {
  var n, r = t && za(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var h, v, u;
      r = za(o), o = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = o) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(o));
    }
  }
  return i;
}, ji = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Tc = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), s = a.visibility;
  if (s === "hidden" || s === "collapse")
    return !0;
  var l = Cn.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (Cn.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = za(t);
        if (u && !u.shadowRoot && o(u) === !0)
          return ji(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if (Ec(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return ji(t);
  return !1;
}, Ac = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Cn.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ua = function(t, n) {
  return !(n.disabled || wc(n) || Tc(n, t) || // For a details element with a summary, the summary element gets the focus
  xc(n) || Ac(n));
}, Wr = function(t, n) {
  return !(Cc(n) || yn(n) < 0 || !Ua(t, n));
}, Lc = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, To = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = pc(s, a), h = a ? To(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, h) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: h
    });
  }), r.sort(yc).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, $c = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Ha([t], n.includeContainer, {
    filter: Wr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Lc
  }) : r = _o(t, n.includeContainer, Wr.bind(null, n)), To(r);
}, Ic = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Ha([t], n.includeContainer, {
    filter: Ua.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = _o(t, n.includeContainer, Ua.bind(null, n)), r;
}, Mn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Cn.call(t, Ba) === !1 ? !1 : Wr(n, t);
}, Dc = /* @__PURE__ */ ko.concat("iframe:not([inert]):not([inert] *)").join(","), xr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Cn.call(t, Dc) === !1 ? !1 : Ua(n, t);
};
function Xr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Oc(e) {
  if (Array.isArray(e)) return Xr(e);
}
function Zi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Ao(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Mc(e, t, n) {
  return (t = Bc(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Rc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Fc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wi(Object(n), !0).forEach(function(r) {
      Mc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Nc(e) {
  return Oc(e) || Rc(e) || Ao(e) || Fc();
}
function Pc(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bc(e) {
  var t = Pc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ao(e, t) {
  if (e) {
    if (typeof e == "string") return Xr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xr(e, t) : void 0;
  }
}
var Kt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Kt.getActiveTrap(t);
    n !== r && Kt.pauseTrap(t);
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Kt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, zc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Vc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ia = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Hc = function(t) {
  return ia(t) && !t.shiftKey;
}, Uc = function(t) {
  return ia(t) && t.shiftKey;
}, Yi = function(t) {
  return setTimeout(t, 0);
}, Kn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ta = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, qc = [], jc = function(t, n) {
  var r = n?.document || document, o = n?.trapStack || qc, i = Xi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Hc,
    isKeyBackward: Uc
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(C, T, F) {
    return C && C[T] !== void 0 ? C[T] : i[F || T];
  }, h = function(C, T) {
    var F = typeof T?.composedPath == "function" ? T.composedPath() : void 0;
    return a.containerGroups.findIndex(function(V) {
      var q = V.container, Y = V.tabbableNodes;
      return q.contains(C) || F?.includes(q) || Y.find(function(U) {
        return U === C;
      });
    });
  }, v = function(C) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, F = T.hasFallback, V = F === void 0 ? !1 : F, q = T.params, Y = q === void 0 ? [] : q, U = i[C];
    if (typeof U == "function" && (U = U.apply(void 0, Nc(Y))), U === !0 && (U = void 0), !U) {
      if (U === void 0 || U === !1)
        return U;
      throw new Error("`".concat(C, "` was specified but was not a node, or did not return a node"));
    }
    var oe = U;
    if (typeof U == "string") {
      try {
        oe = r.querySelector(U);
      } catch (ae) {
        throw new Error("`".concat(C, '` appears to be an invalid selector; error="').concat(ae.message, '"'), {
          cause: ae
        });
      }
      if (!oe && !V)
        throw new Error("`".concat(C, "` as selector refers to no known node"));
    }
    return oe;
  }, u = function(C) {
    var T = C.activeElement;
    return T ? T.shadowRoot && T.shadowRoot.activeElement !== null ? u(T.shadowRoot) : T : null;
  }, f = function() {
    var C = v("initialFocus", {
      hasFallback: !0
    });
    if (C === !1)
      return !1;
    if (C === void 0 || C && !xr(C, i.tabbableOptions)) {
      var T = u(r);
      if (h(T) >= 0)
        C = T;
      else {
        var F = a.tabbableGroups[0], V = F && F.firstTabbableNode;
        C = V || v("fallbackFocus");
      }
    } else C === null && (C = v("fallbackFocus"));
    if (!C)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return C;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(C) {
      var T = $c(C, i.tabbableOptions), F = Ic(C, i.tabbableOptions), V = T.length > 0 ? T[0] : void 0, q = T.length > 0 ? T[T.length - 1] : void 0, Y = F.find(function(ae) {
        return Mn(ae);
      }), U = F.slice().reverse().find(function(ae) {
        return Mn(ae);
      }), oe = !!T.find(function(ae) {
        return yn(ae) > 0;
      });
      return {
        container: C,
        tabbableNodes: T,
        focusableNodes: F,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: oe,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: V,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: Y,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: U,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(fe) {
          var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Se = T.indexOf(fe);
          return Se < 0 ? be ? F.slice(F.indexOf(fe) + 1).find(function(de) {
            return Mn(de);
          }) : F.slice(0, F.indexOf(fe)).reverse().find(function(de) {
            return Mn(de);
          }) : T[Se + (be ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(C) {
      return C.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(C) {
      return C.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(C) {
    if (C !== !1) {
      if (C === u(r)) {
        a.mostRecentlyFocusedNode = C;
        return;
      }
      if (!C || !C.focus) {
        c(f());
        return;
      }
      C.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = C, zc(C) && C.select();
    }
  }, p = function(C) {
    var T = v("setReturnFocus", {
      params: [C]
    });
    return T || (T === !1 ? !1 : C);
  }, x = function(C) {
    var T = C.target, F = C.event, V = C.isBackward, q = V === void 0 ? !1 : V;
    T = T || Ta(F), m();
    var Y = null;
    if (a.tabbableGroups.length > 0) {
      var U = h(T, F), oe = U >= 0 ? a.containerGroups[U] : void 0;
      if (U < 0)
        q ? Y = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : Y = a.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var ae = a.tabbableGroups.findIndex(function(Ae) {
          var Oe = Ae.firstTabbableNode;
          return T === Oe;
        });
        if (ae < 0 && (oe.container === T || xr(T, i.tabbableOptions) && !Mn(T, i.tabbableOptions) && !oe.nextTabbableNode(T, !1)) && (ae = U), ae >= 0) {
          var fe = ae === 0 ? a.tabbableGroups.length - 1 : ae - 1, be = a.tabbableGroups[fe];
          Y = yn(T) >= 0 ? be.lastTabbableNode : be.lastDomTabbableNode;
        } else ia(F) || (Y = oe.nextTabbableNode(T, !1));
      } else {
        var Se = a.tabbableGroups.findIndex(function(Ae) {
          var Oe = Ae.lastTabbableNode;
          return T === Oe;
        });
        if (Se < 0 && (oe.container === T || xr(T, i.tabbableOptions) && !Mn(T, i.tabbableOptions) && !oe.nextTabbableNode(T)) && (Se = U), Se >= 0) {
          var de = Se === a.tabbableGroups.length - 1 ? 0 : Se + 1, ye = a.tabbableGroups[de];
          Y = yn(T) >= 0 ? ye.firstTabbableNode : ye.firstDomTabbableNode;
        } else ia(F) || (Y = oe.nextTabbableNode(T));
      }
    } else
      Y = v("fallbackFocus");
    return Y;
  }, g = function(C) {
    var T = Ta(C);
    if (!(h(T, C) >= 0)) {
      if (Kn(i.clickOutsideDeactivates, C)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Kn(i.allowOutsideClick, C) || C.preventDefault();
    }
  }, b = function(C) {
    var T = Ta(C), F = h(T, C) >= 0;
    if (F || T instanceof Document)
      F && (a.mostRecentlyFocusedNode = T);
    else {
      C.stopImmediatePropagation();
      var V, q = !0;
      if (a.mostRecentlyFocusedNode)
        if (yn(a.mostRecentlyFocusedNode) > 0) {
          var Y = h(a.mostRecentlyFocusedNode), U = a.containerGroups[Y].tabbableNodes;
          if (U.length > 0) {
            var oe = U.findIndex(function(ae) {
              return ae === a.mostRecentlyFocusedNode;
            });
            oe >= 0 && (i.isKeyForward(a.recentNavEvent) ? oe + 1 < U.length && (V = U[oe + 1], q = !1) : oe - 1 >= 0 && (V = U[oe - 1], q = !1));
          }
        } else
          a.containerGroups.some(function(ae) {
            return ae.tabbableNodes.some(function(fe) {
              return yn(fe) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (V = x({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), c(V || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, _ = function(C) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = C;
    var F = x({
      event: C,
      isBackward: T
    });
    F && (ia(C) && C.preventDefault(), c(F));
  }, E = function(C) {
    (i.isKeyForward(C) || i.isKeyBackward(C)) && _(C, i.isKeyBackward(C));
  }, I = function(C) {
    Vc(C) && Kn(i.escapeDeactivates, C) !== !1 && (C.preventDefault(), s.deactivate());
  }, L = function(C) {
    var T = Ta(C);
    h(T, C) >= 0 || Kn(i.clickOutsideDeactivates, C) || Kn(i.allowOutsideClick, C) || (C.preventDefault(), C.stopImmediatePropagation());
  }, A = function() {
    if (a.active) {
      Kt.activateTrap(o, s);
      var C;
      return i.delayInitialFocus ? C = new Promise(function(T) {
        a.delayInitialFocusTimer = Yi(function() {
          c(f()), T();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", E, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), C;
    }
  }, B = function(C) {
    a.active && !a.paused && s._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var T = /* @__PURE__ */ new Set(), F = /* @__PURE__ */ new Set(), V = Zi(C), q;
    try {
      for (V.s(); !(q = V.n()).done; ) {
        var Y = q.value;
        T.add(Y);
        for (var U = typeof ShadowRoot < "u" && Y.getRootNode() instanceof ShadowRoot, oe = Y; oe; ) {
          T.add(oe);
          var ae = oe.parentElement, fe = [];
          ae ? fe = ae.children : !ae && U && (fe = oe.getRootNode().children, ae = oe.getRootNode().host, U = typeof ShadowRoot < "u" && ae.getRootNode() instanceof ShadowRoot);
          var be = Zi(fe), Se;
          try {
            for (be.s(); !(Se = be.n()).done; ) {
              var de = Se.value;
              F.add(de);
            }
          } catch (ye) {
            be.e(ye);
          } finally {
            be.f();
          }
          oe = ae;
        }
      }
    } catch (ye) {
      V.e(ye);
    } finally {
      V.f();
    }
    T.forEach(function(ye) {
      F.delete(ye);
    }), a.adjacentElements = F;
  }, H = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", E, !0), r.removeEventListener("keydown", I), s;
  }, re = function(C) {
    var T = a.mostRecentlyFocusedNode;
    if (T) {
      var F = C.some(function(q) {
        var Y = Array.from(q.removedNodes);
        return Y.some(function(U) {
          return U === T || typeof U.contains == "function" && U.contains(T);
        });
      });
      if (F && a.containers.some(function(q) {
        return q?.isConnected;
      })) {
        m();
        var V = f();
        c(V);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(re) : void 0, X = function() {
    O && (O.disconnect(), a.active && !a.paused && a.containers.map(function(C) {
      O.observe(C, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(C) {
      if (a.active)
        return this;
      var T = l(C, "onActivate"), F = l(C, "onPostActivate"), V = l(C, "checkCanFocusTrap"), q = Kt.getActiveTrap(o), Y = !1;
      if (q && !q.paused) {
        var U;
        (U = q._setSubtreeIsolation) === null || U === void 0 || U.call(q, !1), Y = !0;
      }
      try {
        V || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = u(r), T?.({
          trap: s
        });
        var oe = function() {
          V && m();
          var be = function() {
            s._setSubtreeIsolation(!0), X(), F?.({
              trap: s
            });
          }, Se = A();
          Se ? Se.then(be) : be();
        };
        if (V)
          return V(a.containers.concat()).then(oe, oe), this;
        oe();
      } catch (fe) {
        if (q === Kt.getActiveTrap(o) && Y) {
          var ae;
          (ae = q._setSubtreeIsolation) === null || ae === void 0 || ae.call(q, !0);
        }
        throw fe;
      }
      return this;
    },
    deactivate: function(C) {
      if (!a.active)
        return this;
      var T = Xi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, C);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || s._setSubtreeIsolation(!1), a.alreadySilent.clear(), H(), a.active = !1, a.paused = !1, X(), Kt.deactivateTrap(o, s);
      var F = l(T, "onDeactivate"), V = l(T, "onPostDeactivate"), q = l(T, "checkCanReturnFocus"), Y = l(T, "delayReturnFocus"), U = l(T, "returnFocus", "returnFocusOnDeactivate");
      F?.({
        trap: s
      });
      var oe = function() {
        U && c(p(a.nodeFocusedBeforeActivation)), V?.({
          trap: s
        });
      }, ae = function() {
        Y && U ? Yi(oe) : oe();
      };
      return U && q ? (q(p(a.nodeFocusedBeforeActivation)).then(ae, ae), this) : (ae(), this);
    },
    pause: function(C) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, C)) : this;
    },
    unpause: function(C) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, C)) : this;
    },
    updateContainerElements: function(C) {
      var T = [].concat(C).filter(Boolean);
      return a.containers = T.map(function(F) {
        return typeof F == "string" ? r.querySelector(F) : F;
      }), i.isolateSubtrees && B(a.containers), a.active && (m(), a.paused || s._setSubtreeIsolation(!0)), X(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(C, T) {
        if (a.paused === C)
          return this;
        if (a.paused = C, C) {
          var F = l(T, "onPause"), V = l(T, "onPostPause");
          F?.({
            trap: s
          }), H(), s._setSubtreeIsolation(!1), X(), V?.({
            trap: s
          });
        } else {
          var q = l(T, "onUnpause"), Y = l(T, "onPostUnpause");
          q?.({
            trap: s
          });
          var U = function() {
            m();
            var ae = function() {
              s._setSubtreeIsolation(!0), X(), Y?.({
                trap: s
              });
            }, fe = A();
            fe ? fe.then(ae) : ae();
          };
          U();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(C) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(T) {
          var F;
          C ? i.isolateSubtrees === "aria-hidden" ? ((T.ariaHidden === "true" || ((F = T.getAttribute("aria-hidden")) === null || F === void 0 ? void 0 : F.toLowerCase()) === "true") && a.alreadySilent.add(T), T.setAttribute("aria-hidden", "true")) : ((T.inert || T.hasAttribute("inert")) && a.alreadySilent.add(T), T.setAttribute("inert", !0)) : a.alreadySilent.has(T) || (i.isolateSubtrees === "aria-hidden" ? T.removeAttribute("aria-hidden") : T.removeAttribute("inert"));
        });
      }
    }
  }), s.updateContainerElements(t), s;
};
function Zc(e, t = {}) {
  let n;
  const { immediate: r, ...o } = t, i = Sn(!1), a = Sn(!1), s = (f) => n && n.activate(f), l = (f) => n && n.deactivate(f), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  }, u = W(() => {
    const f = nt(e);
    return nc(f).map((m) => {
      const c = nt(m);
      return typeof c == "string" ? c : mo(c);
    }).filter(gc);
  });
  return He(u, (f) => {
    if (f.length)
      if (!n)
        n = jc(f, {
          ...o,
          onActivate(m) {
            i.value = !0, t.onActivate && t.onActivate(m);
          },
          onDeactivate(m) {
            i.value = !1, t.onDeactivate && t.onDeactivate(m);
          }
        }), r && s();
      else {
        const m = n?.active;
        n?.updateContainerElements(f), !m && r && s();
      }
  }, { flush: "post" }), go(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const Lo = /* @__PURE__ */ ke((e, { slots: t }) => {
  const n = Sn(), r = ii(Zc(n, e.options));
  return () => {
    if (t.default) return qs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Wc = 864e5, Xc = 6e4, Yc = 36e5, Gi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function jn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Gi in e ? e[Gi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Rt(e, t) {
  return jn(e, e);
}
function Gc(e, t, n) {
  const r = Rt(e);
  return isNaN(t) ? jn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Kc(e, t, n) {
  const r = Rt(e);
  if (isNaN(t)) return jn(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = jn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
function Jn(e, t, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: i = 0,
    days: a = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Rt(e), u = o || r ? Kc(v, o + r * 12) : v, f = a || i ? Gc(u, a + i * 7) : u, m = l + s * 60, p = (h + m * 60) * 1e3;
  return jn(e, +f + p);
}
function Ki(e) {
  const t = Rt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function un(e, ...t) {
  const n = jn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ji(e, t) {
  const n = Rt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Jc(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Ji(r), a = Ji(o), s = +i - Ki(i), l = +a - Ki(a);
  return Math.round((s - l) / Wc);
}
function la(e, t) {
  const n = +Rt(e) - +Rt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Qc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function qa(e) {
  return !(!Qc(e) && typeof e != "number" || isNaN(+Rt(e)));
}
function eu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function tu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - o.getFullYear();
}
function nu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Qi(r, o), a = Math.abs(
    Jc(r, o)
  );
  r.setDate(r.getDate() - i * a);
  const s = +(Qi(r, o) === -i), l = i * (a - s);
  return l === 0 ? 0 : l;
}
function Qi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function di(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function au(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = (+r - +o) / Yc;
  return di(n?.roundingMethod)(i);
}
function $o(e, t) {
  return +Rt(e) - +Rt(t);
}
function ru(e, t, n) {
  const r = $o(e, t) / Xc;
  return di(n?.roundingMethod)(r);
}
function iu(e, t) {
  const n = Rt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function lu(e, t) {
  const n = Rt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function ou(e, t) {
  const n = Rt(e);
  return +iu(n) == +lu(n);
}
function su(e, t, n) {
  const [r, o, i] = un(
    n?.in,
    e,
    e,
    t
  ), a = la(o, i), s = Math.abs(
    eu(o, i)
  );
  if (s < 1) return 0;
  o.getMonth() === 1 && o.getDate() > 27 && o.setDate(30), o.setMonth(o.getMonth() - a * s);
  let l = la(o, i) === -a;
  ou(r) && s === 1 && la(r, i) === 1 && (l = !1);
  const h = a * (s - +l);
  return h === 0 ? 0 : h;
}
function cu(e, t, n) {
  const r = $o(e, t) / 1e3;
  return di(n?.roundingMethod)(r);
}
function uu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = la(r, o), a = Math.abs(tu(r, o));
  r.setFullYear(1584), o.setFullYear(1584);
  const s = la(r, o) === -i, l = i * (a - +s);
  return l === 0 ? 0 : l;
}
function du(e, t) {
  const [n, r] = un(e, t.start, t.end);
  return { start: n, end: r };
}
function fu(e, t) {
  const { start: n, end: r } = du(t?.in, e), o = {}, i = uu(r, n);
  i && (o.years = i);
  const a = Jn(n, { years: o.years }), s = su(r, a);
  s && (o.months = s);
  const l = Jn(a, { months: o.months }), h = nu(r, l);
  h && (o.days = h);
  const v = Jn(l, { days: o.days }), u = au(r, v);
  u && (o.hours = u);
  const f = Jn(v, { hours: o.hours }), m = ru(r, f);
  m && (o.minutes = m);
  const c = Jn(f, { minutes: o.minutes }), p = cu(r, c);
  return p && (o.seconds = p), o;
}
function hu(e) {
  return +Rt(e) < Date.now();
}
const vu = (e, t) => t.length === 1 ? (n) => e(n, t[0]) : (n) => e(n, ...t), Qa = (e, t) => t.length >= e.length ? e(...t) : vu(e, t);
function el(...e) {
  return Qa(mu, e);
}
const mu = (e, t) => e.length >= t;
function Lt(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function tl(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function gu(...e) {
  return Qa(Io, e);
}
function Io(e, t) {
  let n = { ...e, ...t };
  for (let r in t) Object.hasOwn(e, r) && tl(e[r]) && tl(t[r]) && (n[r] = Io(e[r], t[r]));
  return n;
}
function en(...e) {
  return Qa(bu, e);
}
function bu(e, t) {
  if (!el(t, 1)) return { ...e };
  if (!el(t, 2)) {
    let { [t[0]]: r, ...o } = e;
    return o;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function pu(...e) {
  return Qa(yu, e);
}
function yu(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const Do = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcCarousel: {
    autoPlayDelayInSeconds: 5,
    nextSlideAriaLabel: "Next slide",
    pauseAriaLabel: "Pause slideshow",
    playAriaLabel: "Play slideshow",
    prevSlideAriaLabel: "Previous slide",
    slideAriaLabel: "Slide {slide}"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    removeAriaLabel: "Remove play",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, Ze = ii(Do), _g = (e) => {
  Object.assign(Ze, gu(Do, e));
}, wu = /* @__PURE__ */ Symbol(), ya = () => {
  const e = li();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Xn(wu) : null;
}, xu = () => ya() ? Pa("NuxtTime") : "time", Oo = /* @__PURE__ */ ke({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => Ze.general.locale }
  },
  setup(e) {
    const t = ba(e, ["datetime", "locale"]), n = xu(), r = W(() => o.value ? i.value?.toISOString() : void 0), o = W(() => i.value ? qa(i.value) : !1), i = W(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, s) => o.value ? ($(), we(Ft(Z(n)), Ce({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: _e(() => [
        he(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : se("", !0);
  }
}), Yn = (e) => {
  const t = li(), n = ya();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Pa("NuxtLink") : Pa("RouterLink");
}, fi = /* @__PURE__ */ ke({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Yn(e.to);
    return (n, r) => ($(), we(Ft(Z(t)), Ce(n.$attrs, n.$props), {
      default: _e(() => [
        he(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ua = /* @__PURE__ */ ke({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = ge(!1), n = ac(t, 1);
    return St(() => {
      t.value = !0;
    }), (r, o) => ($(), we(xn, Ot(Pt({ name: e.name, mode: e.mode })), {
      default: _e(() => [
        Z(n) ? he(r.$slots, "default", {}, void 0, void 0, 0) : se("", !0)
      ]),
      _: 3
    }, 16));
  }
}), ku = {
  key: 0,
  class: "lc-feedback-message__content"
}, $n = /* @__PURE__ */ ke({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = W(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), j("div", {
      class: pe(t.value),
      role: "alert"
    }, [
      Re(Z(ua), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: _e(() => [
          e.content ? ($(), j("p", ku, [
            e.variant === "error" ? ($(), we(Z(Je), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : se("", !0),
            kt(" " + Ie(e.content), 1)
          ])) : se("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), Mo = "--vc-auto-duration", Su = `height var(${Mo}) cubic-bezier(0.33, 1, 0.68, 1)`, Aa = { padding: 0 }, _u = 300, Cu = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function nl(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function al(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: Su } : { transition: t };
}
function rl(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function Eu(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const Tu = /* @__PURE__ */ ke({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Hi(n, "when"), i = Hi(n, "baseHeight"), a = W(() => ({ overflow: "hidden", height: `${i.value}px` })), s = W(() => ({
      ...Aa,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = ge(null), h = ge(o.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function u() {
      return o.value ? Aa : i.value === 0 ? Cu : s.value;
    }
    const f = Sn(u()), m = (L) => f.value = L, c = (L) => m({ ...f.value, ...L }), p = ge(_u), x = (L) => p.value = L, g = W(() => ({ [Mo]: `${p.value}ms` }));
    let b = NaN;
    function _() {
      m(Aa), v("expanded"), r("expanded");
    }
    function E() {
      m(s.value), v("collapsed"), r("collapsed");
    }
    St(() => {
      if (!l.value) return;
      const L = Eu(l.value.scrollHeight - i.value);
      L > 0 && x(L), !o.value && i.value === 0 && m(s.value);
    }), He(o, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (rl(l)) return _();
          v("expanding"), r("expand"), m({
            ...Aa,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return _();
              b = l.value.scrollHeight, c({
                ...al(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (rl(l) || (v("collapsing"), r("collapse"), c({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return E();
          requestAnimationFrame(() => {
            l.value && c({
              ...a.value,
              ...al(l),
              willChange: "height"
            });
          });
        }
    }), He(i, (L) => {
      o.value || (L > 0 ? c({ display: void 0, height: `${L}px` }) : c({ display: "none" }));
    });
    function I(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (o.value ? Math.abs(l.value.scrollHeight - nl(l)) < 1 ? _() : b < l.value.scrollHeight && c({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - nl(l)) < 1 && E());
    }
    return (L, A) => ($(), we(Ft(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Et(f.value),
      onTransitionend: I,
      "data-collapse": h.value
    }, {
      default: _e(() => [
        he(L.$slots, "default", Ot(Pt({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), Ro = /* @__PURE__ */ ke({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), we(Z(Tu), Ce({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: _e(() => [
        he(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), we(Ft(e.as), { key: 1 }, {
      default: _e(() => [
        he(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Au = /* @__PURE__ */ ke({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), we(pa, {
      key: 0,
      to: e.to
    }, [
      he(t.$slots, "default")
    ], 8, ["to"])) : he(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), Lu = ["height", "width"], $u = ["r", "stroke-width"], Iu = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], Fo = /* @__PURE__ */ ke({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = W(() => Math.min(100, Math.max(0, e.progress))), n = W(() => e.radius - e.strokeWidth), r = W(() => 2 * Math.PI * n.value), o = W(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), j("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      te("circle", {
        class: pe(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, $u),
      te("circle", {
        class: pe(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": o.value,
        "stroke-width": e.strokeWidth
      }, null, 10, Iu)
    ], 8, Lu));
  }
}), Du = { class: "lc-timer-circle" }, Ou = ["aria-valuenow"], Mu = { class: "lc-timer-circle__content" }, Ru = /* @__PURE__ */ ke({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = ge(0), n = rc(t, {
      duration: e.durationInMs,
      transition: ic.linear
    });
    return St(() => {
      t.value = 100;
    }), (r, o) => ($(), j("div", Du, [
      te("div", {
        "aria-valuenow": Z(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Re(Z(Fo), Ce({ progress: Z(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, Ou),
      te("div", Mu, [
        he(r.$slots, "default")
      ])
    ]));
  }
}), Fu = (e, t) => e in t, tn = (e, t) => typeof e == "string" && Object.values(t).includes(e), Nu = "left", Pu = "large", Bu = "primary", Cg = ["left", "right"], Eg = ["large", "medium", "small"], Tg = ["button", "reset", "submit"], Ag = ["click", "long-press"], Lg = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Yr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Yr || {});
const zu = ["aria-valuenow"], Vu = { class: "lc-button__content" }, Hu = {
  key: 0,
  class: "lc-button__label-bubble"
}, Uu = {
  key: 0,
  class: "lc-button__overlay"
}, qu = { class: "lc-button__long-press-hint" }, ju = {
  key: 1,
  class: "lc-button__overlay"
}, Zu = {
  key: 0,
  class: "lc-button__loading-text"
}, il = 1e3 / 25, Tt = /* @__PURE__ */ ke({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: () => Nu },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => Ze.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: () => Pu },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: () => Bu }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = cn(), o = ge(!!r.default), i = ge(!1), a = ge(!1), s = ge(!1), l = ge(!1), h = ge(0), v = ge(null);
    let u, f, m;
    const c = W(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !o.value,
        "lc-button--link": x.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && s.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = W(() => e.disabled || e.loading), x = W(() => !!(e.href || e.to) && !p.value), g = W(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = W(() => l.value || !!v.value), _ = W(() => typeof e.to == "string" ? void 0 : e.to?.replace), E = W(() => {
      const V = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? V : {
        ...V,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = W(() => x.value ? Yn(e.to) : "button"), L = () => {
      i.value = !1, s.value = !1, X(), C();
    }, A = (V) => {
      p.value || tn(V.key, Yr) && (v.value || (v.value = V.key, H()));
    }, B = (V) => {
      tn(V.key, Yr) && V.key === v.value && (X(), !l.value && z());
    }, H = (V = !1) => {
      e.trigger !== "click" && (V && window.addEventListener("pointerup", O), clearTimeout(m), s.value = !0);
    }, re = () => {
      p.value || (l.value = !0, H(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), C(), !v.value && z();
    }, X = () => {
      v.value = null;
    }, z = () => {
      !s.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, s.value = !1);
    }, C = () => {
      l.value = !1;
    }, T = () => {
      p.value || H();
    }, F = () => {
      C(), z();
    };
    return fo(() => {
      o.value = !!r.default;
    }), Ln(() => {
      clearInterval(u), clearTimeout(f), clearTimeout(m);
    }), He(s, (V) => {
      if (!p.value) {
        if (!V) {
          clearInterval(u), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, u = setInterval(() => {
          h.value += il / e.longPressDelay * 100;
        }, il), f = setTimeout(() => {
          clearInterval(u), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (V, q) => ($(), we(Ft(I.value), Ce(V.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: E.value,
      replace: _.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: q[0] || (q[0] = ca(() => {
      }, ["prevent"])),
      onKeydown: A,
      onKeyup: B,
      onPointerdown: re,
      onPointerup: O,
      onTouchend: F,
      onTouchstartPassive: T
    }), {
      default: _e(() => [
        e.trigger === "long-press" ? ($(), j("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, zu)) : se("", !0),
        te("div", Vu, [
          e.icon ? ($(), we(Z(Je), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : se("", !0),
          Re(xn, { name: "font-size-fade" }, {
            default: _e(() => [
              V.$slots.default ? ($(), j("span", Hu, [
                he(V.$slots, "default"),
                Re(Z(Zr), Ce({ count: e.count }, {
                  class: "lc-button__count-text",
                  variant: "info"
                }), null, 16)
              ])) : se("", !0)
            ]),
            _: 3
          }),
          V.$slots.default ? se("", !0) : ($(), we(Z(Zr), Ce({ key: 1 }, { count: e.count }, {
            class: "lc-button__count",
            variant: "info"
          }), null, 16))
        ]),
        Re(Z(ua), { name: "fade" }, {
          default: _e(() => [
            g.value ? ($(), j("div", Uu, [
              te("span", qu, Ie(e.longPressHint), 1)
            ])) : se("", !0),
            e.loading ? ($(), j("div", ju, [
              Re(Z(Je), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), j("span", Zu, Ie(e.loadingText), 1)) : se("", !0)
            ])) : se("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), Wu = "default", $g = ["dashed", "default"], hi = /* @__PURE__ */ ke({
  __name: "LcSeparator",
  props: {
    variant: { default: () => Wu }
  },
  setup(e) {
    return (t, n) => ($(), j("hr", {
      class: pe(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), $t = (e) => {
  if (e) return `lc-${e}`;
  const t = ya(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, vi = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Xu = {}, Yu = { viewBox: "0 0 752 8" }, Gu = { id: "perforation" }, Ku = ["cx"];
function Ju(e, t) {
  return $(), j("svg", Yu, [
    te("mask", Gu, [
      t[0] || (t[0] = te("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(at, null, yt(new Array(21), (n, r) => ($(), j("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Ku))), 128))
    ]),
    t[1] || (t[1] = te("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Qu = /* @__PURE__ */ vi(Xu, [["render", Ju]]), ed = {}, td = { viewBox: "0 0 752 8" }, nd = { id: "perforation" }, ad = ["points"];
function rd(e, t) {
  return $(), j("svg", td, [
    te("mask", nd, [
      t[0] || (t[0] = te("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(at, null, yt(new Array(150), (n, r) => ($(), j("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, ad))), 128))
    ]),
    t[1] || (t[1] = te("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const ll = /* @__PURE__ */ vi(ed, [["render", rd]]), id = ["id"], ld = {
  key: 0,
  class: "lc-card__background"
}, od = {
  key: 1,
  class: /* @__PURE__ */ pe(["lc-card__perforation", "lc-card__perforation--top"])
}, sd = {
  key: 0,
  class: "lc-card__toggle"
}, cd = {
  key: 2,
  class: /* @__PURE__ */ pe(["lc-card__perforation", "lc-card__perforation--bottom"])
}, wa = /* @__PURE__ */ ke({
  __name: "LcCard",
  props: /* @__PURE__ */ _n({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => Ze.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = $t(e.id), r = ge(!!t.default), o = Ya(e, "modelValue"), i = W(() => !!e.animated && (!!e.expandable || o.value)), a = W(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": o.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), s = () => {
      e.expandable && (o.value = !o.value);
    };
    return fo(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), j("article", {
      id: Z(n),
      class: pe(a.value)
    }, [
      l.$slots.background ? ($(), j("div", ld, [
        he(l.$slots, "background")
      ])) : se("", !0),
      e.variant === "transaction" ? ($(), j("div", od, [
        Re(ll)
      ])) : se("", !0),
      l.$slots.header || e.expandable ? ($(), we(Ft(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${Z(n)}-region` : void 0,
        "aria-expanded": e.expandable ? o.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: s
      }, {
        default: _e(() => [
          e.headerTo && !e.expandable ? ($(), we(Z(fi), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: _e(() => [
              te("header", {
                class: pe(["lc-card__header", e.headerClass])
              }, [
                he(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), j("header", {
            key: 1,
            class: pe(["lc-card__header", e.headerClass])
          }, [
            he(l.$slots, "header"),
            e.expandable ? ($(), j(at, { key: 0 }, [
              l.$slots.toggle ? ($(), j("div", sd, [
                he(l.$slots, "toggle")
              ])) : ($(), we(Z(Je), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : se("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : se("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || o.value) ? ($(), we(Z(Ro), Ce({
        key: 3,
        id: `${Z(n)}-region`
      }, { when: o.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: _e(() => [
          l.$slots.default ? ($(), j("div", {
            key: 0,
            class: pe(["lc-card__body", e.bodyClass])
          }, [
            he(l.$slots, "default")
          ], 2)) : se("", !0),
          l.$slots.footer ? ($(), j("footer", {
            key: 1,
            class: pe(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), we(Z(hi), {
              key: 0,
              variant: "dashed"
            })) : se("", !0),
            he(l.$slots, "footer")
          ], 2)) : se("", !0),
          e.variant !== "default" ? ($(), j("div", cd, [
            e.variant == "order" ? ($(), we(Qu, { key: 0 })) : ($(), we(ll, { key: 1 }))
          ])) : se("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : se("", !0)
    ], 10, id));
  }
}), Ig = ["large", "medium", "none"], Dg = ["large", "none", "small"], Og = ["default", "order", "transaction"], er = () => typeof window < "u", Gr = /* @__PURE__ */ new Set();
let kr;
const ud = () => {
  kr ??= js(!0).run(() => bo(() => document.documentElement)), kr && (kr.value = Gr.size > 0);
}, dd = (e) => {
  const t = /* @__PURE__ */ Symbol("lc-scroll-lock-owner"), n = (r) => {
    er() && (r ? Gr.add(t) : Gr.delete(t), ud());
  };
  He(() => nt(e), n, { immediate: !0 }), go(() => n(!1));
}, fd = ["aria-hidden", "inert"], hd = { class: "lc-modal__card-header-wrap" }, vd = { class: "lc-modal__card-header-actions" }, No = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => Ze.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => Ze.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => Ze.lcModal.noFocusTrap },
    spacing: { default: () => Ze.lcModal.spacing },
    stackDepth: {},
    to: { default: () => Ze.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = ge(), o = W(() => (e.stackDepth ?? 0) > 0), i = W(() => v("close-button")), a = W(
      () => e.stackDepth === void 0 ? void 0 : { "--lc-modal-stack-depth": e.stackDepth }
    ), h = {
      allowOutsideClick: (m) => {
        const c = m.target;
        return c ? nt(e.ignoreOutsideClickOn).some((p) => (typeof p == "string" ? document.querySelector(p) : mo(p))?.contains(c) ?? !1) : !1;
      },
      // passed as a function, so the element is only created in the browser when the trap activates
      fallbackFocus: () => {
        const m = document.createElement("button");
        return m.id = "lc-modal-fallback-focus", m.hidden = !0, m;
      },
      immediate: !0
    }, v = (m) => e.closeTriggers.includes(m), u = (m) => {
      o.value || v(m) && n("close");
    }, f = (m) => {
      r.value = m;
    };
    return Ja(r, () => u("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), po("Escape", () => u("escape")), dd(() => e.isVisible), (m, c) => e.isVisible ? ($(), we(pa, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Re(Z(ua), { name: "fade" }, {
        default: _e(() => [
          te("div", {
            "aria-hidden": o.value || void 0,
            class: pe([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize,
                "lc-modal__bg--no-backdrop": o.value
              },
              e.backgroundClass
            ]),
            inert: o.value || void 0,
            style: Et(a.value)
          }, [
            Re(Z(ua), Ce(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: _e(() => [
                ($(), we(Ft(e.noFocusTrap ? "div" : Z(Lo)), {
                  options: e.noFocusTrap ? null : h
                }, {
                  default: _e(() => [
                    he(m.$slots, "modal", Ot(Pt({ setRef: f })), () => [
                      Re(Z(wa), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: pe([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: _e(() => [
                          m.$slots.header || i.value ? ($(), j("header", {
                            key: 0,
                            class: pe(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            te("div", hd, [
                              he(m.$slots, "header")
                            ]),
                            te("div", vd, [
                              he(m.$slots, "actions"),
                              i.value ? ($(), we(Z(Tt), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: c[0] || (c[0] = (p) => u("close-button"))
                              })) : se("", !0)
                            ])
                          ], 2)) : se("", !0),
                          he(m.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 14, fd)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
}), Mg = ["click-outside", "close-button", "escape"], Rg = ["large", "medium", "small"], md = 30, gd = 0.3, ol = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const o = parseFloat(t[1]);
    return t[2] === "px" ? o : o / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, bd = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const o = ge(0), i = ge(0), a = ge(!1), s = ge(0), l = ge(0), h = ge(0), v = ge(0), u = W(
    () => nt(t)[s.value] ?? nt(t)[0]
  ), f = W(() => s.value < nt(t).length - 1), m = () => {
    i.value = 0, o.value = 0, a.value = !1;
  }, c = () => {
    s.value = 0;
  }, p = (_, E) => (E > 0 ? _ / E : 0) > gd || _ > md, x = () => {
    if (!a.value) return;
    const _ = v.value - h.value, E = Date.now() - l.value, I = Math.abs(_), L = _ > 0 ? "down" : "up", A = nt(t);
    if (L === "up" && f.value && p(I, E)) {
      const H = ol(A[s.value]) + I;
      let re = s.value + 1, O = 1 / 0;
      for (let X = s.value + 1; X < A.length; X++) {
        const z = Math.abs(ol(A[X]) - H);
        z < O && (O = z, re = X);
      }
      s.value = re, m();
      return;
    }
    if (L === "down" && p(I, E) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (_) => {
    if (_.target.closest('button, a, [role="button"]')) return;
    _.currentTarget.setPointerCapture(_.pointerId), h.value = _.clientY, v.value = _.clientY, l.value = Date.now(), a.value = !0;
  }, b = (_) => {
    if (!a.value) return;
    v.value = _.clientY;
    const E = v.value - h.value;
    E < 0 && f.value ? (i.value = -E, o.value = 0) : (i.value = 0, o.value = Math.max(0, E));
  };
  return qt(e, "pointerdown", g), qt(e, "pointermove", b), qt(e, "pointerup", x), qt(e, "pointercancel", x), qt(e, "lostpointercapture", x), {
    currentSnapHeight: u,
    currentSnapIndex: s,
    dismissOffset: o,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, pd = { class: "lc-bottom-sheet-modal__header" }, yd = { class: "lc-bottom-sheet-modal__header-actions" }, wd = {
  key: 0,
  class: "lc-bottom-sheet-modal__footer"
}, xd = { class: "lc-bottom-sheet" }, kd = ["aria-labelledby"], Sd = { class: "lc-bottom-sheet__header-actions" }, _d = {
  key: 0,
  class: "lc-bottom-sheet__footer"
}, La = 300, sl = "lc-bottom-sheet__drag-area", Cd = "(width < 496px)", Fg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    maxHeight: {},
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => Ze.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${sl}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], o = t;
    let i;
    const s = `${$t()}-header`, l = ct("dragArea"), h = ge(!1), v = ge(!1), u = ge(!0), f = lc(Cd), m = bo(() => er() ? document.documentElement : null), {
      currentSnapHeight: c,
      dismissOffset: p,
      isDragging: x,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: _
    } = bd({
      canClose: () => H("swipe-down"),
      dragAreaRef: l,
      onClose: () => A(),
      snapHeights: W(() => e.snapHeights)
    }), E = W(
      () => e.closeTriggers.filter(
        (O) => r.includes(O)
      )
    ), I = () => {
      if (x.value) {
        const X = _.value !== 0;
        return {
          height: X ? `calc(${c.value} + ${_.value}px)` : c.value,
          transform: X ? "translateY(0)" : `translateY(${Math.max(0, p.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: c.value,
          transform: "translateY(100%)",
          transition: `transform ${La}ms ease`
        };
      const O = u.value;
      return {
        height: c.value,
        transform: O ? "translateY(100%)" : "translateY(0)",
        transition: u.value ? "none" : `height ${La}ms ease, transform ${La}ms ease`
      };
    }, L = W(() => ({ maxHeight: e.maxHeight, ...I() })), A = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), o("update:modelValue", !1);
      }, La));
    }, B = () => {
      H("click-outside") && A();
    }, H = (O) => e.closeTriggers.includes(O), re = (O) => {
      const X = O.target;
      v.value = X.scrollTop > 0;
    };
    return He(
      () => e.modelValue,
      async (O) => {
        if (!O) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, u.value = !0, m.value = !0, await Ga(), requestAnimationFrame(() => {
          u.value = !1;
        });
      },
      { immediate: !0 }
    ), po("Escape", () => {
      H("escape") && A();
    }), Ln(() => {
      clearTimeout(i), m.value = !1;
    }), (O, X) => Z(f) ? e.modelValue ? ($(), we(pa, {
      key: 1,
      to: e.to
    }, [
      te("div", xd, [
        te("div", {
          class: pe(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: B
        }, null, 2),
        Re(Z(Lo), { options: n }, {
          default: _e(() => [
            te("div", {
              "aria-labelledby": O.$slots.title ? s : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Et(L.value)
            }, [
              te("div", {
                ref: "dragArea",
                class: pe([
                  sl,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                X[1] || (X[1] = te("div", { class: "lc-bottom-sheet__handle" }, [
                  te("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                O.$slots.title || H("close-button") ? ($(), j("div", {
                  key: 0,
                  id: s,
                  class: "lc-bottom-sheet__header"
                }, [
                  he(O.$slots, "title"),
                  te("div", Sd, [
                    he(O.$slots, "actions"),
                    H("close-button") ? ($(), we(Z(Tt), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: A
                    })) : se("", !0)
                  ])
                ])) : se("", !0)
              ], 2),
              te("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: re
              }, [
                he(O.$slots, "default")
              ], 544),
              O.$slots.footer ? ($(), j("div", _d, [
                he(O.$slots, "footer")
              ])) : se("", !0)
            ], 12, kd)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : se("", !0) : ($(), we(Z(No), Ce({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": E.value,
      spacing: "small",
      onClose: X[0] || (X[0] = (z) => o("update:modelValue", !1))
    }), Ka({
      default: _e(() => [
        te("div", {
          class: pe(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: re
        }, [
          he(O.$slots, "default")
        ], 34),
        O.$slots.footer ? ($(), j("div", wd, [
          he(O.$slots, "footer")
        ])) : se("", !0)
      ]),
      _: 2
    }, [
      O.$slots.title ? {
        name: "header",
        fn: _e(() => [
          te("div", pd, [
            he(O.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      O.$slots.actions ? {
        name: "actions",
        fn: _e(() => [
          te("div", yd, [
            he(O.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), Ng = ["swipe-down", "click-outside", "escape"];
function Po(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function o(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (n = u.map((f) => f.height), r.forEach((f) => t.on(f, s)), s());
  }
  function i() {
    r.forEach((v) => t.off(v, s));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => n[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function s() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: o,
    destroy: i
  };
}
Po.globalOptions = void 0;
const Ed = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Qn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function ea(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function $a(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function tr(e = {}) {
  let t, n, r, o, i = [], a = [];
  const s = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, _) {
    n = b;
    const {
      mergeOptions: E,
      optionsAtMedia: I
    } = _, L = E(Ed, tr.globalOptions), A = E(L, e);
    t = I(A), r = n.rootNode(), o = n.slideNodes();
    const {
      watchDrag: B,
      loop: H
    } = n.internalEngine().options, re = !!B;
    t.loop && H && (v.loop = Qn(t.loop), $a(r, v.loop)), t.draggable && re && (v.draggable = Qn(t.draggable), $a(r, v.draggable)), t.dragging && (v.dragging = Qn(t.dragging), l.forEach((O) => n.on(O, m))), t.snapped && (v.snapped = Qn(t.snapped), s.forEach((O) => n.on(O, p)), p()), t.inView && (v.inView = Qn(t.inView), h.forEach((O) => n.on(O, x)), x());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), s.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, x)), ea(r, v.loop), ea(r, v.draggable), ea(r, v.dragging), c([], i, v.snapped), c([], a, v.inView), Object.keys(v).forEach((b) => {
      const _ = b;
      v[_] = [];
    });
  }
  function m(b, _) {
    (_ === "pointerDown" ? $a : ea)(r, v.dragging);
  }
  function c(b = [], _ = [], E) {
    const I = _.map((A) => o[A]), L = b.map((A) => o[A]);
    return I.forEach((A) => ea(A, E)), L.forEach((A) => $a(A, E)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), _ = b[n.selectedScrollSnap()];
    i = c(_, i, v.snapped);
  }
  function x() {
    const b = n.slidesInView();
    a = c(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
tr.globalOptions = void 0;
function cl(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Sr(e) {
  return typeof e == "number" && !isNaN(e);
}
function Bo(e = {}) {
  let o, i = [], a, s = 0, l = 0, h = 0, v = !1, u, f;
  function m(C) {
    o = C;
    const T = o.selectedScrollSnap(), {
      scrollBody: F,
      containerRect: V,
      axis: q
    } = o.internalEngine(), Y = q.measureSize(V);
    a = cl(Y * 0.75, 200, 500), v = !1, i = o.scrollSnapList().map((U, oe) => oe === T ? 1 : 0), u = F.settled, f = o.scrollProgress, F.settled = O, o.scrollProgress = X, o.on("select", b).on("slideFocus", p).on("pointerDown", g).on("pointerUp", x), E(), p();
  }
  function c() {
    const {
      scrollBody: C
    } = o.internalEngine();
    C.settled = u, o.scrollProgress = f, o.off("select", b).off("slideFocus", p).off("pointerDown", g).off("pointerUp", x), o.slideNodes().forEach((T) => {
      const F = T.style;
      F.opacity = "", F.transform = "", F.pointerEvents = "", T.getAttribute("style") || T.removeAttribute("style");
    });
  }
  function p() {
    const C = o.selectedScrollSnap();
    L(C, 1);
  }
  function x() {
    v = !1;
  }
  function g() {
    v = !1, s = 0, l = 0;
  }
  function b() {
    const C = o.internalEngine().scrollBody.duration();
    l = C ? 0 : 1, v = !0, C || p();
  }
  function _(C) {
    const {
      axis: T
    } = o.internalEngine();
    return `translate${T.scroll.toUpperCase()}(${T.direction(C)}px)`;
  }
  function E() {
    const {
      translate: C,
      slideLooper: T
    } = o.internalEngine();
    C.clear(), C.toggleActive(!1), T.loopPoints.forEach(({
      translate: F
    }) => {
      F.clear(), F.toggleActive(!1);
    });
  }
  function I(C) {
    const {
      scrollSnaps: T,
      location: F,
      target: V
    } = o.internalEngine();
    !Sr(C) || i[C] < 0.5 || (F.set(T[C]), V.set(F));
  }
  function L(C, T) {
    o.scrollSnapList().forEach((V, q) => {
      const Y = Math.abs(T), U = i[q], oe = q === C, ae = oe ? U + Y : U - Y, fe = cl(ae, 0, 1);
      i[q] = fe;
      const be = oe && v, Se = o.previousScrollSnap();
      be && (i[Se] = 1 - fe), oe && B(C, fe), A(q);
    });
  }
  function A(C) {
    const T = o.internalEngine().slideRegistry[C], {
      scrollSnaps: F,
      containerRect: V
    } = o.internalEngine(), q = i[C];
    T.forEach((Y) => {
      const U = o.slideNodes()[Y].style, oe = parseFloat(q.toFixed(2)), ae = oe > 0, fe = ae ? F[C] : V.width + 2, be = _(fe);
      ae && (U.transform = be), U.opacity = oe.toString(), U.pointerEvents = q > 0.5 ? "auto" : "none", ae || (U.transform = be);
    });
  }
  function B(C, T) {
    const {
      index: F,
      dragHandler: V,
      scrollSnaps: q
    } = o.internalEngine(), Y = V.pointerDown(), U = 1 / (q.length - 1);
    let oe = C, ae = Y ? o.selectedScrollSnap() : o.previousScrollSnap();
    if (Y && oe === ae) {
      const Se = Math.sign(s) * -1;
      oe = ae, ae = F.clone().set(ae).add(Se).get();
    }
    const fe = ae * U, be = (oe - ae) * U;
    h = fe + be * T;
  }
  function H() {
    const {
      dragHandler: C,
      index: T,
      scrollBody: F
    } = o.internalEngine(), V = o.selectedScrollSnap();
    if (!C.pointerDown()) return V;
    const q = Math.sign(F.velocity()), Y = Math.sign(s), U = T.clone().set(V).add(q * -1).get();
    return !q || !Y ? null : Y === q ? U : V;
  }
  function re(C) {
    const {
      dragHandler: T,
      scrollBody: F
    } = C.internalEngine(), V = T.pointerDown(), q = F.velocity(), Y = F.duration(), U = H(), oe = !Sr(U);
    if (V) {
      if (!q) return;
      s += q, l = Math.abs(q / a), I(U);
    }
    if (!V) {
      if (!Y || oe) return;
      l += (1 - i[U]) / Y, l *= 0.68;
    }
    oe || L(U, l);
  }
  function O() {
    const {
      target: C,
      location: T
    } = o.internalEngine(), F = C.get() - T.get(), V = Math.abs(F) >= 1, q = H(), Y = !Sr(q);
    return re(o), Y || V ? !1 : i[q] > 0.999;
  }
  function X() {
    return h;
  }
  return {
    name: "fade",
    options: e,
    init: m,
    destroy: c
  };
}
Bo.globalOptions = void 0;
function Td(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ul(e) {
  return Td(e) || Array.isArray(e);
}
function Ad() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function mi(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== i ? !1 : n.every((a) => {
    const s = e[a], l = t[a];
    return typeof s == "function" ? `${s}` == `${l}` : !ul(s) || !ul(l) ? s === l : mi(s, l);
  });
}
function dl(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Ld(e, t) {
  if (e.length !== t.length) return !1;
  const n = dl(e), r = dl(t);
  return n.every((o, i) => {
    const a = r[i];
    return mi(o, a);
  });
}
function gi(e) {
  return typeof e == "number";
}
function Kr(e) {
  return typeof e == "string";
}
function nr(e) {
  return typeof e == "boolean";
}
function fl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function dt(e) {
  return Math.abs(e);
}
function bi(e) {
  return Math.sign(e);
}
function oa(e, t) {
  return dt(e - t);
}
function $d(e, t) {
  if (e === 0 || t === 0 || dt(e) <= dt(t)) return 0;
  const n = oa(dt(e), dt(t));
  return dt(n / e);
}
function Id(e) {
  return Math.round(e * 100) / 100;
}
function da(e) {
  return fa(e).map(Number);
}
function jt(e) {
  return e[xa(e)];
}
function xa(e) {
  return Math.max(0, e.length - 1);
}
function pi(e, t) {
  return t === xa(e);
}
function hl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function fa(e) {
  return Object.keys(e);
}
function zo(e, t) {
  return [e, t].reduce((n, r) => (fa(r).forEach((o) => {
    const i = n[o], a = r[o], s = fl(i) && fl(a);
    n[o] = s ? zo(i, a) : a;
  }), n), {});
}
function Jr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function Dd(e, t) {
  const n = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Kr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function ha() {
  let e = [];
  function t(o, i, a, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(i, a, s), l = () => o.removeEventListener(i, a, s);
    else {
      const h = o;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function Od(e, t, n, r) {
  const o = ha(), i = 1e3 / 60;
  let a = null, s = 0, l = 0;
  function h() {
    o.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), o.clear();
  }
  function u(x) {
    if (!l) return;
    a || (a = x, n(), n());
    const g = x - a;
    for (a = x, s += g; s >= i; )
      n(), s -= i;
    const b = s / i;
    r(b), l && (l = t.requestAnimationFrame(u));
  }
  function f() {
    l || (l = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, s = 0, l = 0;
  }
  function c() {
    a = null, s = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function Md(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, s = v(), l = u();
  function h(c) {
    const {
      height: p,
      width: x
    } = c;
    return r ? p : x;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(c) {
    return c * a;
  }
  return {
    scroll: o,
    cross: i,
    startEdge: s,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function En(e = 0, t = 0) {
  const n = dt(e - t);
  function r(h) {
    return h < e;
  }
  function o(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || o(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function s(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function Vo(e, t, n) {
  const {
    constrain: r
  } = En(0, e), o = e + 1;
  let i = a(t);
  function a(f) {
    return n ? dt((o + f) % o) : r(f);
  }
  function s() {
    return i;
  }
  function l(f) {
    return i = a(f), u;
  }
  function h(f) {
    return v().set(s() + f);
  }
  function v() {
    return Vo(e, s(), n);
  }
  const u = {
    get: s,
    set: l,
    add: h,
    clone: v
  };
  return u;
}
function Rd(e, t, n, r, o, i, a, s, l, h, v, u, f, m, c, p, x, g, b) {
  const {
    cross: _,
    direction: E
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, A = ha(), B = ha(), H = En(50, 225).constrain(m.measure(20)), re = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, X = c ? 43 : 25;
  let z = !1, C = 0, T = 0, F = !1, V = !1, q = !1, Y = !1;
  function U(ue) {
    if (!b) return;
    function Fe(je) {
      (nr(b) || b(ue, je)) && de(je);
    }
    const qe = t;
    A.add(qe, "dragstart", (je) => je.preventDefault(), L).add(qe, "touchmove", () => {
    }, L).add(qe, "touchend", () => {
    }).add(qe, "touchstart", Fe).add(qe, "mousedown", Fe).add(qe, "touchcancel", Ae).add(qe, "contextmenu", Ae).add(qe, "click", Oe, !0);
  }
  function oe() {
    A.clear(), B.clear();
  }
  function ae() {
    const ue = Y ? n : t;
    B.add(ue, "touchmove", ye, L).add(ue, "touchend", Ae).add(ue, "mousemove", ye, L).add(ue, "mouseup", Ae);
  }
  function fe(ue) {
    const Fe = ue.nodeName || "";
    return I.includes(Fe);
  }
  function be() {
    return (c ? O : re)[Y ? "mouse" : "touch"];
  }
  function Se(ue, Fe) {
    const qe = u.add(bi(ue) * -1), je = v.byDistance(ue, !c).distance;
    return c || dt(ue) < H ? je : x && Fe ? je * 0.5 : v.byIndex(qe.get(), 0).distance;
  }
  function de(ue) {
    const Fe = Jr(ue, r);
    Y = Fe, q = c && Fe && !ue.buttons && z, z = oa(o.get(), a.get()) >= 2, !(Fe && ue.button !== 0) && (fe(ue.target) || (F = !0, i.pointerDown(ue), h.useFriction(0).useDuration(0), o.set(a), ae(), C = i.readPoint(ue), T = i.readPoint(ue, _), f.emit("pointerDown")));
  }
  function ye(ue) {
    if (!Jr(ue, r) && ue.touches.length >= 2) return Ae(ue);
    const qe = i.readPoint(ue), je = i.readPoint(ue, _), Xe = oa(qe, C), Ve = oa(je, T);
    if (!V && !Y && (!ue.cancelable || (V = Xe > Ve, !V)))
      return Ae(ue);
    const Pe = i.pointerMove(ue);
    Xe > p && (q = !0), h.useFriction(0.3).useDuration(0.75), s.start(), o.add(E(Pe)), ue.preventDefault();
  }
  function Ae(ue) {
    const qe = v.byDistance(0, !1).index !== u.get(), je = i.pointerUp(ue) * be(), Xe = Se(E(je), qe), Ve = $d(je, Xe), Pe = X - 10 * Ve, rt = g + Ve / 50;
    V = !1, F = !1, B.clear(), h.useDuration(Pe).useFriction(rt), l.distance(Xe, !c), Y = !1, f.emit("pointerUp");
  }
  function Oe(ue) {
    q && (ue.stopPropagation(), ue.preventDefault(), q = !1);
  }
  function We() {
    return F;
  }
  return {
    init: U,
    destroy: oe,
    pointerDown: We
  };
}
function Fd(e, t) {
  let r, o;
  function i(u) {
    return u.timeStamp;
  }
  function a(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Jr(u, t) ? u : u.touches[0])[c];
  }
  function s(u) {
    return r = u, o = u, a(u);
  }
  function l(u) {
    const f = a(u) - a(o), m = i(u) - i(r) > 170;
    return o = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !o) return 0;
    const f = a(o) - a(r), m = i(u) - i(r), c = i(u) - i(o) > 170, p = f / m;
    return m && !c && dt(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function Nd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: o + i,
      bottom: r + a,
      left: o,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function Pd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function Bd(e, t, n, r, o, i, a) {
  const s = [e].concat(r);
  let l, h, v = [], u = !1;
  function f(x) {
    return o.measureSize(a.measure(x));
  }
  function m(x) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const _ of b) {
        if (u) return;
        const E = _.target === e, I = r.indexOf(_.target), L = E ? h : v[I], A = f(E ? e : r[I]);
        if (dt(A - L) >= 0.5) {
          x.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (nr(i) || i(x, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      s.forEach((b) => l.observe(b));
    });
  }
  function c() {
    u = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function zd(e, t, n, r, o, i) {
  let a = 0, s = 0, l = o, h = i, v = e.get(), u = 0;
  function f() {
    const L = r.get() - e.get(), A = !l;
    let B = 0;
    return A ? (a = 0, n.set(r), e.set(r), B = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), B = v - u), s = bi(B), u = v, I;
  }
  function m() {
    const L = r.get() - t.get();
    return dt(L) < 1e-3;
  }
  function c() {
    return l;
  }
  function p() {
    return s;
  }
  function x() {
    return a;
  }
  function g() {
    return _(o);
  }
  function b() {
    return E(i);
  }
  function _(L) {
    return l = L, I;
  }
  function E(L) {
    return h = L, I;
  }
  const I = {
    direction: p,
    duration: c,
    velocity: x,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: E,
    useDuration: _
  };
  return I;
}
function Vd(e, t, n, r, o) {
  const i = o.measure(10), a = o.measure(50), s = En(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", p = dt(e[c] - t.get()), x = n.get() - t.get(), g = s.constrain(p / a);
    n.subtract(x * g), !m && dt(x) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function Hd(e, t, n, r, o) {
  const i = En(-t + e, 0), a = u(), s = v(), l = f();
  function h(c, p) {
    return oa(c, p) <= 1;
  }
  function v() {
    const c = a[0], p = jt(a), x = a.lastIndexOf(c), g = a.indexOf(p) + 1;
    return En(x, g);
  }
  function u() {
    return n.map((c, p) => {
      const {
        min: x,
        max: g
      } = i, b = i.constrain(c), _ = !p, E = pi(n, p);
      return _ ? g : E || h(x, b) ? x : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + o) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: c,
      max: p
    } = s;
    return a.slice(c, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function Ud(e, t, n) {
  const r = t[0], o = n ? r - e : jt(t);
  return {
    limit: En(o, r)
  };
}
function qd(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = En(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? s(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function jd(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Zd(e, t, n, r, o) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: s
  } = o, l = u().map(t.measure), h = f(), v = m();
  function u() {
    return s(r).map((p) => jt(p)[a] - p[0][i]).map(dt);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -dt(p));
  }
  function m() {
    return s(h).map((p) => p[0]).map((p, x) => p + l[x]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function Wd(e, t, n, r, o, i) {
  const {
    groupSlides: a
  } = o, {
    min: s,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(s, l).map((c, p, x) => {
      const g = !p, b = pi(x, p);
      if (g) {
        const _ = jt(x[0]) + 1;
        return hl(_);
      }
      if (b) {
        const _ = xa(i) - jt(x)[0] + 1;
        return hl(_, jt(x)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function Xd(e, t, n, r, o) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: s
  } = r;
  function l(c) {
    return c.concat().sort((p, x) => dt(p) - dt(x))[0];
  }
  function h(c) {
    const p = e ? a(c) : s(c), x = t.map((b, _) => ({
      diff: v(b - p, 0),
      index: _
    })).sort((b, _) => dt(b.diff) - dt(_.diff)), {
      index: g
    } = x[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(c, p) {
    const x = [c, c + n, c - n];
    if (!e) return c;
    if (!p) return l(x);
    const g = x.filter((b) => bi(b) === p);
    return g.length ? l(g) : jt(x) - n;
  }
  function u(c, p) {
    const x = t[c] - o.get(), g = v(x, p);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, p) {
    const x = o.get() + c, {
      index: g,
      distance: b
    } = h(x), _ = !e && i(x);
    if (!p || _) return {
      index: g,
      distance: c
    };
    const E = t[g] - b, I = c + v(E, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function Yd(e, t, n, r, o, i, a) {
  function s(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(u.index), a.emit("select"));
  }
  function l(u, f) {
    const m = o.byDistance(u, f);
    s(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = o.byIndex(m.get(), f);
    s(c);
  }
  return {
    distance: l,
    index: h
  };
}
function Gd(e, t, n, r, o, i, a, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!s) return;
    function c(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((_) => _.includes(p));
      gi(b) && (o.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((p, x) => {
      i.add(p, "focus", (g) => {
        (nr(s) || s(m, g)) && c(x);
      }, l);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function aa(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function o(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return gi(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: i
  };
}
function Ho(e, t) {
  const n = e.scroll === "x" ? a : s, r = t.style;
  let o = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function s(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = Id(e.direction(f));
    m !== o && (r.transform = n(m), o = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function Kd(e, t, n, r, o, i, a, s, l) {
  const v = da(o), u = da(o).reverse(), f = g().concat(b());
  function m(A, B) {
    return A.reduce((H, re) => H - o[re], B);
  }
  function c(A, B) {
    return A.reduce((H, re) => m(H, B) > 0 ? H.concat([re]) : H, []);
  }
  function p(A) {
    return i.map((B, H) => ({
      start: B - r[H] + 0.5 + A,
      end: B + t - 0.5 + A
    }));
  }
  function x(A, B, H) {
    const re = p(B);
    return A.map((O) => {
      const X = H ? 0 : -n, z = H ? n : 0, C = H ? "end" : "start", T = re[O][C];
      return {
        index: O,
        loopPoint: T,
        slideLocation: aa(-1),
        translate: Ho(e, l[O]),
        target: () => s.get() > T ? X : z
      };
    });
  }
  function g() {
    const A = a[0], B = c(u, A);
    return x(B, n, !1);
  }
  function b() {
    const A = t - a[0] - 1, B = c(v, A);
    return x(B, -n, !0);
  }
  function _() {
    return f.every(({
      index: A
    }) => {
      const B = v.filter((H) => H !== A);
      return m(B, t) <= 0.1;
    });
  }
  function E() {
    f.forEach((A) => {
      const {
        target: B,
        translate: H,
        slideLocation: re
      } = A, O = B();
      O !== re.get() && (H.to(O), re.set(O));
    });
  }
  function I() {
    f.forEach((A) => A.translate.clear());
  }
  return {
    canLoop: _,
    clear: I,
    loop: E,
    loopPoints: f
  };
}
function Jd(e, t, n) {
  let r, o = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      o || (nr(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function Qd(e, t, n, r) {
  const o = {};
  let i = null, a = null, s, l = !1;
  function h() {
    s = new IntersectionObserver((c) => {
      l || (c.forEach((p) => {
        const x = t.indexOf(p.target);
        o[x] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => s.observe(c));
  }
  function v() {
    s && s.disconnect(), l = !0;
  }
  function u(c) {
    return fa(o).reduce((p, x) => {
      const g = parseInt(x), {
        isIntersecting: b
      } = o[g];
      return (c && b || !c && !b) && p.push(g), p;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && a) return a;
    const p = u(c);
    return c && (i = p), c || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function ef(e, t, n, r, o, i) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: l
  } = e, h = n[0] && o, v = c(), u = p(), f = n.map(a), m = x();
  function c() {
    if (!h) return 0;
    const b = n[0];
    return dt(t[s] - b[s]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(jt(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function x() {
    return n.map((b, _, E) => {
      const I = !_, L = pi(E, _);
      return I ? f[_] + v : L ? f[_] + u : E[_ + 1][s] - b[s];
    }).map(dt);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function tf(e, t, n, r, o, i, a, s, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = gi(n);
  function m(g, b) {
    return da(g).filter((_) => _ % b === 0).map((_) => g.slice(_, _ + b));
  }
  function c(g) {
    return g.length ? da(g).reduce((b, _, E) => {
      const I = jt(b) || 0, L = I === 0, A = _ === xa(g), B = o[h] - i[I][h], H = o[h] - i[_][v], re = !r && L ? u(a) : 0, O = !r && A ? u(s) : 0, X = dt(H - O - (B + re));
      return E && X > t + l && b.push(_), A && b.push(g.length), b;
    }, []).map((b, _, E) => {
      const I = Math.max(E[_ - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : c(g);
  }
  return {
    groupSlides: p
  };
}
function nf(e, t, n, r, o, i, a) {
  const {
    align: s,
    axis: l,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: p,
    slidesToScroll: x,
    skipSnaps: g,
    containScroll: b,
    watchResize: _,
    watchSlides: E,
    watchDrag: I,
    watchFocus: L
  } = i, A = 2, B = Nd(), H = B.measure(t), re = n.map(B.measure), O = Md(l, h), X = O.measureSize(H), z = Pd(X), C = Dd(s, X), T = !u && !!b, F = u || !!b, {
    slideSizes: V,
    slideSizesWithGaps: q,
    startGap: Y,
    endGap: U
  } = ef(O, H, re, n, F, o), oe = tf(O, X, x, u, H, re, Y, U, A), {
    snaps: ae,
    snapsAligned: fe
  } = Zd(O, C, H, re, oe), be = -jt(ae) + jt(q), {
    snapsContained: Se,
    scrollContainLimit: de
  } = Hd(X, be, fe, b, A), ye = T ? Se : fe, {
    limit: Ae
  } = Ud(be, ye, u), Oe = Vo(xa(ye), v, u), We = Oe.clone(), Ne = da(n), ue = ({
    dragHandler: S,
    scrollBody: w,
    scrollBounds: K,
    options: {
      loop: M
    }
  }) => {
    M || K.constrain(S.pointerDown()), w.seek();
  }, Fe = ({
    scrollBody: S,
    translate: w,
    location: K,
    offsetLocation: M,
    previousLocation: ie,
    scrollLooper: D,
    slideLooper: J,
    dragHandler: y,
    animation: ce,
    eventHandler: Te,
    scrollBounds: d,
    options: {
      loop: ne
    }
  }, ee) => {
    const k = S.settled(), N = !d.shouldConstrain(), Q = ne ? k : k && N, $e = Q && !y.pointerDown();
    $e && ce.stop();
    const xe = K.get() * ee + ie.get() * (1 - ee);
    M.set(xe), ne && (D.loop(S.direction()), J.loop()), w.to(M.get()), $e && Te.emit("settle"), Q || Te.emit("scroll");
  }, qe = Od(r, o, () => ue(R), (S) => Fe(R, S)), je = 0.68, Xe = ye[Oe.get()], Ve = aa(Xe), Pe = aa(Xe), rt = aa(Xe), ut = aa(Xe), me = zd(Ve, rt, Pe, ut, f, je), Be = Xd(u, ye, be, Ae, ut), ze = Yd(qe, Oe, We, me, Be, ut, a), Ke = jd(Ae), Qe = ha(), ht = Qd(t, n, a, p), {
    slideRegistry: vt
  } = Wd(T, b, ye, de, oe, Ne), et = Gd(e, n, vt, ze, me, Qe, a, L), R = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: a,
    containerRect: H,
    slideRects: re,
    animation: qe,
    axis: O,
    dragHandler: Rd(O, e, r, o, ut, Fd(O, o), Ve, qe, ze, me, Be, Oe, a, z, m, c, g, je, I),
    eventStore: Qe,
    percentOfView: z,
    index: Oe,
    indexPrevious: We,
    limit: Ae,
    location: Ve,
    offsetLocation: rt,
    previousLocation: Pe,
    options: i,
    resizeHandler: Bd(t, a, o, n, O, _, B),
    scrollBody: me,
    scrollBounds: Vd(Ae, rt, ut, me, z),
    scrollLooper: qd(be, Ae, rt, [Ve, rt, Pe, ut]),
    scrollProgress: Ke,
    scrollSnapList: ye.map(Ke.get),
    scrollSnaps: ye,
    scrollTarget: Be,
    scrollTo: ze,
    slideLooper: Kd(O, X, be, V, q, ae, ye, rt, n),
    slideFocus: et,
    slidesHandler: Jd(t, a, E),
    slidesInView: ht,
    slideIndexes: Ne,
    slideRegistry: vt,
    slidesToScroll: oe,
    target: ut,
    translate: Ho(O, t)
  };
  return R;
}
function af() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function o(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((u) => u !== v), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: a,
    on: i,
    clear: s
  };
  return l;
}
const rf = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function lf(e) {
  function t(i, a) {
    return zo(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, s = fa(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, s);
  }
  function r(i) {
    return i.map((a) => fa(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function of(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(i, e)), a.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function ja(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, i = lf(o), a = of(i), s = ha(), l = af(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = l, p = O;
  let x = !1, g, b = h(rf, ja.globalOptions), _ = h(b), E = [], I, L, A;
  function B() {
    const {
      container: Ne,
      slides: ue
    } = _;
    L = (Kr(Ne) ? e.querySelector(Ne) : Ne) || e.children[0];
    const qe = Kr(ue) ? L.querySelectorAll(ue) : ue;
    A = [].slice.call(qe || L.children);
  }
  function H(Ne) {
    const ue = nf(e, L, A, r, o, Ne, l);
    if (Ne.loop && !ue.slideLooper.canLoop()) {
      const Fe = Object.assign({}, Ne, {
        loop: !1
      });
      return H(Fe);
    }
    return ue;
  }
  function re(Ne, ue) {
    x || (b = h(b, Ne), _ = v(b), E = ue || E, B(), g = H(_), u([b, ...E.map(({
      options: Fe
    }) => Fe)]).forEach((Fe) => s.add(Fe, "change", O)), _.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(We), g.eventHandler.init(We), g.resizeHandler.init(We), g.slidesHandler.init(We), g.options.loop && g.slideLooper.loop(), L.offsetParent && A.length && g.dragHandler.init(We), I = a.init(We, E)));
  }
  function O(Ne, ue) {
    const Fe = oe();
    X(), re(h({
      startIndex: Fe
    }, Ne), ue), l.emit("reInit");
  }
  function X() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), s.clear();
  }
  function z() {
    x || (x = !0, s.clear(), X(), l.emit("destroy"), l.clear());
  }
  function C(Ne, ue, Fe) {
    !_.active || x || (g.scrollBody.useBaseFriction().useDuration(ue === !0 ? 0 : _.duration), g.scrollTo.index(Ne, Fe || 0));
  }
  function T(Ne) {
    const ue = g.index.add(1).get();
    C(ue, Ne, -1);
  }
  function F(Ne) {
    const ue = g.index.add(-1).get();
    C(ue, Ne, 1);
  }
  function V() {
    return g.index.add(1).get() !== oe();
  }
  function q() {
    return g.index.add(-1).get() !== oe();
  }
  function Y() {
    return g.scrollSnapList;
  }
  function U() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function oe() {
    return g.index.get();
  }
  function ae() {
    return g.indexPrevious.get();
  }
  function fe() {
    return g.slidesInView.get();
  }
  function be() {
    return g.slidesInView.get(!1);
  }
  function Se() {
    return I;
  }
  function de() {
    return g;
  }
  function ye() {
    return e;
  }
  function Ae() {
    return L;
  }
  function Oe() {
    return A;
  }
  const We = {
    canScrollNext: V,
    canScrollPrev: q,
    containerNode: Ae,
    internalEngine: de,
    destroy: z,
    off: m,
    on: f,
    emit: c,
    plugins: Se,
    previousScrollSnap: ae,
    reInit: p,
    rootNode: ye,
    scrollNext: T,
    scrollPrev: F,
    scrollProgress: U,
    scrollSnapList: Y,
    scrollTo: C,
    selectedScrollSnap: oe,
    slideNodes: Oe,
    slidesInView: fe,
    slidesNotInView: be
  };
  return re(t, n), setTimeout(() => l.emit("init"), 0), We;
}
ja.globalOptions = void 0;
function ar(e = {}, t = []) {
  const n = Ui(e), r = Ui(t);
  let o = n ? e.value : e, i = r ? t.value : t;
  const a = Sn(), s = Sn();
  function l() {
    s.value && s.value.reInit(o, i);
  }
  return St(() => {
    !Ad() || !a.value || (ja.globalOptions = ar.globalOptions, s.value = ja(a.value, o, i));
  }), oi(() => {
    s.value && s.value.destroy();
  }), n && He(e, (h) => {
    mi(o, h) || (o = h, l());
  }), r && He(t, (h) => {
    Ld(i, h) || (i = h, l());
  }), [a, s];
}
ar.globalOptions = void 0;
const Pg = ["default", "highlight"], Bg = ["click", "keyboard"], Qr = /* @__PURE__ */ Symbol();
var Ra = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ra || {});
const sf = ["tabindex"], cf = {
  key: 0,
  class: "lc-carousel__arrows"
}, uf = ["aria-controls", "aria-current", "aria-label", "onClick"], df = { class: "lc-carousel__dot-indicator" }, ff = ["aria-label", "aria-pressed"], vl = 1.08, hf = /* @__PURE__ */ ke({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    arrows: { type: Boolean },
    autoPlay: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    fade: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    pagination: { type: Boolean },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = W(() => e.slides.length > 1), i = W(() => !e.disableSwipe && o.value), a = {
      align: "start",
      containScroll: "trimSnaps"
    }, s = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, l = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: i.value,
      watchResize: ({ containerNode: M, emit: ie, reInit: D }, J) => {
        if (!e.adaptiveHeight) return !0;
        for (const y of J) {
          if (M() === y.target) return !0;
          requestAnimationFrame(() => {
            D(), ie("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? s : a
    }, h = Ze.lcCarousel.autoPlayDelayInSeconds * 1e3, v = (M = e.fade) => [
      ...e.adaptiveHeight ? [Po()] : [],
      ...M ? [Bo()] : [],
      tr({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [u, f] = ar(
      {
        ...l,
        startIndex: e.defaultIndex
      },
      v()
    ), m = Xn(Qr, () => null, !0), c = yo(), p = ge(0), x = ge(0), g = ge(!i.value), b = ge(!1), _ = ge(!1), E = ge(!1), I = ge(!1), L = ge(!1), A = ge(), B = ge(e.defaultIndex), H = ge(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((M, ie) => ie)
      )
    );
    let re = h, O, X, z, C, T, F;
    const V = W(() => Ze.lcCarousel), q = W(
      () => !!e.autoPlay && o.value && !I.value && !E.value && !b.value
    ), Y = W(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--arrows": !!e.arrows && o.value,
        "lc-carousel--auto-play": !!e.autoPlay && o.value,
        "lc-carousel--auto-play-paused": !!e.autoPlay && !q.value,
        "lc-carousel--draggable": !g.value,
        "lc-carousel--fade": e.fade,
        "lc-carousel--keyboard-enabled": ze("keyboard"),
        "lc-carousel--swipe-hint": L.value
      }
    ]), U = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !1
      }), g.value = !0);
    }, oe = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !0
      }), g.value = !1);
    }, ae = (M, ie) => e.keyExtractor ? e.keyExtractor(M, ie) : e.keyProp && Fu(e.keyProp, M) ? String(M[e.keyProp]) : String(ie), fe = (M) => {
      const ie = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return Ke(M) ? ie : {
        ...ie,
        "aria-hidden": "true",
        inert: "true"
      };
    }, be = ({ clientX: M }) => {
      if (!f.value || !ze("click") || g.value) return;
      const D = f.value.slideNodes().map((J) => J.getBoundingClientRect());
      for (const [J, { left: y, right: ce }] of D.entries())
        if (!(M < y || M > ce)) {
          vt(J);
          break;
        }
    }, Se = () => {
      _.value = !0, w(), K(), je(), r("ready");
    }, de = (M) => {
      if (!(!tn(M.key, Ra) || !ze("keyboard") || g.value))
        switch (M.preventDefault(), M.stopPropagation(), M.key) {
          case Ra.ArrowLeft:
            R();
            break;
          case Ra.ArrowRight:
            et();
            break;
        }
    }, ye = () => {
      m?.disable(), Fe();
    }, Ae = () => {
      m?.enable(), je();
    }, Oe = () => {
      w(), K();
    }, We = () => {
      const M = f.value?.selectedScrollSnap() ?? 0;
      B.value = M, r("changed", M);
    }, Ne = () => {
      clearTimeout(X), X = void 0, O = void 0;
    }, ue = () => {
      clearTimeout(X), O = Date.now(), X = setTimeout(() => Xe(1), re);
    }, Fe = () => {
      !X || O === void 0 || (re = Math.max(0, re - (Date.now() - O)), Ne());
    }, qe = () => {
      !q.value || X || ue();
    }, je = () => {
      if (re = h, p.value += 1, !q.value) {
        Ne();
        return;
      }
      ue();
    }, Xe = (M) => {
      const ie = M > 0;
      if (!(ie ? f.value?.canScrollNext() : f.value?.canScrollPrev())) {
        Ve((B.value + M + e.slides.length) % e.slides.length);
        return;
      }
      ie ? et() : R(), je();
    }, Ve = (M) => {
      f.value?.scrollTo(M, Qe(!0)), je();
    }, Pe = (M) => V.value.slideAriaLabel.replace("{slide}", String(M + 1)), rt = () => {
      if (q.value) {
        I.value = !0;
        return;
      }
      I.value = !1, E.value = !1;
    }, ut = () => {
      b.value = document.visibilityState === "hidden", ht();
    }, me = [
      ["focusin", () => E.value = !0],
      ["focusout", () => E.value = !1],
      ["mouseenter", () => E.value = !0],
      ["mouseleave", () => E.value = !1]
    ], Be = () => {
      clearTimeout(T), T = setTimeout(() => f.value?.reInit(), 50);
    }, ze = (M) => e.moveTriggers.includes(M), Ke = (M) => H.value.has(M), Qe = (M) => !M || c.value === "reduce", ht = () => {
      const M = A.value?.querySelector(".lc-carousel__dot-progress")?.getAnimations?.().at(0);
      if (M) {
        if (q.value) {
          M.play();
          return;
        }
        M.pause();
      }
    }, vt = (M, ie = !0) => {
      f.value?.scrollTo(M, Qe(ie));
    }, et = (M = !0) => {
      f.value?.scrollNext(Qe(M));
    }, R = (M = !0) => {
      f.value?.scrollPrev(Qe(M));
    }, S = async () => {
      L.value || (L.value = !0, await new Promise((M) => {
        F = setTimeout(() => {
          L.value = !1, M();
        }, 1800);
      }));
    }, w = () => {
      if (!f.value || e.variant !== "highlight") return;
      const { rootNode: M, slideNodes: ie } = f.value, D = ie(), y = M().getBoundingClientRect(), ce = y.left + y.width / 2;
      let Te = D[0], d = 1 / 0;
      D.forEach((N) => {
        const Q = N.getBoundingClientRect(), $e = Q.left + Q.width / 2, xe = Math.abs($e - ce);
        xe < d && (Te = N, d = xe);
      });
      const k = Te.offsetWidth * (vl - 1) / 2;
      D.forEach((N, Q) => {
        if (N === Te) {
          x.value = Q, N.style.transform = `scale(${vl.toString()}) translateX(0px)`, N.style.zIndex = "1";
          return;
        }
        const $e = N.getBoundingClientRect(), Le = $e.left + $e.width / 2 < ce ? -1 : 1;
        N.style.transform = `scale(1) translateX(${(Le * k).toString()}px)`, N.style.zIndex = "0";
      });
    }, K = () => {
      if (!f.value) return;
      const M = f.value.slidesInView();
      if (!M.length) return;
      const ie = e.slides.length, D = /* @__PURE__ */ new Set();
      M.forEach((J) => {
        for (let y = -e.visibleSlideBuffer; y <= e.visibleSlideBuffer; y++) {
          const ce = (J + y + ie) % ie;
          D.add(ce);
        }
      }), H.value = D;
    };
    return St(() => {
      document.addEventListener("visibilitychange", ut), f.value && (f.value.on("init", Se).on("pointerDown", ye).on("pointerUp", Ae).on("reInit", Oe).on("resize", K).on("scroll", w).on("select", We).on("slidesChanged", w).on("slidesInView", K), C = f.value.rootNode(), me.forEach(
        ([M, ie]) => C?.addEventListener(M, ie)
      ), e.adaptiveHeight && (z = new ResizeObserver(Be), f.value.slideNodes().forEach((M) => z?.observe(M))));
    }), Ln(() => {
      document.removeEventListener("visibilitychange", ut), me.forEach(
        ([M, ie]) => C?.removeEventListener(M, ie)
      ), Ne(), clearTimeout(F), clearTimeout(T), z?.disconnect();
    }), He(
      [i, () => e.fade, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([M, ie, D, J, y]) => {
        g.value = !M, f.value?.reInit(
          {
            ...l,
            loop: D,
            skipSnaps: J,
            watchDrag: M,
            ...y === "highlight" ? s : a
          },
          v(ie)
        );
      }
    ), He(q, (M) => M ? qe() : Fe()), t({
      disable: U,
      enable: oe,
      moveToIndex: vt,
      next: et,
      prev: R,
      showSwipeHint: S
    }), si(Qr, {
      disable: U,
      enable: oe
    }), (M, ie) => ($(), j("div", {
      class: pe(Y.value),
      style: Et(
        e.autoPlay ? { "--lc-carousel-auto-play-delay": `${h}ms` } : void 0
      ),
      tabindex: ze("keyboard") ? 0 : void 0,
      onClickPassive: be,
      onKeydown: de
    }, [
      te("div", {
        ref_key: "emblaRef",
        ref: u,
        class: "lc-carousel__container"
      }, [
        te("div", Ce({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), j(at, null, yt(e.slides, (D, J) => he(M.$slots, "slide", Ce({ ref_for: !0 }, { slide: D, index: J }, {
            key: ae(D, J),
            attributes: fe(J),
            isHighlighted: x.value === J,
            isVisible: Ke(J)
          }))), 128))
        ], 16),
        e.arrows && o.value ? ($(), j("nav", cf, [
          Re(Z(Tt), {
            "aria-controls": e.id,
            "aria-label": V.value.prevSlideAriaLabel,
            icon: "chevron-left",
            size: "small",
            variant: "filled",
            onClick: ie[0] || (ie[0] = (D) => Xe(-1))
          }, null, 8, ["aria-controls", "aria-label"]),
          Re(Z(Tt), {
            "aria-controls": e.id,
            "aria-label": V.value.nextSlideAriaLabel,
            icon: "chevron-right",
            size: "small",
            variant: "filled",
            onClick: ie[1] || (ie[1] = (D) => Xe(1))
          }, null, 8, ["aria-controls", "aria-label"])
        ])) : se("", !0)
      ], 512),
      e.pagination && o.value ? ($(), j("div", {
        key: 0,
        ref_key: "paginationElement",
        ref: A,
        class: "lc-carousel__pagination"
      }, [
        ($(!0), j(at, null, yt(e.slides, (D, J) => ($(), j("button", {
          key: ae(D, J),
          "aria-controls": e.id,
          "aria-current": B.value === J ? "true" : void 0,
          "aria-label": Pe(J),
          class: pe(["lc-carousel__dot", { "lc-carousel__dot--active": B.value === J }]),
          type: "button",
          onClick: (y) => Ve(J)
        }, [
          te("span", df, [
            e.autoPlay && B.value === J ? ($(), j("span", {
              key: p.value,
              class: "lc-carousel__dot-progress"
            })) : se("", !0)
          ])
        ], 10, uf))), 128)),
        e.autoPlay ? ($(), j("button", {
          key: 0,
          "aria-label": q.value ? V.value.pauseAriaLabel : V.value.playAriaLabel,
          "aria-pressed": q.value ? "false" : "true",
          class: "lc-carousel__auto-play-toggle",
          type: "button",
          onClick: rt
        }, [
          Re(Z(Je), {
            name: q.value ? "pause" : "play-filled",
            size: "small"
          }, null, 8, ["name"])
        ], 8, ff)) : se("", !0)
      ], 512)) : se("", !0)
    ], 46, sf));
  }
}), vf = ["for"], mf = { class: "lc-checkbox__control" }, gf = ["id", "data-click-name"], bf = ["id"], zg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: o } = wo(), i = W(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), j("div", {
      class: pe([i.value, s.$attrs.class])
    }, [
      te("label", {
        class: "lc-checkbox__wrap",
        for: Z(r)
      }, [
        te("div", mf, [
          Qt(te("input", Ce({ id: Z(r) }, {
            ...en(s.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = ci((h) => a.value = !a.value, ["enter"]))
          }), null, 16, gf), [
            [ho, a.value]
          ]),
          Re(Z(Je), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(r)}-label`,
          class: "lc-checkbox__label"
        }, Ie(e.label), 9, bf)) : se("", !0)
      ], 8, vf),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Uo = () => typeof window > "u";
function pf(e, t) {
  const n = ya(), r = typeof e == "string" ? e : void 0, o = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, o) : n.useState(o);
  const i = o ? nt(o()) : void 0;
  return ge(i);
}
const yi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, qo = (e, t) => fu({
  end: new Date(t),
  start: new Date(e)
}), jo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...yi[t],
  timeZone: r
}).format(new Date(e)), _r = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), yf = 2147483647, wf = /* @__PURE__ */ ke({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, o = Uo(), i = pf(() => /* @__PURE__ */ new Date()), a = ge(!1);
    let s, l;
    const h = W(() => {
      if (a.value) return n;
      const { hours: E, minutes: I, seconds: L } = qo(i.value, m.value);
      return {
        ...n,
        hours: E || 0,
        minutes: I || 0,
        seconds: L || 0
      };
    }), v = W(() => u.value ? m.value.toISOString() : void 0), u = W(() => qa(m.value)), f = W(() => {
      const { hours: E, minutes: I, seconds: L } = h.value, A = `${_r(I)}:${_r(L)}`;
      return e.variant === "without-hours" ? A : `${_r(E)}:${A}`;
    }), m = W(() => new Date(e.expiresAt)), c = () => {
      clearInterval(s), clearTimeout(l);
    }, p = () => {
      a.value || (a.value = !0, r("expired"), c());
    }, x = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, g = () => hu(m.value), b = () => {
      if (!u.value) return;
      const E = m.value.getTime() - Date.now();
      E > yf || (l = setTimeout(p, Math.max(0, E)));
    }, _ = () => {
      c(), b(), s = setInterval(() => {
        g() ? p() : x();
      }, 1e3);
    };
    return oi(() => {
      c();
    }), He(
      v,
      () => {
        o || (a.value = !1, _());
      },
      {
        immediate: !0
      }
    ), (E, I) => u.value ? ($(), j("time", Ce({ key: 0 }, { datetime: v.value }, { class: "lc-countdown" }), Ie(f.value), 17)) : se("", !0);
  }
}), Vg = ["default", "without-hours"], xf = { class: "lc-data-list" }, Hg = /* @__PURE__ */ ke({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), j("ul", xf, [
      he(t.$slots, "default")
    ]));
  }
}), kf = { class: "lc-data-list-item" }, Sf = { class: "lc-data-list-item__content" }, _f = {
  key: 0,
  class: "lc-data-list-item__headline"
}, Cf = {
  key: 0,
  class: "lc-data-list-item__text"
}, Ef = { key: 0 }, Tf = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, Ug = /* @__PURE__ */ ke({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), j("li", kf, [
      te("div", Sf, [
        te("section", null, [
          e.headline ? ($(), j("span", _f, Ie(e.headline), 1)) : se("", !0),
          he(t.$slots, "default", {}, () => [
            e.text ? ($(), j("p", Cf, Ie(e.text), 1)) : se("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), j("aside", Ef, [
          he(t.$slots, "suffix")
        ])) : se("", !0)
      ]),
      t.$slots.underneath ? ($(), j("div", Tf, [
        he(t.$slots, "underneath")
      ])) : se("", !0)
    ]));
  }
});
var Af = Object.defineProperty, Lf = (e, t, n) => t in e ? Af(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, sa = (e, t, n) => Lf(e, typeof t != "symbol" ? t + "" : t, n);
const ml = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, gl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), bl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, $f = (e, t = !0, n) => {
  var r, o, i, a;
  const s = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((o = n.number) == null ? void 0 : o.fraction) ?? 0;
  let h = bl(0, l, n);
  const v = h.formatToParts(1000.12), u = ((i = v.find((x) => x.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((x) => x.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = gl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return s;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const x = c[1].length <= l ? c[1].length : l;
    h = bl(x, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = gl(p, u, f), s + p;
}, Zo = (e) => JSON.parse(e.replaceAll("'", '"')), If = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = Df(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = Ia(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = Ia(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = Ia(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = Of(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = Ia(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, Ia = (e) => e !== "" ? !!JSON.parse(e) : !0, Df = (e) => e.startsWith("[") && e.endsWith("]") ? Zo(e) : e, Of = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Zo(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Wo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Wo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class Mf {
  constructor(t = {}) {
    sa(this, "opts", {}), sa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...ml, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Wo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = ml;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, o) => r.length - o.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((o) => this.process(t, o, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((o, i) => {
      o === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(o);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return $f(t, r, this.opts);
    if (n == null) return t;
    const o = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(o)) return this.memo.get(o);
    const { mask: i, escaped: a } = this.escapeMask(n), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => x > -1 && g > -1 : () => x < i.length && g < t.length, m = (_) => !this.isReversed() && _ <= u || this.isReversed() && _ >= u;
    let c, p = -1, x = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const _ = i.charAt(x), E = l[_], I = E?.transform != null ? E.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(x) && E != null ? (I.match(E.pattern) != null ? (s[v](I), E.repeated ? (p === -1 ? p = x : x === u && x !== p && (x = p - h), u === p && (x -= h)) : E.multiple && (b = !0, x -= h), x += h) : E.multiple ? b && (x += h, g -= h, b = !1) : I === c ? c = void 0 : E.optional && (x += h, g -= h), g += h) : (r && !this.isEager() && s[v](_), I === _ && !this.isEager() ? g += h : c = _, this.isEager() || (x += h)), this.isEager())
        for (; m(x) && (l[i.charAt(x)] == null || a.includes(x)); ) {
          if (r) {
            if (s[v](i.charAt(x)), t.charAt(g) === i.charAt(x)) {
              x += h, g += h;
              continue;
            }
          } else i.charAt(x) === t.charAt(g) && (g += h);
          x += h;
        }
    }
    return this.memo.set(o, s.join("")), this.memo.get(o);
  }
}
const Xo = ["text", "search", "url", "tel", "password"];
let Rf = class {
  constructor(t, n = {}) {
    sa(this, "items", /* @__PURE__ */ new Map()), sa(this, "eventAbortController"), sa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const o = r.target, i = this.items.get(o);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), s = i.isEager(), l = a && s && i.unmasked(o.value) === "" ? "" : o.value;
      this.fixCursor(o, a, () => this.setValue(o, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!Xo.includes(r.type)) return;
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const o = new Mf(If(r, n));
      this.items.set(r, o), queueMicrotask(() => this.updateValue(r));
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: o, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var o, i, a;
    const s = t.selectionStart, l = t.value;
    if (r(), s === null || s === l.length && !n) return;
    const h = t.value, v = l.slice(0, s), u = h.slice(0, s), f = (o = this.processInput(t, v)) == null ? void 0 : o.unmasked, m = (i = this.processInput(t, u)) == null ? void 0 : i.unmasked;
    if (f === void 0 || m === void 0) return;
    let c = s;
    if (v !== u)
      if (n)
        c += h.length - l.length;
      else if (f.length === 0)
        c = 0;
      else {
        c = h.length;
        for (let p = 1; p <= h.length; p++)
          if ((((a = this.processInput(t, h.slice(0, p))) == null ? void 0 : a.unmasked) ?? "").length >= f.length) {
            c = p;
            break;
          }
      }
    t.setSelectionRange(c, c);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((o) => o(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let o = n ?? t.value;
    this.options.preProcess != null && (o = this.options.preProcess(o));
    let i = r.masked(o);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(o),
      completed: r.completed(o)
    };
  }
};
const Cr = /* @__PURE__ */ new WeakMap(), Ff = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, Nf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || !Xo.includes(r.type)) return;
  let o = {};
  if (t.value != null && (o = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const s = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      Ff(t, s);
    };
    o.onMaska = o.onMaska == null ? i : Array.isArray(o.onMaska) ? [...o.onMaska, i] : [o.onMaska, i];
  }
  Cr.has(r) ? (n = Cr.get(r)) == null || n.update(o) : Cr.set(r, new Rf(r, o));
}, Pf = ["for"], Bf = ["id"], zf = { class: "lc-input__input-wrap" }, Vf = ["data-testid"], Hf = ["data-testid"], rr = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, o = n, i = ct("input"), a = $t(e.id), s = ge(!1), l = W(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = W(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => s.value = !0,
      onFocusout: () => s.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = W(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": s.value || !!e.value || typeof e.value == "number"
      }
    ]), u = W(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = W({
      get: () => e.value,
      set: (c) => {
        o("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return St(() => {
      e.autofocus && i.value?.focus(), e.value && o("update:value", e.value);
    }), t({ ref: i }), (c, p) => ($(), j("div", {
      class: pe([l.value, c.$attrs.class])
    }, [
      te("label", {
        class: "lc-input__wrap",
        for: Z(a)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(a)}-label`,
          class: pe(v.value)
        }, Ie(e.label), 11, Bf)) : se("", !0),
        te("div", zf, [
          c.$slots.prefix ? ($(), j("div", {
            key: 0,
            class: pe(["lc-input__prefix", e.prefixClass])
          }, [
            he(c.$slots, "prefix")
          ], 2)) : se("", !0),
          e.mask ? Qt(($(), j("input", Ce({
            key: 1,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, Vf)), [
            [qi, f.value],
            [Z(Nf), u.value]
          ]) : Qt(($(), j("input", Ce({
            key: 2,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, Hf)), [
            [qi, f.value]
          ]),
          c.$slots.suffix ? ($(), j("div", {
            key: 3,
            class: pe(["lc-input__suffix", e.suffixClass])
          }, [
            he(c.$slots, "suffix")
          ], 2)) : se("", !0)
        ])
      ], 8, Pf),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), jg = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], Zg = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], Wg = /* @__PURE__ */ ke({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ba(e, ["mask", "placeholder"]);
    return (n, r) => ($(), we(Z(rr), Ce({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), Uf = { class: "lc-description-list" }, Xg = /* @__PURE__ */ ke({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), j("dl", Uf, [
      he(t.$slots, "default")
    ]));
  }
}), Yo = /* @__PURE__ */ Symbol();
var ln = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(ln || {});
const Yg = /* @__PURE__ */ ke({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ba(e, ["index"]), i = ct("input"), a = Xn(Yo, () => null, !0), s = W(() => nt(a?.config)), l = W(() => o.disabled || !!nt(a?.disabled)), h = W(() => l.value ? "*" : "#"), v = W({
      get: () => l.value ? "X" : f.value,
      set: (c) => {
        if (l.value || c === "X") return;
        const p = typeof c == "number" ? c : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), u = W(() => a ? `${nt(a.name)}_input_${e.index}` : o.name), f = W(() => a ? nt(a.value)?.[e.index] : o.value), m = (c) => {
      if (tn(c.key, ln))
        switch (c.key !== ln.Dead && c.preventDefault(), c.key) {
          case ln.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case ln.ArrowRight:
            a?.focusNext(e.index);
            break;
          case ln.Backspace:
          case ln.Delete:
            v.value = null;
            break;
          case ln.Dead: {
            const p = c.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(c.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (c, p) => ($(), we(Z(rr), Ce({ ref: "input" }, { ...c.$attrs, ...o, ...s.value, disabled: l.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), qf = ["id"], jf = ["id"], Zf = ["aria-labelledby"], Gg = /* @__PURE__ */ ke({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ge([]), i = $t(e.id), a = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, s = () => {
      const f = o.value.findIndex((m) => !m.disabled);
      o.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= o.value.length) return;
      const m = o.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = o.value.slice(0, f).reverse().find(({ disabled: x }) => !x)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= o.value.length) return;
      const p = o.value[c];
      if (p.disabled) {
        v(c, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (o.value[m.index] = m);
    };
    return St(s), t({ focusFirstEnabledInput: s, focusInputByIndex: l }), si(Yo, {
      config: vo(
        W(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), j("fieldset", Ce(f.$attrs, {
      id: Z(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), j("legend", {
        key: 0,
        id: `${Z(i)}-label`,
        class: pe(["lc-digit-input-group__label", e.legendClass])
      }, [
        he(f.$slots, "legend")
      ], 10, jf)) : se("", !0),
      te("div", {
        "aria-labelledby": f.$slots.legend ? `${Z(i)}-label` : void 0,
        class: pe(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        he(f.$slots, "default", Ot(Pt({ setRef: u })))
      ], 10, Zf),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, qf));
  }
}), Wf = ["id"], Xf = ["aria-expanded"], Yf = ["aria-expanded"], Gf = /* @__PURE__ */ ke({
  __name: "LcExpandable",
  props: /* @__PURE__ */ _n({
    actionClass: {},
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    hideIcon: { type: Boolean },
    headerTag: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = $t(e.id), r = `${n}-region`, o = Ya(e, "modelValue"), i = W(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": o.value,
        "lc-expandable--with-action": !!t.action
      }
    ]), a = W(() => ["lc-expandable__action", e.actionClass]), s = W(() => ["lc-expandable__content", e.contentClass]), l = () => {
      o.value = !o.value;
    };
    return (h, v) => ($(), j("article", Ce(h.$attrs, {
      id: Z(n),
      class: i.value
    }), [
      e.headerTag ? ($(), we(Ft(e.headerTag), {
        key: 0,
        class: "lc-expandable__heading"
      }, {
        default: _e(() => [
          te("button", Ce({ "aria-controls": r }, { disabled: e.disabled }, {
            "aria-expanded": o.value,
            class: ["lc-expandable__header", e.headerClass],
            type: "button",
            onClickPassive: l
          }), [
            he(h.$slots, "header"),
            e.disabled ? se("", !0) : ($(), we(Z(Je), {
              key: 0,
              class: "lc-expandable__header-icon",
              name: "chevron-down"
            }))
          ], 16, Xf)
        ]),
        _: 3
      })) : ($(), j("button", Ce({
        key: 1,
        "aria-controls": r
      }, { disabled: e.disabled }, {
        "aria-expanded": o.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: l
      }), [
        he(h.$slots, "header"),
        !e.disabled && !e.hideIcon ? ($(), we(Z(Je), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        })) : se("", !0)
      ], 16, Yf)),
      t.action ? ($(), j("div", {
        key: 2,
        class: pe(a.value)
      }, [
        he(h.$slots, "action")
      ], 2)) : se("", !0),
      e.animated ? ($(), we(Z(Ro), {
        key: 3,
        animated: "",
        class: "lc-expandable__collapse",
        when: o.value,
        onCollapse: v[0] || (v[0] = (u) => h.$emit("collapse")),
        onCollapsed: v[1] || (v[1] = (u) => h.$emit("collapsed")),
        onExpand: v[2] || (v[2] = (u) => h.$emit("expand")),
        onExpanded: v[3] || (v[3] = (u) => h.$emit("expanded"))
      }, {
        default: _e(() => [
          te("section", {
            id: r,
            class: pe(s.value),
            role: "region"
          }, [
            he(h.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Qt(($(), j("section", {
        key: 4,
        id: r,
        class: pe(s.value),
        role: "region"
      }, [
        he(h.$slots, "default")
      ], 2)), [
        [ui, o.value]
      ])
    ], 16, Wf));
  }
}), Kf = { class: "lc-expandable-list" }, Kg = /* @__PURE__ */ ke({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), j("div", Kf, [
      he(t.$slots, "default")
    ]));
  }
}), Jf = () => {
  const e = ge(!1);
  return St(() => {
    e.value = !0;
  }), Ln(() => {
    e.value = !1;
  }), e;
}, Qf = {
  key: 0,
  class: "lc-fly-out__illustration"
}, e0 = { class: "lc-fly-out__message" }, Jg = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => Ze.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => Ze.lcFlyOut.to },
    visibleInSeconds: { default: () => Ze.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = Jf(), o = W(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = na(
      () => {
        n("update:isVisible", !1);
      },
      o,
      { immediate: !1 }
    );
    return Ln(a), He(
      () => e.isVisible,
      (s) => {
        s ? i() : a();
      },
      { immediate: !0 }
    ), (s, l) => Z(r) ? ($(), we(pa, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Re(Z(ua), { name: "slide-down-lg" }, {
        default: _e(() => [
          e.isVisible ? ($(), j("div", Ce({ key: 0 }, s.$attrs, { class: "lc-fly-out__container" }), [
            Re(Z(Ru), {
              class: "lc-fly-out__timer",
              "duration-in-ms": o.value
            }, {
              default: _e(() => [
                Re(Z(Tt), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => s.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            s.$slots.default ? ($(), j("div", Qf, [
              he(s.$slots, "default")
            ])) : se("", !0),
            te("p", e0, Ie(e.message), 1)
          ], 16)) : se("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
});
const va = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function pl(e) {
  return Number(e) >= 0;
}
function t0(e) {
  return typeof e == "object" && e !== null;
}
function n0(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function yl(e) {
  if (!t0(e) || n0(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Go(e, t) {
  return Object.keys(t).forEach((n) => {
    if (yl(t[n]) && yl(e[n])) {
      e[n] || (e[n] = {}), Go(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function a0(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var o;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((o = a.inner) === null || o === void 0) && o.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const s = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(s) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return va(i) && va(r) ? Go(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return wl(e.spec);
        const o = r0(r, e);
        return o ? wl(o) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function wl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function r0(e, t) {
  if (!xl(t))
    return null;
  if (uc(e)) {
    const o = t.fields[dc(e)];
    return o?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let o = 0; o < n.length; o++) {
    const i = n[o];
    if (xl(r) && i in r.fields ? r = r.fields[i] : i0(r) && pl(i) ? r = r.spec.types[Number(i)] : pl(i) && l0(r) && (r = r.innerType), o === n.length - 1)
      return r.spec;
  }
  return null;
}
function i0(e) {
  return va(e) && e.type === "tuple";
}
function xl(e) {
  return va(e) && e.type === "object";
}
function l0(e) {
  return va(e) && e.type === "array";
}
const Qg = /* @__PURE__ */ ke({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    } = fc({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? a0(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        o.value = !0;
        const { valid: c, values: p } = await v();
        c && n.onSubmit && await n.onSubmit(p), c && n.resetOnSubmit && s();
      } finally {
        o.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    }), (m, c) => ($(), j("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      he(m.$slots, "default", Ot(Pt({ isSubmitting: Z(o), meta: Z(i), values: Z(u) })))
    ], 32));
  }
}), e2 = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Ko = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Ko || {});
const Bt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, o0 = { class: "lc-form-field" }, t2 = /* @__PURE__ */ ke({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Bt.Blur, Bt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Change],
      lazy: () => [Bt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: o,
      handleChange: i,
      meta: a,
      value: s
    } = hc(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Bt.Blur]: (f) => u(f, !0),
      [Bt.Change]: (f) => i(f, !0),
      [Bt.Update]: (f) => i(f, !0)
    }, h = W(() => ({
      errorMessage: r.value,
      name: e.name,
      value: s.value,
      ...v.value
    })), v = W(() => {
      const f = {
        [Bt.Blur]: (m) => u(m, !1),
        [Bt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), u = async (f, m) => {
      if (o(f, m), await Ga(), !f) return;
      const c = new CustomEvent(Ko.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => ($(), j("div", o0, [
      he(f.$slots, "default", Ot(Pt({ field: h.value })))
    ]));
  }
}), s0 = ["id"], c0 = { ref: "wrapper" }, u0 = { class: "lc-header__wrap" }, d0 = { class: "lc-header__left-button-wrap" }, f0 = { class: "lc-header__headline-wrap" }, h0 = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, v0 = ["id", "aria-labelledby"], m0 = { class: "lc-header__fly-out-content-container" }, n2 = /* @__PURE__ */ ke({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [Ze.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => Ze.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => Ze.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = ct("wrapper"), n = $t(e.id), r = ge(!1), o = W(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ja(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...nt(e.ignoreOutsideClickOn)] }
    ), (a, s) => ($(), j("header", {
      id: Z(n),
      class: pe(o.value)
    }, [
      te("div", c0, [
        te("div", u0, [
          te("div", d0, [
            Re(Z(Tt), Ce({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: s[0] || (s[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          te("div", f0, [
            te("h1", {
              class: pe(["lc-header__headline", e.headlineClass])
            }, [
              he(a.$slots, "headline")
            ], 2)
          ]),
          he(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), j("div", h0, [
              Re(Z(Tt), {
                id: `${Z(n)}-toggle`,
                "aria-controls": `${Z(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: pe(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: _e(() => [
                  he(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : se("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), j("div", {
          key: 0,
          id: `${Z(n)}-region`,
          "aria-labelledby": `${Z(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          te("div", m0, [
            te("div", {
              class: pe(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              he(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, v0)) : se("", !0)
      ], 512),
      he(a.$slots, "default")
    ], 10, s0));
  }
}), g0 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = W(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), j("div", {
      class: pe(t.value),
      style: Et({
        "--ball-opacity": e.opacity
      })
    }, Ie(e.content), 7));
  }
}), b0 = { class: "lc-high-frequency-ball-background" }, Jo = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", b0, [
      ($(!0), j(at, null, yt(e.ballConfig, (r, o) => ($(), we(g0, {
        key: o,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Et({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      te("div", {
        class: pe(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), p0 = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, y0 = { class: "lc-lottery-jackpot__value" }, w0 = { class: "lc-lottery-jackpot__currency" }, x0 = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, kl = 10 ** 9, Sl = 10 ** 6, k0 = "mil millones", S0 = "mil M", Qo = /* @__PURE__ */ ke({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => Ze.general.currency },
    locale: { default: () => Ze.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = kl * 100, n = Sl * 100, r = W(() => {
      let a;
      const s = e.value >= t, l = e.value >= n;
      switch (!0) {
        case s:
          a = Math.floor(e.value / kl) / 100;
          break;
        case l:
          a = Math.floor(e.value / Sl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = l || s;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(c));
    }), o = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = W(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === k0 ? S0 : a;
    });
    return (a, s) => ($(), j("div", {
      class: pe([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), j("span", p0, Ie(e.placeholder), 1)) : ($(), j(at, { key: 1 }, [
        te("span", y0, [
          te("span", w0, Ie(o.value), 1),
          te("span", null, Ie(r.value), 1)
        ]),
        i.value ? ($(), j("span", x0, Ie(i.value), 1)) : se("", !0)
      ], 64))
    ], 2));
  }
}), a2 = ["large", "medium", "small"], _0 = { class: "lc-info-button__modal" }, C0 = { class: "lc-info-button__modal-header" }, E0 = { class: "lc-info-button__modal-headline" }, T0 = { class: "lc-info-button__modal-text" }, es = /* @__PURE__ */ ke({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => Ze.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => Ze.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = er(), n = ge(!1), r = () => {
      n.value = !1;
    }, o = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), j("div", {
      class: pe(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Re(Z(Tt), Ce({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: o
      }), null, 16, ["aria-label"]),
      Z(t) && n.value ? ($(), we(Z(No), Ce({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: _e(() => [
          te("div", _0, [
            te("header", C0, [
              te("span", E0, Ie(e.headline), 1),
              Re(Z(Tt), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            he(i.$slots, "default", {}, () => [
              te("p", T0, Ie(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : se("", !0)
    ], 2));
  }
}), r2 = ["default", "prominent"], A0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", L0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", $0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", I0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", D0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, O0 = ["src"], M0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, R0 = ["src"], F0 = 8, rn = 10, N0 = 20, P0 = /* @__PURE__ */ ke({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = W(() => o.value.length > 1), r = W(() => {
      switch (e.variant) {
        case "fire":
          return A0;
        case "pie":
          return $0;
        case "star":
          return I0;
        default:
          return null;
      }
    }), o = W(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, N0);
      if (i.length <= F0) return [i];
      const s = i.split(" ").filter(Boolean);
      if (s.length === 1)
        return [
          i.slice(0, rn),
          i.slice(rn)
        ];
      let l = "";
      const h = [];
      return s.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= rn) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > rn) {
          if (l.length > 0) {
            let u = 0;
            l.length < rn && (l += " ", u = rn - l.length, l += v.slice(0, u)), h.push(l), h.push(v.slice(u)), l = "";
            return;
          }
          h.push(v.slice(0, rn)), l = v.slice(rn);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), j("div", {
      class: pe(t.value)
    }, [
      e.variant === "price-tag" ? ($(), j("svg", D0, [...a[0] || (a[0] = [
        te("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : se("", !0),
      r.value ? ($(), j("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, O0)) : se("", !0),
      e.variant !== "new" ? ($(), j("span", M0, Ie(o.value.join(`
`)), 1)) : ($(), j("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: Z(L0),
        width: "48"
      }, null, 8, R0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), we(Z(es), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${Z(Ze).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 2));
  }
}), i2 = ["fire", "lightning", "money", "star"], l2 = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], o2 = ["bottom-m", "bottom-xl", "top-m", "top-xl"], ts = ["badge", "default", "hero"];
var ns = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(ns || {});
const B0 = { class: "lc-teaser-hero-badge__text-wrap" }, z0 = /* @__PURE__ */ ke({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => ns.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      class: pe(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Et({
        "--teaser-badge-color": e.color
      })
    }, [
      te("div", B0, [
        te("span", null, Ie(e.title), 1),
        te("span", null, Ie(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), we(Z(es), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${Z(Ze).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 6));
  }
}), V0 = (e) => !!e.title && !!e.subtitle, H0 = { class: "lc-teaser__background" }, ir = /* @__PURE__ */ ke({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = cn(), n = W(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, o) => ($(), we(Z(wa), Ce({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Ka({
      default: _e(() => [
        he(r.$slots, "default"),
        e.badge ? ($(), j(at, { key: 0 }, [
          Z(V0)(e.badge) ? ($(), we(z0, Ot(Ce({ key: 0 }, e.badge)), null, 16)) : ($(), we(P0, Ot(Ce({ key: 1 }, e.badge)), null, 16))
        ], 64)) : se("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: _e(() => [
          te("div", H0, [
            he(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: _e(() => [
          he(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: _e(() => [
          he(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), U0 = { class: "lc-high-frequency-teaser__background" }, q0 = { class: "lc-high-frequency-teaser__jackpot-section" }, j0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, Z0 = { class: "lc-high-frequency-teaser__button-container" }, W0 = { class: "lc-high-frequency-teaser__button-wrap" }, X0 = { class: "lc-high-frequency-teaser__hint-container" }, Y0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, s2 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    cn();
    const t = W(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (r, o) => ($(), we(Z(ir), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: _e(() => [
        te("div", U0, [
          Re(Z(Jo), Ot(Pt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: _e(() => [
        he(r.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        te("section", q0, [
          ($(), we(Ft(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), j("strong", j0, Ie(e.headline), 1)) : se("", !0),
              Re(Z(Qo), Ce(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        te("section", Z0, [
          te("div", W0, [
            he(r.$slots, "primary-button", {}, () => [
              Re(Z(Tt), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: o[0] || (o[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        te("section", X0, [
          e.hint ? ($(), j("p", Y0, [
            he(r.$slots, "hint", {}, () => [
              kt(Ie(e.hint), 1)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), G0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, K0 = ["stroke"], J0 = ["stroke"], _l = "lc-high-frequency-teaser-watch-arrows-gradient-1", Cl = "lc-high-frequency-teaser-watch-arrows-gradient-2", Q0 = /* @__PURE__ */ ke({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", G0, [
      te("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${_l})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, K0),
      n[2] || (n[2] = te("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      te("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${Cl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, J0),
      n[3] || (n[3] = te("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      te("defs", null, [
        te("linearGradient", {
          id: _l,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          te("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          te("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        te("linearGradient", {
          id: Cl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          te("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          te("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), eh = {}, th = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function nh(e, t) {
  return $(), j("svg", th, [...t[0] || (t[0] = [
    Zs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const ah = /* @__PURE__ */ vi(eh, [["render", nh], ["__scopeId", "data-v-0c679bcf"]]), rh = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, ih = ["fill"], El = "lc-high-frequency-teaser-watch-play-button-gradient", lh = /* @__PURE__ */ ke({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", rh, [
      n[1] || (n[1] = te("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      te("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${El})`
      }, null, 8, ih),
      te("defs", null, [
        te("radialGradient", {
          id: El,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          te("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          te("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ta = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, oh = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, sh = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, ch = { class: "lc-high-frequency-teaser-watch__game-badge" }, uh = { class: "lc-high-frequency-teaser-watch__game-label" }, dh = { class: "lc-high-frequency-teaser-watch__game-number" }, fh = { class: "lc-high-frequency-teaser-watch__game-icon" }, hh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, vh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, mh = { class: "lc-high-frequency-teaser-watch__timer-value" }, gh = { class: "lc-high-frequency-teaser-watch__timer-unit" }, bh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, ph = { class: "lc-high-frequency-teaser-watch__main" }, yh = { class: "lc-high-frequency-teaser-watch__title" }, c2 = /* @__PURE__ */ ke({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = ge("idle"), n = ge(e.gameNumber), r = ge(!1), o = ge(0), i = W(() => e.to ? Yn(e.to) : "div"), a = W(() => String(n.value).split("")), s = W(() => t.value === "spinning"), l = W(() => t.value === "idle" || s.value), h = W(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": s.value
    })), v = W(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": s.value
    })), u = W(() => ({
      "lc-high-frequency-teaser-watch__arrows--idle-spin": o.value > 0 && t.value === "idle",
      "lc-high-frequency-teaser-watch__arrows--spinning": s.value
    })), f = W(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = xo(
      () => {
        t.value === "idle" && e.isOperational && o.value++;
      },
      ta.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: x } = na(
      () => {
        t.value = "spinning";
      },
      ta.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = na(
      () => t.value = "paused",
      ta.PAUSE_DELAY,
      { immediate: !1 }
    ), _ = ge(e.gameNumber), { start: E, stop: I } = na(
      () => {
        t.value = "label", n.value = _.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ta.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: A } = na(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      ta.IDLE_DELAY,
      { immediate: !1 }
    ), B = () => {
      x(), b(), I(), A();
    };
    return He(
      () => e.isOperational,
      (H) => {
        H ? c() : (B(), m(), t.value = "idle", r.value = !1);
      }
    ), He(
      () => e.gameNumber,
      (H, re) => {
        if (H === re || !e.isOperational) {
          n.value = H;
          return;
        }
        B(), m(), _.value = H, t.value = "idle", p(), g(), E(), L();
      }
    ), (H, re) => ($(), we(Ft(i.value), Ot(Pt({ to: e.to })), {
      default: _e(() => [
        Re(Z(ir), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: _e(() => [
            te("div", oh, [
              Re(Z(Jo), Ce({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: _e(() => [
            te("div", sh, [
              te("div", ch, [
                te("span", uh, Ie(e.gameLabel), 1),
                te("span", dh, [
                  ($(!0), j(at, null, yt(a.value, (O, X) => ($(), j("span", {
                    key: `pos-${X}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Re(Ws, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: _e(() => [
                        ($(), j("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Et({ transitionDelay: `${X * 35}ms` })
                        }, Ie(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              te("div", fh, [
                Re(xn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: _e(() => [
                    e.isOperational ? se("", !0) : ($(), j("div", hh, [
                      Re(ah)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), j("div", vh, [
                  Re(xn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: _e(() => [
                      l.value ? ($(), j("div", {
                        key: 0,
                        class: pe(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        te("span", {
                          class: pe(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          te("span", mh, Ie(e.timerValueLabel), 1),
                          te("span", gh, Ie(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), j("div", {
                          key: `arrows-${o.value}`,
                          class: pe(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Re(Q0)
                        ], 2))
                      ], 2)) : se("", !0)
                    ]),
                    _: 1
                  }),
                  Re(xn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: _e(() => [
                      t.value === "label" ? ($(), j("div", bh, [
                        he(H.$slots, "new-game-label")
                      ])) : se("", !0)
                    ]),
                    _: 3
                  })
                ])) : se("", !0)
              ])
            ])
          ]),
          footer: _e(() => [
            he(H.$slots, "message")
          ]),
          default: _e(() => [
            te("div", ph, [
              te("div", {
                class: pe(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Re(lh)
              ], 2),
              te("span", yh, Ie(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Bn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", wh = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Da = 0; Da < Bn.length; Da++)
  wh[Bn.charCodeAt(Da)] = Da;
var xh = function(e) {
  var t = new Uint8Array(e), n, r = t.length, o = "";
  for (n = 0; n < r; n += 3)
    o += Bn[t[n] >> 2], o += Bn[(t[n] & 3) << 4 | t[n + 1] >> 4], o += Bn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], o += Bn[t[n + 2] & 63];
  return r % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : r % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, kh = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], ra = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], o = kh.indexOf(r);
    t = t * 83 + o;
  }
  return t;
}, Er = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, Tr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, Sh = (e) => e < 0 ? -1 : 1, Ar = (e, t) => Sh(e) * Math.pow(Math.abs(e), t), Tl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, _h = (e) => {
  if (!e || e.length < 6) throw new Tl("The blurhash string must be at least 6 characters");
  let t = ra(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new Tl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, Ch = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [Er(t), Er(n), Er(r)];
}, Eh = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, o = e % 19;
  return [Ar((n - 9) / 9, 2) * t, Ar((r - 9) / 9, 2) * t, Ar((o - 9) / 9, 2) * t];
}, Th = (e, t, n, r) => {
  _h(e), r = r | 1;
  let o = ra(e[0]), i = Math.floor(o / 9) + 1, a = o % 9 + 1, s = (ra(e[1]) + 1) / 166, l = new Array(a * i);
  for (let u = 0; u < l.length; u++) if (u === 0) {
    let f = ra(e.substring(2, 6));
    l[u] = Ch(f);
  } else {
    let f = ra(e.substring(4 + u * 2, 6 + u * 2));
    l[u] = Eh(f, s * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let u = 0; u < n; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, p = 0;
    for (let _ = 0; _ < i; _++) for (let E = 0; E < a; E++) {
      let I = Math.cos(Math.PI * f * E / t) * Math.cos(Math.PI * u * _ / n), L = l[E + _ * a];
      m += L[0] * I, c += L[1] * I, p += L[2] * I;
    }
    let x = Tr(m), g = Tr(c), b = Tr(p);
    v[4 * f + 0 + u * h] = x, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, Ah = Th;
function Lh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $h(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Lr = { exports: {} }, $r = {}, Al;
function dn() {
  return Al || (Al = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var s = a.shift();
        if (s) {
          if (typeof s != "object")
            throw new TypeError(s + "must be non-object");
          for (var l in s)
            n(s, l) && (i[l] = s[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, s, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(s, s + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, s, l, h, v, u;
        for (l = 0, a = 0, s = i.length; a < s; a++)
          l += i[a].length;
        for (u = new Uint8Array(l), h = 0, a = 0, s = i.length; a < s; a++)
          v = i[a], u.set(v, h), h += v.length;
        return u;
      }
    }, o = {
      arraySet: function(i, a, s, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, o));
    }, e.setTyped(t);
  })($r)), $r;
}
var Rn = {}, Ht = {}, gn = {}, Ll;
function Ih() {
  if (Ll) return gn;
  Ll = 1;
  var e = dn(), t = 4, n = 0, r = 1, o = 2;
  function i(w) {
    for (var K = w.length; --K >= 0; )
      w[K] = 0;
  }
  var a = 0, s = 1, l = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, p = 19, x = 2 * m + 1, g = 15, b = 16, _ = 7, E = 256, I = 16, L = 17, A = 18, B = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), H = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), re = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], X = 512, z = new Array((m + 2) * 2);
  i(z);
  var C = new Array(c * 2);
  i(C);
  var T = new Array(X);
  i(T);
  var F = new Array(v - h + 1);
  i(F);
  var V = new Array(u);
  i(V);
  var q = new Array(c);
  i(q);
  function Y(w, K, M, ie, D) {
    this.static_tree = w, this.extra_bits = K, this.extra_base = M, this.elems = ie, this.max_length = D, this.has_stree = w && w.length;
  }
  var U, oe, ae;
  function fe(w, K) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = K;
  }
  function be(w) {
    return w < 256 ? T[w] : T[256 + (w >>> 7)];
  }
  function Se(w, K) {
    w.pending_buf[w.pending++] = K & 255, w.pending_buf[w.pending++] = K >>> 8 & 255;
  }
  function de(w, K, M) {
    w.bi_valid > b - M ? (w.bi_buf |= K << w.bi_valid & 65535, Se(w, w.bi_buf), w.bi_buf = K >> b - w.bi_valid, w.bi_valid += M - b) : (w.bi_buf |= K << w.bi_valid & 65535, w.bi_valid += M);
  }
  function ye(w, K, M) {
    de(
      w,
      M[K * 2],
      M[K * 2 + 1]
      /*.Len*/
    );
  }
  function Ae(w, K) {
    var M = 0;
    do
      M |= w & 1, w >>>= 1, M <<= 1;
    while (--K > 0);
    return M >>> 1;
  }
  function Oe(w) {
    w.bi_valid === 16 ? (Se(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function We(w, K) {
    var M = K.dyn_tree, ie = K.max_code, D = K.stat_desc.static_tree, J = K.stat_desc.has_stree, y = K.stat_desc.extra_bits, ce = K.stat_desc.extra_base, Te = K.stat_desc.max_length, d, ne, ee, k, N, Q, $e = 0;
    for (k = 0; k <= g; k++)
      w.bl_count[k] = 0;
    for (M[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < x; d++)
      ne = w.heap[d], k = M[M[ne * 2 + 1] * 2 + 1] + 1, k > Te && (k = Te, $e++), M[ne * 2 + 1] = k, !(ne > ie) && (w.bl_count[k]++, N = 0, ne >= ce && (N = y[ne - ce]), Q = M[ne * 2], w.opt_len += Q * (k + N), J && (w.static_len += Q * (D[ne * 2 + 1] + N)));
    if ($e !== 0) {
      do {
        for (k = Te - 1; w.bl_count[k] === 0; )
          k--;
        w.bl_count[k]--, w.bl_count[k + 1] += 2, w.bl_count[Te]--, $e -= 2;
      } while ($e > 0);
      for (k = Te; k !== 0; k--)
        for (ne = w.bl_count[k]; ne !== 0; )
          ee = w.heap[--d], !(ee > ie) && (M[ee * 2 + 1] !== k && (w.opt_len += (k - M[ee * 2 + 1]) * M[ee * 2], M[ee * 2 + 1] = k), ne--);
    }
  }
  function Ne(w, K, M) {
    var ie = new Array(g + 1), D = 0, J, y;
    for (J = 1; J <= g; J++)
      ie[J] = D = D + M[J - 1] << 1;
    for (y = 0; y <= K; y++) {
      var ce = w[y * 2 + 1];
      ce !== 0 && (w[y * 2] = Ae(ie[ce]++, ce));
    }
  }
  function ue() {
    var w, K, M, ie, D, J = new Array(g + 1);
    for (M = 0, ie = 0; ie < u - 1; ie++)
      for (V[ie] = M, w = 0; w < 1 << B[ie]; w++)
        F[M++] = ie;
    for (F[M - 1] = ie, D = 0, ie = 0; ie < 16; ie++)
      for (q[ie] = D, w = 0; w < 1 << H[ie]; w++)
        T[D++] = ie;
    for (D >>= 7; ie < c; ie++)
      for (q[ie] = D << 7, w = 0; w < 1 << H[ie] - 7; w++)
        T[256 + D++] = ie;
    for (K = 0; K <= g; K++)
      J[K] = 0;
    for (w = 0; w <= 143; )
      z[w * 2 + 1] = 8, w++, J[8]++;
    for (; w <= 255; )
      z[w * 2 + 1] = 9, w++, J[9]++;
    for (; w <= 279; )
      z[w * 2 + 1] = 7, w++, J[7]++;
    for (; w <= 287; )
      z[w * 2 + 1] = 8, w++, J[8]++;
    for (Ne(z, m + 1, J), w = 0; w < c; w++)
      C[w * 2 + 1] = 5, C[w * 2] = Ae(w, 5);
    U = new Y(z, B, f + 1, m, g), oe = new Y(C, H, 0, c, g), ae = new Y(new Array(0), re, 0, p, _);
  }
  function Fe(w) {
    var K;
    for (K = 0; K < m; K++)
      w.dyn_ltree[K * 2] = 0;
    for (K = 0; K < c; K++)
      w.dyn_dtree[K * 2] = 0;
    for (K = 0; K < p; K++)
      w.bl_tree[K * 2] = 0;
    w.dyn_ltree[E * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function qe(w) {
    w.bi_valid > 8 ? Se(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function je(w, K, M, ie) {
    qe(w), Se(w, M), Se(w, ~M), e.arraySet(w.pending_buf, w.window, K, M, w.pending), w.pending += M;
  }
  function Xe(w, K, M, ie) {
    var D = K * 2, J = M * 2;
    return w[D] < w[J] || w[D] === w[J] && ie[K] <= ie[M];
  }
  function Ve(w, K, M) {
    for (var ie = w.heap[M], D = M << 1; D <= w.heap_len && (D < w.heap_len && Xe(K, w.heap[D + 1], w.heap[D], w.depth) && D++, !Xe(K, ie, w.heap[D], w.depth)); )
      w.heap[M] = w.heap[D], M = D, D <<= 1;
    w.heap[M] = ie;
  }
  function Pe(w, K, M) {
    var ie, D, J = 0, y, ce;
    if (w.last_lit !== 0)
      do
        ie = w.pending_buf[w.d_buf + J * 2] << 8 | w.pending_buf[w.d_buf + J * 2 + 1], D = w.pending_buf[w.l_buf + J], J++, ie === 0 ? ye(w, D, K) : (y = F[D], ye(w, y + f + 1, K), ce = B[y], ce !== 0 && (D -= V[y], de(w, D, ce)), ie--, y = be(ie), ye(w, y, M), ce = H[y], ce !== 0 && (ie -= q[y], de(w, ie, ce)));
      while (J < w.last_lit);
    ye(w, E, K);
  }
  function rt(w, K) {
    var M = K.dyn_tree, ie = K.stat_desc.static_tree, D = K.stat_desc.has_stree, J = K.stat_desc.elems, y, ce, Te = -1, d;
    for (w.heap_len = 0, w.heap_max = x, y = 0; y < J; y++)
      M[y * 2] !== 0 ? (w.heap[++w.heap_len] = Te = y, w.depth[y] = 0) : M[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = Te < 2 ? ++Te : 0, M[d * 2] = 1, w.depth[d] = 0, w.opt_len--, D && (w.static_len -= ie[d * 2 + 1]);
    for (K.max_code = Te, y = w.heap_len >> 1; y >= 1; y--)
      Ve(w, M, y);
    d = J;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], Ve(
        w,
        M,
        1
        /*SMALLEST*/
      ), ce = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = ce, M[d * 2] = M[y * 2] + M[ce * 2], w.depth[d] = (w.depth[y] >= w.depth[ce] ? w.depth[y] : w.depth[ce]) + 1, M[y * 2 + 1] = M[ce * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, Ve(
        w,
        M,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], We(w, K), Ne(M, Te, w.bl_count);
  }
  function ut(w, K, M) {
    var ie, D = -1, J, y = K[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), K[(M + 1) * 2 + 1] = 65535, ie = 0; ie <= M; ie++)
      J = y, y = K[(ie + 1) * 2 + 1], !(++ce < Te && J === y) && (ce < d ? w.bl_tree[J * 2] += ce : J !== 0 ? (J !== D && w.bl_tree[J * 2]++, w.bl_tree[I * 2]++) : ce <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[A * 2]++, ce = 0, D = J, y === 0 ? (Te = 138, d = 3) : J === y ? (Te = 6, d = 3) : (Te = 7, d = 4));
  }
  function me(w, K, M) {
    var ie, D = -1, J, y = K[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), ie = 0; ie <= M; ie++)
      if (J = y, y = K[(ie + 1) * 2 + 1], !(++ce < Te && J === y)) {
        if (ce < d)
          do
            ye(w, J, w.bl_tree);
          while (--ce !== 0);
        else J !== 0 ? (J !== D && (ye(w, J, w.bl_tree), ce--), ye(w, I, w.bl_tree), de(w, ce - 3, 2)) : ce <= 10 ? (ye(w, L, w.bl_tree), de(w, ce - 3, 3)) : (ye(w, A, w.bl_tree), de(w, ce - 11, 7));
        ce = 0, D = J, y === 0 ? (Te = 138, d = 3) : J === y ? (Te = 6, d = 3) : (Te = 7, d = 4);
      }
  }
  function Be(w) {
    var K;
    for (ut(w, w.dyn_ltree, w.l_desc.max_code), ut(w, w.dyn_dtree, w.d_desc.max_code), rt(w, w.bl_desc), K = p - 1; K >= 3 && w.bl_tree[O[K] * 2 + 1] === 0; K--)
      ;
    return w.opt_len += 3 * (K + 1) + 5 + 5 + 4, K;
  }
  function ze(w, K, M, ie) {
    var D;
    for (de(w, K - 257, 5), de(w, M - 1, 5), de(w, ie - 4, 4), D = 0; D < ie; D++)
      de(w, w.bl_tree[O[D] * 2 + 1], 3);
    me(w, w.dyn_ltree, K - 1), me(w, w.dyn_dtree, M - 1);
  }
  function Ke(w) {
    var K = 4093624447, M;
    for (M = 0; M <= 31; M++, K >>>= 1)
      if (K & 1 && w.dyn_ltree[M * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (M = 32; M < f; M++)
      if (w.dyn_ltree[M * 2] !== 0)
        return r;
    return n;
  }
  var Qe = !1;
  function ht(w) {
    Qe || (ue(), Qe = !0), w.l_desc = new fe(w.dyn_ltree, U), w.d_desc = new fe(w.dyn_dtree, oe), w.bl_desc = new fe(w.bl_tree, ae), w.bi_buf = 0, w.bi_valid = 0, Fe(w);
  }
  function vt(w, K, M, ie) {
    de(w, (a << 1) + (ie ? 1 : 0), 3), je(w, K, M);
  }
  function et(w) {
    de(w, s << 1, 3), ye(w, E, z), Oe(w);
  }
  function R(w, K, M, ie) {
    var D, J, y = 0;
    w.level > 0 ? (w.strm.data_type === o && (w.strm.data_type = Ke(w)), rt(w, w.l_desc), rt(w, w.d_desc), y = Be(w), D = w.opt_len + 3 + 7 >>> 3, J = w.static_len + 3 + 7 >>> 3, J <= D && (D = J)) : D = J = M + 5, M + 4 <= D && K !== -1 ? vt(w, K, M, ie) : w.strategy === t || J === D ? (de(w, (s << 1) + (ie ? 1 : 0), 3), Pe(w, z, C)) : (de(w, (l << 1) + (ie ? 1 : 0), 3), ze(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Pe(w, w.dyn_ltree, w.dyn_dtree)), Fe(w), ie && qe(w);
  }
  function S(w, K, M) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = K >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = K & 255, w.pending_buf[w.l_buf + w.last_lit] = M & 255, w.last_lit++, K === 0 ? w.dyn_ltree[M * 2]++ : (w.matches++, K--, w.dyn_ltree[(F[M] + f + 1) * 2]++, w.dyn_dtree[be(K) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return gn._tr_init = ht, gn._tr_stored_block = vt, gn._tr_flush_block = R, gn._tr_tally = S, gn._tr_align = et, gn;
}
var Ir, $l;
function as() {
  if ($l) return Ir;
  $l = 1;
  function e(t, n, r, o) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, s = 0; r !== 0; ) {
      s = r > 2e3 ? 2e3 : r, r -= s;
      do
        i = i + n[o++] | 0, a = a + i | 0;
      while (--s);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Ir = e, Ir;
}
var Dr, Il;
function rs() {
  if (Il) return Dr;
  Il = 1;
  function e() {
    for (var r, o = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      o[i] = r;
    }
    return o;
  }
  var t = e();
  function n(r, o, i, a) {
    var s = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ s[(r ^ o[h]) & 255];
    return r ^ -1;
  }
  return Dr = n, Dr;
}
var Or, Dl;
function wi() {
  return Dl || (Dl = 1, Or = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Or;
}
var Ol;
function Dh() {
  if (Ol) return Ht;
  Ol = 1;
  var e = dn(), t = Ih(), n = as(), r = rs(), o = wi(), i = 0, a = 1, s = 3, l = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, p = -1, x = 1, g = 2, b = 3, _ = 4, E = 0, I = 2, L = 8, A = 9, B = 15, H = 8, re = 29, O = 256, X = O + 1 + re, z = 30, C = 19, T = 2 * X + 1, F = 15, V = 3, q = 258, Y = q + V + 1, U = 32, oe = 42, ae = 69, fe = 73, be = 91, Se = 103, de = 113, ye = 666, Ae = 1, Oe = 2, We = 3, Ne = 4, ue = 3;
  function Fe(d, ne) {
    return d.msg = o[ne], ne;
  }
  function qe(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function je(d) {
    for (var ne = d.length; --ne >= 0; )
      d[ne] = 0;
  }
  function Xe(d) {
    var ne = d.state, ee = ne.pending;
    ee > d.avail_out && (ee = d.avail_out), ee !== 0 && (e.arraySet(d.output, ne.pending_buf, ne.pending_out, ee, d.next_out), d.next_out += ee, ne.pending_out += ee, d.total_out += ee, d.avail_out -= ee, ne.pending -= ee, ne.pending === 0 && (ne.pending_out = 0));
  }
  function Ve(d, ne) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, ne), d.block_start = d.strstart, Xe(d.strm);
  }
  function Pe(d, ne) {
    d.pending_buf[d.pending++] = ne;
  }
  function rt(d, ne) {
    d.pending_buf[d.pending++] = ne >>> 8 & 255, d.pending_buf[d.pending++] = ne & 255;
  }
  function ut(d, ne, ee, k) {
    var N = d.avail_in;
    return N > k && (N = k), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(ne, d.input, d.next_in, N, ee), d.state.wrap === 1 ? d.adler = n(d.adler, ne, N, ee) : d.state.wrap === 2 && (d.adler = r(d.adler, ne, N, ee)), d.next_in += N, d.total_in += N, N);
  }
  function me(d, ne) {
    var ee = d.max_chain_length, k = d.strstart, N, Q, $e = d.prev_length, xe = d.nice_match, Le = d.strstart > d.w_size - Y ? d.strstart - (d.w_size - Y) : 0, Ye = d.window, wt = d.w_mask, lt = d.prev, Ge = d.strstart + q, mt = Ye[k + $e - 1], _t = Ye[k + $e];
    d.prev_length >= d.good_match && (ee >>= 2), xe > d.lookahead && (xe = d.lookahead);
    do
      if (N = ne, !(Ye[N + $e] !== _t || Ye[N + $e - 1] !== mt || Ye[N] !== Ye[k] || Ye[++N] !== Ye[k + 1])) {
        k += 2, N++;
        do
          ;
        while (Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && Ye[++k] === Ye[++N] && k < Ge);
        if (Q = q - (Ge - k), k = Ge - q, Q > $e) {
          if (d.match_start = ne, $e = Q, Q >= xe)
            break;
          mt = Ye[k + $e - 1], _t = Ye[k + $e];
        }
      }
    while ((ne = lt[ne & wt]) > Le && --ee !== 0);
    return $e <= d.lookahead ? $e : d.lookahead;
  }
  function Be(d) {
    var ne = d.w_size, ee, k, N, Q, $e;
    do {
      if (Q = d.window_size - d.lookahead - d.strstart, d.strstart >= ne + (ne - Y)) {
        e.arraySet(d.window, d.window, ne, ne, 0), d.match_start -= ne, d.strstart -= ne, d.block_start -= ne, k = d.hash_size, ee = k;
        do
          N = d.head[--ee], d.head[ee] = N >= ne ? N - ne : 0;
        while (--k);
        k = ne, ee = k;
        do
          N = d.prev[--ee], d.prev[ee] = N >= ne ? N - ne : 0;
        while (--k);
        Q += ne;
      }
      if (d.strm.avail_in === 0)
        break;
      if (k = ut(d.strm, d.window, d.strstart + d.lookahead, Q), d.lookahead += k, d.lookahead + d.insert >= V)
        for ($e = d.strstart - d.insert, d.ins_h = d.window[$e], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + V - 1]) & d.hash_mask, d.prev[$e & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = $e, $e++, d.insert--, !(d.lookahead + d.insert < V)); )
          ;
    } while (d.lookahead < Y && d.strm.avail_in !== 0);
  }
  function ze(d, ne) {
    var ee = 65535;
    for (ee > d.pending_buf_size - 5 && (ee = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (Be(d), d.lookahead === 0 && ne === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var k = d.block_start + ee;
      if ((d.strstart === 0 || d.strstart >= k) && (d.lookahead = d.strstart - k, d.strstart = k, Ve(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - Y && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ne === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : (d.strstart > d.block_start && (Ve(d, !1), d.strm.avail_out === 0), Ae);
  }
  function Ke(d, ne) {
    for (var ee, k; ; ) {
      if (d.lookahead < Y) {
        if (Be(d), d.lookahead < Y && ne === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (ee = 0, d.lookahead >= V && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, ee = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), ee !== 0 && d.strstart - ee <= d.w_size - Y && (d.match_length = me(d, ee)), d.match_length >= V)
        if (k = t._tr_tally(d, d.strstart - d.match_start, d.match_length - V), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= V) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, ee = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        k = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (k && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = d.strstart < V - 1 ? d.strstart : V - 1, ne === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function Qe(d, ne) {
    for (var ee, k, N; ; ) {
      if (d.lookahead < Y) {
        if (Be(d), d.lookahead < Y && ne === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (ee = 0, d.lookahead >= V && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, ee = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = V - 1, ee !== 0 && d.prev_length < d.max_lazy_match && d.strstart - ee <= d.w_size - Y && (d.match_length = me(d, ee), d.match_length <= 5 && (d.strategy === x || d.match_length === V && d.strstart - d.match_start > 4096) && (d.match_length = V - 1)), d.prev_length >= V && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - V, k = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - V), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + V - 1]) & d.hash_mask, ee = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = V - 1, d.strstart++, k && (Ve(d, !1), d.strm.avail_out === 0))
          return Ae;
      } else if (d.match_available) {
        if (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), k && Ve(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return Ae;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < V - 1 ? d.strstart : V - 1, ne === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function ht(d, ne) {
    for (var ee, k, N, Q, $e = d.window; ; ) {
      if (d.lookahead <= q) {
        if (Be(d), d.lookahead <= q && ne === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= V && d.strstart > 0 && (N = d.strstart - 1, k = $e[N], k === $e[++N] && k === $e[++N] && k === $e[++N])) {
        Q = d.strstart + q;
        do
          ;
        while (k === $e[++N] && k === $e[++N] && k === $e[++N] && k === $e[++N] && k === $e[++N] && k === $e[++N] && k === $e[++N] && k === $e[++N] && N < Q);
        d.match_length = q - (Q - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= V ? (ee = t._tr_tally(d, 1, d.match_length - V), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (ee = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), ee && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ne === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function vt(d, ne) {
    for (var ee; ; ) {
      if (d.lookahead === 0 && (Be(d), d.lookahead === 0)) {
        if (ne === i)
          return Ae;
        break;
      }
      if (d.match_length = 0, ee = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, ee && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ne === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Ne) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function et(d, ne, ee, k, N) {
    this.good_length = d, this.max_lazy = ne, this.nice_length = ee, this.max_chain = k, this.func = N;
  }
  var R;
  R = [
    /*      good lazy nice chain */
    new et(0, 0, 0, 0, ze),
    /* 0 store only */
    new et(4, 4, 8, 4, Ke),
    /* 1 max speed, no lazy matches */
    new et(4, 5, 16, 8, Ke),
    /* 2 */
    new et(4, 6, 32, 32, Ke),
    /* 3 */
    new et(4, 4, 16, 16, Qe),
    /* 4 lazy matches */
    new et(8, 16, 32, 32, Qe),
    /* 5 */
    new et(8, 16, 128, 128, Qe),
    /* 6 */
    new et(8, 32, 128, 256, Qe),
    /* 7 */
    new et(32, 128, 258, 1024, Qe),
    /* 8 */
    new et(32, 258, 258, 4096, Qe)
    /* 9 max compression */
  ];
  function S(d) {
    d.window_size = 2 * d.w_size, je(d.head), d.max_lazy_match = R[d.level].max_lazy, d.good_match = R[d.level].good_length, d.nice_match = R[d.level].nice_length, d.max_chain_length = R[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = V - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(T * 2), this.dyn_dtree = new e.Buf16((2 * z + 1) * 2), this.bl_tree = new e.Buf16((2 * C + 1) * 2), je(this.dyn_ltree), je(this.dyn_dtree), je(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(F + 1), this.heap = new e.Buf16(2 * X + 1), je(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * X + 1), je(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function K(d) {
    var ne;
    return !d || !d.state ? Fe(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, ne = d.state, ne.pending = 0, ne.pending_out = 0, ne.wrap < 0 && (ne.wrap = -ne.wrap), ne.status = ne.wrap ? oe : de, d.adler = ne.wrap === 2 ? 0 : 1, ne.last_flush = i, t._tr_init(ne), v);
  }
  function M(d) {
    var ne = K(d);
    return ne === v && S(d.state), ne;
  }
  function ie(d, ne) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = ne, v);
  }
  function D(d, ne, ee, k, N, Q) {
    if (!d)
      return f;
    var $e = 1;
    if (ne === p && (ne = 6), k < 0 ? ($e = 0, k = -k) : k > 15 && ($e = 2, k -= 16), N < 1 || N > A || ee !== L || k < 8 || k > 15 || ne < 0 || ne > 9 || Q < 0 || Q > _)
      return Fe(d, f);
    k === 8 && (k = 9);
    var xe = new w();
    return d.state = xe, xe.strm = d, xe.wrap = $e, xe.gzhead = null, xe.w_bits = k, xe.w_size = 1 << xe.w_bits, xe.w_mask = xe.w_size - 1, xe.hash_bits = N + 7, xe.hash_size = 1 << xe.hash_bits, xe.hash_mask = xe.hash_size - 1, xe.hash_shift = ~~((xe.hash_bits + V - 1) / V), xe.window = new e.Buf8(xe.w_size * 2), xe.head = new e.Buf16(xe.hash_size), xe.prev = new e.Buf16(xe.w_size), xe.lit_bufsize = 1 << N + 6, xe.pending_buf_size = xe.lit_bufsize * 4, xe.pending_buf = new e.Buf8(xe.pending_buf_size), xe.d_buf = 1 * xe.lit_bufsize, xe.l_buf = 3 * xe.lit_bufsize, xe.level = ne, xe.strategy = Q, xe.method = ee, M(d);
  }
  function J(d, ne) {
    return D(d, ne, L, B, H, E);
  }
  function y(d, ne) {
    var ee, k, N, Q;
    if (!d || !d.state || ne > h || ne < 0)
      return d ? Fe(d, f) : f;
    if (k = d.state, !d.output || !d.input && d.avail_in !== 0 || k.status === ye && ne !== l)
      return Fe(d, d.avail_out === 0 ? c : f);
    if (k.strm = d, ee = k.last_flush, k.last_flush = ne, k.status === oe)
      if (k.wrap === 2)
        d.adler = 0, Pe(k, 31), Pe(k, 139), Pe(k, 8), k.gzhead ? (Pe(
          k,
          (k.gzhead.text ? 1 : 0) + (k.gzhead.hcrc ? 2 : 0) + (k.gzhead.extra ? 4 : 0) + (k.gzhead.name ? 8 : 0) + (k.gzhead.comment ? 16 : 0)
        ), Pe(k, k.gzhead.time & 255), Pe(k, k.gzhead.time >> 8 & 255), Pe(k, k.gzhead.time >> 16 & 255), Pe(k, k.gzhead.time >> 24 & 255), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, k.gzhead.os & 255), k.gzhead.extra && k.gzhead.extra.length && (Pe(k, k.gzhead.extra.length & 255), Pe(k, k.gzhead.extra.length >> 8 & 255)), k.gzhead.hcrc && (d.adler = r(d.adler, k.pending_buf, k.pending, 0)), k.gzindex = 0, k.status = ae) : (Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, ue), k.status = de);
      else {
        var $e = L + (k.w_bits - 8 << 4) << 8, xe = -1;
        k.strategy >= g || k.level < 2 ? xe = 0 : k.level < 6 ? xe = 1 : k.level === 6 ? xe = 2 : xe = 3, $e |= xe << 6, k.strstart !== 0 && ($e |= U), $e += 31 - $e % 31, k.status = de, rt(k, $e), k.strstart !== 0 && (rt(k, d.adler >>> 16), rt(k, d.adler & 65535)), d.adler = 1;
      }
    if (k.status === ae)
      if (k.gzhead.extra) {
        for (N = k.pending; k.gzindex < (k.gzhead.extra.length & 65535) && !(k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), Xe(d), N = k.pending, k.pending === k.pending_buf_size)); )
          Pe(k, k.gzhead.extra[k.gzindex] & 255), k.gzindex++;
        k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), k.gzindex === k.gzhead.extra.length && (k.gzindex = 0, k.status = fe);
      } else
        k.status = fe;
    if (k.status === fe)
      if (k.gzhead.name) {
        N = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), Xe(d), N = k.pending, k.pending === k.pending_buf_size)) {
            Q = 1;
            break;
          }
          k.gzindex < k.gzhead.name.length ? Q = k.gzhead.name.charCodeAt(k.gzindex++) & 255 : Q = 0, Pe(k, Q);
        } while (Q !== 0);
        k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), Q === 0 && (k.gzindex = 0, k.status = be);
      } else
        k.status = be;
    if (k.status === be)
      if (k.gzhead.comment) {
        N = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), Xe(d), N = k.pending, k.pending === k.pending_buf_size)) {
            Q = 1;
            break;
          }
          k.gzindex < k.gzhead.comment.length ? Q = k.gzhead.comment.charCodeAt(k.gzindex++) & 255 : Q = 0, Pe(k, Q);
        } while (Q !== 0);
        k.gzhead.hcrc && k.pending > N && (d.adler = r(d.adler, k.pending_buf, k.pending - N, N)), Q === 0 && (k.status = Se);
      } else
        k.status = Se;
    if (k.status === Se && (k.gzhead.hcrc ? (k.pending + 2 > k.pending_buf_size && Xe(d), k.pending + 2 <= k.pending_buf_size && (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), d.adler = 0, k.status = de)) : k.status = de), k.pending !== 0) {
      if (Xe(d), d.avail_out === 0)
        return k.last_flush = -1, v;
    } else if (d.avail_in === 0 && qe(ne) <= qe(ee) && ne !== l)
      return Fe(d, c);
    if (k.status === ye && d.avail_in !== 0)
      return Fe(d, c);
    if (d.avail_in !== 0 || k.lookahead !== 0 || ne !== i && k.status !== ye) {
      var Le = k.strategy === g ? vt(k, ne) : k.strategy === b ? ht(k, ne) : R[k.level].func(k, ne);
      if ((Le === We || Le === Ne) && (k.status = ye), Le === Ae || Le === We)
        return d.avail_out === 0 && (k.last_flush = -1), v;
      if (Le === Oe && (ne === a ? t._tr_align(k) : ne !== h && (t._tr_stored_block(k, 0, 0, !1), ne === s && (je(k.head), k.lookahead === 0 && (k.strstart = 0, k.block_start = 0, k.insert = 0))), Xe(d), d.avail_out === 0))
        return k.last_flush = -1, v;
    }
    return ne !== l ? v : k.wrap <= 0 ? u : (k.wrap === 2 ? (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), Pe(k, d.adler >> 16 & 255), Pe(k, d.adler >> 24 & 255), Pe(k, d.total_in & 255), Pe(k, d.total_in >> 8 & 255), Pe(k, d.total_in >> 16 & 255), Pe(k, d.total_in >> 24 & 255)) : (rt(k, d.adler >>> 16), rt(k, d.adler & 65535)), Xe(d), k.wrap > 0 && (k.wrap = -k.wrap), k.pending !== 0 ? v : u);
  }
  function ce(d) {
    var ne;
    return !d || !d.state ? f : (ne = d.state.status, ne !== oe && ne !== ae && ne !== fe && ne !== be && ne !== Se && ne !== de && ne !== ye ? Fe(d, f) : (d.state = null, ne === de ? Fe(d, m) : v));
  }
  function Te(d, ne) {
    var ee = ne.length, k, N, Q, $e, xe, Le, Ye, wt;
    if (!d || !d.state || (k = d.state, $e = k.wrap, $e === 2 || $e === 1 && k.status !== oe || k.lookahead))
      return f;
    for ($e === 1 && (d.adler = n(d.adler, ne, ee, 0)), k.wrap = 0, ee >= k.w_size && ($e === 0 && (je(k.head), k.strstart = 0, k.block_start = 0, k.insert = 0), wt = new e.Buf8(k.w_size), e.arraySet(wt, ne, ee - k.w_size, k.w_size, 0), ne = wt, ee = k.w_size), xe = d.avail_in, Le = d.next_in, Ye = d.input, d.avail_in = ee, d.next_in = 0, d.input = ne, Be(k); k.lookahead >= V; ) {
      N = k.strstart, Q = k.lookahead - (V - 1);
      do
        k.ins_h = (k.ins_h << k.hash_shift ^ k.window[N + V - 1]) & k.hash_mask, k.prev[N & k.w_mask] = k.head[k.ins_h], k.head[k.ins_h] = N, N++;
      while (--Q);
      k.strstart = N, k.lookahead = V - 1, Be(k);
    }
    return k.strstart += k.lookahead, k.block_start = k.strstart, k.insert = k.lookahead, k.lookahead = 0, k.match_length = k.prev_length = V - 1, k.match_available = 0, d.next_in = Le, d.input = Ye, d.avail_in = xe, k.wrap = $e, v;
  }
  return Ht.deflateInit = J, Ht.deflateInit2 = D, Ht.deflateReset = M, Ht.deflateResetKeep = K, Ht.deflateSetHeader = ie, Ht.deflate = y, Ht.deflateEnd = ce, Ht.deflateSetDictionary = Te, Ht.deflateInfo = "pako deflate (from Nodeca project)", Ht;
}
var bn = {}, Ml;
function is() {
  if (Ml) return bn;
  Ml = 1;
  var e = dn(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), o = 0; o < 256; o++)
    r[o] = o >= 252 ? 6 : o >= 248 ? 5 : o >= 240 ? 4 : o >= 224 ? 3 : o >= 192 ? 2 : 1;
  r[254] = r[254] = 1, bn.string2buf = function(a) {
    var s, l, h, v, u, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (s = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? s[u++] = l : l < 2048 ? (s[u++] = 192 | l >>> 6, s[u++] = 128 | l & 63) : l < 65536 ? (s[u++] = 224 | l >>> 12, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63) : (s[u++] = 240 | l >>> 18, s[u++] = 128 | l >>> 12 & 63, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63);
    return s;
  };
  function i(a, s) {
    if (s < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, s));
    for (var l = "", h = 0; h < s; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return bn.buf2binstring = function(a) {
    return i(a, a.length);
  }, bn.binstring2buf = function(a) {
    for (var s = new e.Buf8(a.length), l = 0, h = s.length; l < h; l++)
      s[l] = a.charCodeAt(l);
    return s;
  }, bn.buf2string = function(a, s) {
    var l, h, v, u, f = s || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, l += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && l < f; )
        v = v << 6 | a[l++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, bn.utf8border = function(a, s) {
    var l;
    for (s = s || a.length, s > a.length && (s = a.length), l = s - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? s : l + r[a[l]] > s ? l : s;
  }, bn;
}
var Mr, Rl;
function ls() {
  if (Rl) return Mr;
  Rl = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Mr = e, Mr;
}
var Fl;
function Oh() {
  if (Fl) return Rn;
  Fl = 1;
  var e = Dh(), t = dn(), n = is(), r = wi(), o = ls(), i = Object.prototype.toString, a = 0, s = 4, l = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var _ = this.options;
    _.raw && _.windowBits > 0 ? _.windowBits = -_.windowBits : _.gzip && _.windowBits > 0 && _.windowBits < 16 && (_.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new o(), this.strm.avail_out = 0;
    var E = e.deflateInit2(
      this.strm,
      _.level,
      _.method,
      _.windowBits,
      _.memLevel,
      _.strategy
    );
    if (E !== l)
      throw new Error(r[E]);
    if (_.header && e.deflateSetHeader(this.strm, _.header), _.dictionary) {
      var I;
      if (typeof _.dictionary == "string" ? I = n.string2buf(_.dictionary) : i.call(_.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(_.dictionary) : I = _.dictionary, E = e.deflateSetDictionary(this.strm, I), E !== l)
        throw new Error(r[E]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, _) {
    var E = this.strm, I = this.options.chunkSize, L, A;
    if (this.ended)
      return !1;
    A = _ === ~~_ ? _ : _ === !0 ? s : a, typeof b == "string" ? E.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? E.input = new Uint8Array(b) : E.input = b, E.next_in = 0, E.avail_in = E.input.length;
    do {
      if (E.avail_out === 0 && (E.output = new t.Buf8(I), E.next_out = 0, E.avail_out = I), L = e.deflate(E, A), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (E.avail_out === 0 || E.avail_in === 0 && (A === s || A === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(E.output, E.next_out))) : this.onData(t.shrinkBuf(E.output, E.next_out)));
    } while ((E.avail_in > 0 || E.avail_out === 0) && L !== h);
    return A === s ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (A === v && (this.onEnd(l), E.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, _) {
    var E = new c(_);
    if (E.push(b, !0), E.err)
      throw E.msg || r[E.err];
    return E.result;
  }
  function x(b, _) {
    return _ = _ || {}, _.raw = !0, p(b, _);
  }
  function g(b, _) {
    return _ = _ || {}, _.gzip = !0, p(b, _);
  }
  return Rn.Deflate = c, Rn.deflate = p, Rn.deflateRaw = x, Rn.gzip = g, Rn;
}
var Fn = {}, zt = {}, Rr, Nl;
function Mh() {
  if (Nl) return Rr;
  Nl = 1;
  var e = 30, t = 12;
  return Rr = function(r, o) {
    var i, a, s, l, h, v, u, f, m, c, p, x, g, b, _, E, I, L, A, B, H, re, O, X, z;
    i = r.state, a = r.next_in, X = r.input, s = a + (r.avail_in - 5), l = r.next_out, z = r.output, h = l - (o - r.avail_out), v = l + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, p = i.window, x = i.hold, g = i.bits, b = i.lencode, _ = i.distcode, E = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (x += X[a++] << g, g += 8, x += X[a++] << g, g += 8), L = b[x & E];
        t:
          for (; ; ) {
            if (A = L >>> 24, x >>>= A, g -= A, A = L >>> 16 & 255, A === 0)
              z[l++] = L & 65535;
            else if (A & 16) {
              B = L & 65535, A &= 15, A && (g < A && (x += X[a++] << g, g += 8), B += x & (1 << A) - 1, x >>>= A, g -= A), g < 15 && (x += X[a++] << g, g += 8, x += X[a++] << g, g += 8), L = _[x & I];
              n:
                for (; ; ) {
                  if (A = L >>> 24, x >>>= A, g -= A, A = L >>> 16 & 255, A & 16) {
                    if (H = L & 65535, A &= 15, g < A && (x += X[a++] << g, g += 8, g < A && (x += X[a++] << g, g += 8)), H += x & (1 << A) - 1, H > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (x >>>= A, g -= A, A = l - h, H > A) {
                      if (A = H - A, A > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (re = 0, O = p, c === 0) {
                        if (re += f - A, A < B) {
                          B -= A;
                          do
                            z[l++] = p[re++];
                          while (--A);
                          re = l - H, O = z;
                        }
                      } else if (c < A) {
                        if (re += f + c - A, A -= c, A < B) {
                          B -= A;
                          do
                            z[l++] = p[re++];
                          while (--A);
                          if (re = 0, c < B) {
                            A = c, B -= A;
                            do
                              z[l++] = p[re++];
                            while (--A);
                            re = l - H, O = z;
                          }
                        }
                      } else if (re += c - A, A < B) {
                        B -= A;
                        do
                          z[l++] = p[re++];
                        while (--A);
                        re = l - H, O = z;
                      }
                      for (; B > 2; )
                        z[l++] = O[re++], z[l++] = O[re++], z[l++] = O[re++], B -= 3;
                      B && (z[l++] = O[re++], B > 1 && (z[l++] = O[re++]));
                    } else {
                      re = l - H;
                      do
                        z[l++] = z[re++], z[l++] = z[re++], z[l++] = z[re++], B -= 3;
                      while (B > 2);
                      B && (z[l++] = z[re++], B > 1 && (z[l++] = z[re++]));
                    }
                  } else if ((A & 64) === 0) {
                    L = _[(L & 65535) + (x & (1 << A) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((A & 64) === 0) {
              L = b[(L & 65535) + (x & (1 << A) - 1)];
              continue t;
            } else if (A & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < s && l < v);
    B = g >> 3, a -= B, g -= B << 3, x &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < s ? 5 + (s - a) : 5 - (a - s), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = x, i.bits = g;
  }, Rr;
}
var Fr, Pl;
function Rh() {
  if (Pl) return Fr;
  Pl = 1;
  var e = dn(), t = 15, n = 852, r = 592, o = 0, i = 1, a = 2, s = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Fr = function(f, m, c, p, x, g, b, _) {
    var E = _.bits, I = 0, L = 0, A = 0, B = 0, H = 0, re = 0, O = 0, X = 0, z = 0, C = 0, T, F, V, q, Y, U = null, oe = 0, ae, fe = new e.Buf16(t + 1), be = new e.Buf16(t + 1), Se = null, de = 0, ye, Ae, Oe;
    for (I = 0; I <= t; I++)
      fe[I] = 0;
    for (L = 0; L < p; L++)
      fe[m[c + L]]++;
    for (H = E, B = t; B >= 1 && fe[B] === 0; B--)
      ;
    if (H > B && (H = B), B === 0)
      return x[g++] = 1 << 24 | 64 << 16 | 0, x[g++] = 1 << 24 | 64 << 16 | 0, _.bits = 1, 0;
    for (A = 1; A < B && fe[A] === 0; A++)
      ;
    for (H < A && (H = A), X = 1, I = 1; I <= t; I++)
      if (X <<= 1, X -= fe[I], X < 0)
        return -1;
    if (X > 0 && (f === o || B !== 1))
      return -1;
    for (be[1] = 0, I = 1; I < t; I++)
      be[I + 1] = be[I] + fe[I];
    for (L = 0; L < p; L++)
      m[c + L] !== 0 && (b[be[m[c + L]]++] = L);
    if (f === o ? (U = Se = b, ae = 19) : f === i ? (U = s, oe -= 257, Se = l, de -= 257, ae = 256) : (U = h, Se = v, ae = -1), C = 0, L = 0, I = A, Y = g, re = H, O = 0, V = -1, z = 1 << H, q = z - 1, f === i && z > n || f === a && z > r)
      return 1;
    for (; ; ) {
      ye = I - O, b[L] < ae ? (Ae = 0, Oe = b[L]) : b[L] > ae ? (Ae = Se[de + b[L]], Oe = U[oe + b[L]]) : (Ae = 96, Oe = 0), T = 1 << I - O, F = 1 << re, A = F;
      do
        F -= T, x[Y + (C >> O) + F] = ye << 24 | Ae << 16 | Oe | 0;
      while (F !== 0);
      for (T = 1 << I - 1; C & T; )
        T >>= 1;
      if (T !== 0 ? (C &= T - 1, C += T) : C = 0, L++, --fe[I] === 0) {
        if (I === B)
          break;
        I = m[c + b[L]];
      }
      if (I > H && (C & q) !== V) {
        for (O === 0 && (O = H), Y += A, re = I - O, X = 1 << re; re + O < B && (X -= fe[re + O], !(X <= 0)); )
          re++, X <<= 1;
        if (z += 1 << re, f === i && z > n || f === a && z > r)
          return 1;
        V = C & q, x[V] = H << 24 | re << 16 | Y - g | 0;
      }
    }
    return C !== 0 && (x[Y + C] = I - O << 24 | 64 << 16 | 0), _.bits = H, 0;
  }, Fr;
}
var Bl;
function Fh() {
  if (Bl) return zt;
  Bl = 1;
  var e = dn(), t = as(), n = rs(), r = Mh(), o = Rh(), i = 0, a = 1, s = 2, l = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, p = -3, x = -4, g = -5, b = 8, _ = 1, E = 2, I = 3, L = 4, A = 5, B = 6, H = 7, re = 8, O = 9, X = 10, z = 11, C = 12, T = 13, F = 14, V = 15, q = 16, Y = 17, U = 18, oe = 19, ae = 20, fe = 21, be = 22, Se = 23, de = 24, ye = 25, Ae = 26, Oe = 27, We = 28, Ne = 29, ue = 30, Fe = 31, qe = 32, je = 852, Xe = 592, Ve = 15, Pe = Ve;
  function rt(D) {
    return (D >>> 24 & 255) + (D >>> 8 & 65280) + ((D & 65280) << 8) + ((D & 255) << 24);
  }
  function ut() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function me(D) {
    var J;
    return !D || !D.state ? c : (J = D.state, D.total_in = D.total_out = J.total = 0, D.msg = "", J.wrap && (D.adler = J.wrap & 1), J.mode = _, J.last = 0, J.havedict = 0, J.dmax = 32768, J.head = null, J.hold = 0, J.bits = 0, J.lencode = J.lendyn = new e.Buf32(je), J.distcode = J.distdyn = new e.Buf32(Xe), J.sane = 1, J.back = -1, u);
  }
  function Be(D) {
    var J;
    return !D || !D.state ? c : (J = D.state, J.wsize = 0, J.whave = 0, J.wnext = 0, me(D));
  }
  function ze(D, J) {
    var y, ce;
    return !D || !D.state || (ce = D.state, J < 0 ? (y = 0, J = -J) : (y = (J >> 4) + 1, J < 48 && (J &= 15)), J && (J < 8 || J > 15)) ? c : (ce.window !== null && ce.wbits !== J && (ce.window = null), ce.wrap = y, ce.wbits = J, Be(D));
  }
  function Ke(D, J) {
    var y, ce;
    return D ? (ce = new ut(), D.state = ce, ce.window = null, y = ze(D, J), y !== u && (D.state = null), y) : c;
  }
  function Qe(D) {
    return Ke(D, Pe);
  }
  var ht = !0, vt, et;
  function R(D) {
    if (ht) {
      var J;
      for (vt = new e.Buf32(512), et = new e.Buf32(32), J = 0; J < 144; )
        D.lens[J++] = 8;
      for (; J < 256; )
        D.lens[J++] = 9;
      for (; J < 280; )
        D.lens[J++] = 7;
      for (; J < 288; )
        D.lens[J++] = 8;
      for (o(a, D.lens, 0, 288, vt, 0, D.work, { bits: 9 }), J = 0; J < 32; )
        D.lens[J++] = 5;
      o(s, D.lens, 0, 32, et, 0, D.work, { bits: 5 }), ht = !1;
    }
    D.lencode = vt, D.lenbits = 9, D.distcode = et, D.distbits = 5;
  }
  function S(D, J, y, ce) {
    var Te, d = D.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), ce >= d.wsize ? (e.arraySet(d.window, J, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Te = d.wsize - d.wnext, Te > ce && (Te = ce), e.arraySet(d.window, J, y - ce, Te, d.wnext), ce -= Te, ce ? (e.arraySet(d.window, J, y - ce, ce, 0), d.wnext = ce, d.whave = d.wsize) : (d.wnext += Te, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Te))), 0;
  }
  function w(D, J) {
    var y, ce, Te, d, ne, ee, k, N, Q, $e, xe, Le, Ye, wt, lt = 0, Ge, mt, _t, At, hn, an, ot, It, xt = new e.Buf8(4), Vt, Nt, ka = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!D || !D.state || !D.output || !D.input && D.avail_in !== 0)
      return c;
    y = D.state, y.mode === C && (y.mode = T), ne = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, ee = D.avail_in, N = y.hold, Q = y.bits, $e = ee, xe = k, It = u;
    e:
      for (; ; )
        switch (y.mode) {
          case _:
            if (y.wrap === 0) {
              y.mode = T;
              break;
            }
            for (; Q < 16; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if (y.wrap & 2 && N === 35615) {
              y.check = 0, xt[0] = N & 255, xt[1] = N >>> 8 & 255, y.check = n(y.check, xt, 2, 0), N = 0, Q = 0, y.mode = E;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              D.msg = "incorrect header check", y.mode = ue;
              break;
            }
            if ((N & 15) !== b) {
              D.msg = "unknown compression method", y.mode = ue;
              break;
            }
            if (N >>>= 4, Q -= 4, ot = (N & 15) + 8, y.wbits === 0)
              y.wbits = ot;
            else if (ot > y.wbits) {
              D.msg = "invalid window size", y.mode = ue;
              break;
            }
            y.dmax = 1 << ot, D.adler = y.check = 1, y.mode = N & 512 ? X : C, N = 0, Q = 0;
            break;
          case E:
            for (; Q < 16; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if (y.flags = N, (y.flags & 255) !== b) {
              D.msg = "unknown compression method", y.mode = ue;
              break;
            }
            if (y.flags & 57344) {
              D.msg = "unknown header flags set", y.mode = ue;
              break;
            }
            y.head && (y.head.text = N >> 8 & 1), y.flags & 512 && (xt[0] = N & 255, xt[1] = N >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), N = 0, Q = 0, y.mode = I;
          /* falls through */
          case I:
            for (; Q < 32; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            y.head && (y.head.time = N), y.flags & 512 && (xt[0] = N & 255, xt[1] = N >>> 8 & 255, xt[2] = N >>> 16 & 255, xt[3] = N >>> 24 & 255, y.check = n(y.check, xt, 4, 0)), N = 0, Q = 0, y.mode = L;
          /* falls through */
          case L:
            for (; Q < 16; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            y.head && (y.head.xflags = N & 255, y.head.os = N >> 8), y.flags & 512 && (xt[0] = N & 255, xt[1] = N >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), N = 0, Q = 0, y.mode = A;
          /* falls through */
          case A:
            if (y.flags & 1024) {
              for (; Q < 16; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              y.length = N, y.head && (y.head.extra_len = N), y.flags & 512 && (xt[0] = N & 255, xt[1] = N >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), N = 0, Q = 0;
            } else y.head && (y.head.extra = null);
            y.mode = B;
          /* falls through */
          case B:
            if (y.flags & 1024 && (Le = y.length, Le > ee && (Le = ee), Le && (y.head && (ot = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              ce,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Le,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              ot
            )), y.flags & 512 && (y.check = n(y.check, ce, Le, d)), ee -= Le, d += Le, y.length -= Le), y.length))
              break e;
            y.length = 0, y.mode = H;
          /* falls through */
          case H:
            if (y.flags & 2048) {
              if (ee === 0)
                break e;
              Le = 0;
              do
                ot = ce[d + Le++], y.head && ot && y.length < 65536 && (y.head.name += String.fromCharCode(ot));
              while (ot && Le < ee);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), ee -= Le, d += Le, ot)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = re;
          /* falls through */
          case re:
            if (y.flags & 4096) {
              if (ee === 0)
                break e;
              Le = 0;
              do
                ot = ce[d + Le++], y.head && ot && y.length < 65536 && (y.head.comment += String.fromCharCode(ot));
              while (ot && Le < ee);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), ee -= Le, d += Le, ot)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = O;
          /* falls through */
          case O:
            if (y.flags & 512) {
              for (; Q < 16; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              if (N !== (y.check & 65535)) {
                D.msg = "header crc mismatch", y.mode = ue;
                break;
              }
              N = 0, Q = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), D.adler = y.check = 0, y.mode = C;
            break;
          case X:
            for (; Q < 32; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            D.adler = y.check = rt(N), N = 0, Q = 0, y.mode = z;
          /* falls through */
          case z:
            if (y.havedict === 0)
              return D.next_out = ne, D.avail_out = k, D.next_in = d, D.avail_in = ee, y.hold = N, y.bits = Q, m;
            D.adler = y.check = 1, y.mode = C;
          /* falls through */
          case C:
            if (J === h || J === v)
              break e;
          /* falls through */
          case T:
            if (y.last) {
              N >>>= Q & 7, Q -= Q & 7, y.mode = Oe;
              break;
            }
            for (; Q < 3; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            switch (y.last = N & 1, N >>>= 1, Q -= 1, N & 3) {
              case 0:
                y.mode = F;
                break;
              case 1:
                if (R(y), y.mode = ae, J === v) {
                  N >>>= 2, Q -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = Y;
                break;
              case 3:
                D.msg = "invalid block type", y.mode = ue;
            }
            N >>>= 2, Q -= 2;
            break;
          case F:
            for (N >>>= Q & 7, Q -= Q & 7; Q < 32; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              D.msg = "invalid stored block lengths", y.mode = ue;
              break;
            }
            if (y.length = N & 65535, N = 0, Q = 0, y.mode = V, J === v)
              break e;
          /* falls through */
          case V:
            y.mode = q;
          /* falls through */
          case q:
            if (Le = y.length, Le) {
              if (Le > ee && (Le = ee), Le > k && (Le = k), Le === 0)
                break e;
              e.arraySet(Te, ce, d, Le, ne), ee -= Le, d += Le, k -= Le, ne += Le, y.length -= Le;
              break;
            }
            y.mode = C;
            break;
          case Y:
            for (; Q < 14; ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if (y.nlen = (N & 31) + 257, N >>>= 5, Q -= 5, y.ndist = (N & 31) + 1, N >>>= 5, Q -= 5, y.ncode = (N & 15) + 4, N >>>= 4, Q -= 4, y.nlen > 286 || y.ndist > 30) {
              D.msg = "too many length or distance symbols", y.mode = ue;
              break;
            }
            y.have = 0, y.mode = U;
          /* falls through */
          case U:
            for (; y.have < y.ncode; ) {
              for (; Q < 3; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              y.lens[ka[y.have++]] = N & 7, N >>>= 3, Q -= 3;
            }
            for (; y.have < 19; )
              y.lens[ka[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, Vt = { bits: y.lenbits }, It = o(i, y.lens, 0, 19, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              D.msg = "invalid code lengths set", y.mode = ue;
              break;
            }
            y.have = 0, y.mode = oe;
          /* falls through */
          case oe:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; lt = y.lencode[N & (1 << y.lenbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, _t = lt & 65535, !(Ge <= Q); ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              if (_t < 16)
                N >>>= Ge, Q -= Ge, y.lens[y.have++] = _t;
              else {
                if (_t === 16) {
                  for (Nt = Ge + 2; Q < Nt; ) {
                    if (ee === 0)
                      break e;
                    ee--, N += ce[d++] << Q, Q += 8;
                  }
                  if (N >>>= Ge, Q -= Ge, y.have === 0) {
                    D.msg = "invalid bit length repeat", y.mode = ue;
                    break;
                  }
                  ot = y.lens[y.have - 1], Le = 3 + (N & 3), N >>>= 2, Q -= 2;
                } else if (_t === 17) {
                  for (Nt = Ge + 3; Q < Nt; ) {
                    if (ee === 0)
                      break e;
                    ee--, N += ce[d++] << Q, Q += 8;
                  }
                  N >>>= Ge, Q -= Ge, ot = 0, Le = 3 + (N & 7), N >>>= 3, Q -= 3;
                } else {
                  for (Nt = Ge + 7; Q < Nt; ) {
                    if (ee === 0)
                      break e;
                    ee--, N += ce[d++] << Q, Q += 8;
                  }
                  N >>>= Ge, Q -= Ge, ot = 0, Le = 11 + (N & 127), N >>>= 7, Q -= 7;
                }
                if (y.have + Le > y.nlen + y.ndist) {
                  D.msg = "invalid bit length repeat", y.mode = ue;
                  break;
                }
                for (; Le--; )
                  y.lens[y.have++] = ot;
              }
            }
            if (y.mode === ue)
              break;
            if (y.lens[256] === 0) {
              D.msg = "invalid code -- missing end-of-block", y.mode = ue;
              break;
            }
            if (y.lenbits = 9, Vt = { bits: y.lenbits }, It = o(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              D.msg = "invalid literal/lengths set", y.mode = ue;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, Vt = { bits: y.distbits }, It = o(s, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, Vt), y.distbits = Vt.bits, It) {
              D.msg = "invalid distances set", y.mode = ue;
              break;
            }
            if (y.mode = ae, J === v)
              break e;
          /* falls through */
          case ae:
            y.mode = fe;
          /* falls through */
          case fe:
            if (ee >= 6 && k >= 258) {
              D.next_out = ne, D.avail_out = k, D.next_in = d, D.avail_in = ee, y.hold = N, y.bits = Q, r(D, xe), ne = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, ee = D.avail_in, N = y.hold, Q = y.bits, y.mode === C && (y.back = -1);
              break;
            }
            for (y.back = 0; lt = y.lencode[N & (1 << y.lenbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, _t = lt & 65535, !(Ge <= Q); ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if (mt && (mt & 240) === 0) {
              for (At = Ge, hn = mt, an = _t; lt = y.lencode[an + ((N & (1 << At + hn) - 1) >> At)], Ge = lt >>> 24, mt = lt >>> 16 & 255, _t = lt & 65535, !(At + Ge <= Q); ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              N >>>= At, Q -= At, y.back += At;
            }
            if (N >>>= Ge, Q -= Ge, y.back += Ge, y.length = _t, mt === 0) {
              y.mode = Ae;
              break;
            }
            if (mt & 32) {
              y.back = -1, y.mode = C;
              break;
            }
            if (mt & 64) {
              D.msg = "invalid literal/length code", y.mode = ue;
              break;
            }
            y.extra = mt & 15, y.mode = be;
          /* falls through */
          case be:
            if (y.extra) {
              for (Nt = y.extra; Q < Nt; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              y.length += N & (1 << y.extra) - 1, N >>>= y.extra, Q -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = Se;
          /* falls through */
          case Se:
            for (; lt = y.distcode[N & (1 << y.distbits) - 1], Ge = lt >>> 24, mt = lt >>> 16 & 255, _t = lt & 65535, !(Ge <= Q); ) {
              if (ee === 0)
                break e;
              ee--, N += ce[d++] << Q, Q += 8;
            }
            if ((mt & 240) === 0) {
              for (At = Ge, hn = mt, an = _t; lt = y.distcode[an + ((N & (1 << At + hn) - 1) >> At)], Ge = lt >>> 24, mt = lt >>> 16 & 255, _t = lt & 65535, !(At + Ge <= Q); ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              N >>>= At, Q -= At, y.back += At;
            }
            if (N >>>= Ge, Q -= Ge, y.back += Ge, mt & 64) {
              D.msg = "invalid distance code", y.mode = ue;
              break;
            }
            y.offset = _t, y.extra = mt & 15, y.mode = de;
          /* falls through */
          case de:
            if (y.extra) {
              for (Nt = y.extra; Q < Nt; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              y.offset += N & (1 << y.extra) - 1, N >>>= y.extra, Q -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              D.msg = "invalid distance too far back", y.mode = ue;
              break;
            }
            y.mode = ye;
          /* falls through */
          case ye:
            if (k === 0)
              break e;
            if (Le = xe - k, y.offset > Le) {
              if (Le = y.offset - Le, Le > y.whave && y.sane) {
                D.msg = "invalid distance too far back", y.mode = ue;
                break;
              }
              Le > y.wnext ? (Le -= y.wnext, Ye = y.wsize - Le) : Ye = y.wnext - Le, Le > y.length && (Le = y.length), wt = y.window;
            } else
              wt = Te, Ye = ne - y.offset, Le = y.length;
            Le > k && (Le = k), k -= Le, y.length -= Le;
            do
              Te[ne++] = wt[Ye++];
            while (--Le);
            y.length === 0 && (y.mode = fe);
            break;
          case Ae:
            if (k === 0)
              break e;
            Te[ne++] = y.length, k--, y.mode = fe;
            break;
          case Oe:
            if (y.wrap) {
              for (; Q < 32; ) {
                if (ee === 0)
                  break e;
                ee--, N |= ce[d++] << Q, Q += 8;
              }
              if (xe -= k, D.total_out += xe, y.total += xe, xe && (D.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, Te, xe, ne - xe) : t(y.check, Te, xe, ne - xe)), xe = k, (y.flags ? N : rt(N)) !== y.check) {
                D.msg = "incorrect data check", y.mode = ue;
                break;
              }
              N = 0, Q = 0;
            }
            y.mode = We;
          /* falls through */
          case We:
            if (y.wrap && y.flags) {
              for (; Q < 32; ) {
                if (ee === 0)
                  break e;
                ee--, N += ce[d++] << Q, Q += 8;
              }
              if (N !== (y.total & 4294967295)) {
                D.msg = "incorrect length check", y.mode = ue;
                break;
              }
              N = 0, Q = 0;
            }
            y.mode = Ne;
          /* falls through */
          case Ne:
            It = f;
            break e;
          case ue:
            It = p;
            break e;
          case Fe:
            return x;
          case qe:
          /* falls through */
          default:
            return c;
        }
    return D.next_out = ne, D.avail_out = k, D.next_in = d, D.avail_in = ee, y.hold = N, y.bits = Q, (y.wsize || xe !== D.avail_out && y.mode < ue && (y.mode < Oe || J !== l)) && S(D, D.output, D.next_out, xe - D.avail_out), $e -= D.avail_in, xe -= D.avail_out, D.total_in += $e, D.total_out += xe, y.total += xe, y.wrap && xe && (D.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, Te, xe, D.next_out - xe) : t(y.check, Te, xe, D.next_out - xe)), D.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === C ? 128 : 0) + (y.mode === ae || y.mode === V ? 256 : 0), ($e === 0 && xe === 0 || J === l) && It === u && (It = g), It;
  }
  function K(D) {
    if (!D || !D.state)
      return c;
    var J = D.state;
    return J.window && (J.window = null), D.state = null, u;
  }
  function M(D, J) {
    var y;
    return !D || !D.state || (y = D.state, (y.wrap & 2) === 0) ? c : (y.head = J, J.done = !1, u);
  }
  function ie(D, J) {
    var y = J.length, ce, Te, d;
    return !D || !D.state || (ce = D.state, ce.wrap !== 0 && ce.mode !== z) ? c : ce.mode === z && (Te = 1, Te = t(Te, J, y, 0), Te !== ce.check) ? p : (d = S(D, J, y, y), d ? (ce.mode = Fe, x) : (ce.havedict = 1, u));
  }
  return zt.inflateReset = Be, zt.inflateReset2 = ze, zt.inflateResetKeep = me, zt.inflateInit = Qe, zt.inflateInit2 = Ke, zt.inflate = w, zt.inflateEnd = K, zt.inflateGetHeader = M, zt.inflateSetDictionary = ie, zt.inflateInfo = "pako inflate (from Nodeca project)", zt;
}
var Nr, zl;
function os() {
  return zl || (zl = 1, Nr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Nr;
}
var Pr, Vl;
function Nh() {
  if (Vl) return Pr;
  Vl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Pr = e, Pr;
}
var Hl;
function Ph() {
  if (Hl) return Fn;
  Hl = 1;
  var e = Fh(), t = dn(), n = is(), r = os(), o = wi(), i = ls(), a = Nh(), s = Object.prototype.toString;
  function l(u) {
    if (!(this instanceof l)) return new l(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(o[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : s.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(o[m]);
  }
  l.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, p = this.options.dictionary, x, g, b, _, E, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = n.binstring2buf(u) : s.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), x = e.inflate(m, r.Z_NO_FLUSH), x === r.Z_NEED_DICT && p && (x = e.inflateSetDictionary(this.strm, p)), x === r.Z_BUF_ERROR && I === !0 && (x = r.Z_OK, I = !1), x !== r.Z_STREAM_END && x !== r.Z_OK)
        return this.onEnd(x), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || x === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), _ = m.next_out - b, E = n.buf2string(m.output, b), m.next_out = _, m.avail_out = c - _, _ && t.arraySet(m.output, m.output, b, _, 0), this.onData(E)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && x !== r.Z_STREAM_END);
    return x === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (x = e.inflateEnd(this.strm), this.onEnd(x), this.ended = !0, x === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(u) {
    this.chunks.push(u);
  }, l.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new l(f);
    if (m.push(u, !0), m.err)
      throw m.msg || o[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return Fn.Inflate = l, Fn.inflate = h, Fn.inflateRaw = v, Fn.ungzip = h, Fn;
}
var Br, Ul;
function Bh() {
  if (Ul) return Br;
  Ul = 1;
  var e = dn().assign, t = Oh(), n = Ph(), r = os(), o = {};
  return e(o, t, n, r), Br = o, Br;
}
var ql;
function zh() {
  return ql || (ql = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof $h == "function" ? n = Bh() : n = window.pako, (function(r, o) {
        r.toRGBA8 = function(i) {
          var a = i.width, s = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, s, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * s * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, p = f.rect.width, x = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, x, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, x, h, a, s, m, c, 0) : f.blend == 1 && r._copyTile(g, p, x, h, a, s, m, c, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, x, h, a, s, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, s, l) {
          var h = a * s, v = r.decode._getBPP(l), u = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = l.ctype, p = l.depth, x = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var _ = l.tabs.tRNS, E = -1, I = -1, L = -1;
            if (_ && (E = _[0], I = _[1], L = _[2]), p == 8) for (var b = 0; b < h; b++) {
              var A = b << 2, B = b * 3;
              f[A] = i[B], f[A + 1] = i[B + 1], f[A + 2] = i[B + 2], f[A + 3] = 255, E != -1 && i[B] == E && i[B + 1] == I && i[B + 2] == L && (f[A + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var A = b << 2, B = b * 6;
              f[A] = i[B], f[A + 1] = i[B + 2], f[A + 2] = i[B + 4], f[A + 3] = 255, E != -1 && x(i, B) == E && x(i, B + 2) == I && x(i, B + 4) == L && (f[A + 3] = 0);
            }
          } else if (c == 3) {
            var H = l.tabs.PLTE, re = l.tabs.tRNS, O = re ? re.length : 0;
            if (p == 1) for (var X = 0; X < s; X++)
              for (var z = X * u, C = X * a, b = 0; b < a; b++) {
                var A = C + b << 2, T = i[z + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, F = 3 * T;
                f[A] = H[F], f[A + 1] = H[F + 1], f[A + 2] = H[F + 2], f[A + 3] = T < O ? re[T] : 255;
              }
            if (p == 2) for (var X = 0; X < s; X++)
              for (var z = X * u, C = X * a, b = 0; b < a; b++) {
                var A = C + b << 2, T = i[z + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, F = 3 * T;
                f[A] = H[F], f[A + 1] = H[F + 1], f[A + 2] = H[F + 2], f[A + 3] = T < O ? re[T] : 255;
              }
            if (p == 4) for (var X = 0; X < s; X++)
              for (var z = X * u, C = X * a, b = 0; b < a; b++) {
                var A = C + b << 2, T = i[z + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, F = 3 * T;
                f[A] = H[F], f[A + 1] = H[F + 1], f[A + 2] = H[F + 2], f[A + 3] = T < O ? re[T] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var A = b << 2, T = i[b], F = 3 * T;
              f[A] = H[F], f[A + 1] = H[F + 1], f[A + 2] = H[F + 2], f[A + 3] = T < O ? re[T] : 255;
            }
          } else if (c == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var A = b << 2, V = b << 1, q = i[V];
              f[A] = q, f[A + 1] = q, f[A + 2] = q, f[A + 3] = i[V + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var A = b << 2, V = b << 2, q = i[V];
              f[A] = q, f[A + 1] = q, f[A + 2] = q, f[A + 3] = i[V + 2];
            }
          } else if (c == 0) {
            var E = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var q = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), Y = q == E * 255 ? 0 : 255;
              m[b] = Y << 24 | q << 16 | q << 8 | q;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var q = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), Y = q == E * 85 ? 0 : 255;
              m[b] = Y << 24 | q << 16 | q << 8 | q;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var q = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), Y = q == E * 17 ? 0 : 255;
              m[b] = Y << 24 | q << 16 | q << 8 | q;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var q = i[b], Y = q == E ? 0 : 255;
              m[b] = Y << 24 | q << 16 | q << 8 | q;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var q = i[b << 1], Y = x(i, b << 1) == E ? 0 : 255;
              m[b] = Y << 24 | q << 16 | q << 8 | q;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), s = 8, l = r._bin, h = l.readUshort, v = l.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, c, p = 0, x = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != x[g]) throw "The input is not a PNG file!";
          for (; s < a.length; ) {
            var b = l.readUint(a, s);
            s += 4;
            var _ = l.readASCII(a, s, 4);
            if (s += 4, _ == "IHDR")
              r.decode._IHDR(a, s, u);
            else if (_ == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[s + g];
              m += b;
            } else if (_ == "acTL")
              u.tabs[_] = { num_frames: v(a, s), num_plays: v(a, s + 4) }, c = new Uint8Array(a.length);
            else if (_ == "fcTL") {
              if (p != 0) {
                var E = u.frames[u.frames.length - 1];
                E.data = r.decode._decompress(u, c.slice(0, p), E.rect.width, E.rect.height), p = 0;
              }
              var I = { x: v(a, s + 12), y: v(a, s + 16), width: v(a, s + 4), height: v(a, s + 8) }, L = h(a, s + 22);
              L = h(a, s + 20) / (L == 0 ? 100 : L);
              var A = { rect: I, delay: Math.round(L * 1e3), dispose: a[s + 24], blend: a[s + 25] };
              u.frames.push(A);
            } else if (_ == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[p + g] = a[s + g + 4];
              p += b - 4;
            } else if (_ == "pHYs")
              u.tabs[_] = [l.readUint(a, s), l.readUint(a, s + 4), a[s + 8]];
            else if (_ == "cHRM") {
              u.tabs[_] = [];
              for (var g = 0; g < 8; g++) u.tabs[_].push(l.readUint(a, s + g * 4));
            } else if (_ == "tEXt") {
              u.tabs[_] == null && (u.tabs[_] = {});
              var B = l.nextZero(a, s), H = l.readASCII(a, s, B - s), re = l.readASCII(a, B + 1, s + b - B - 1);
              u.tabs[_][H] = re;
            } else if (_ == "iTXt") {
              u.tabs[_] == null && (u.tabs[_] = {});
              var B = 0, O = s;
              B = l.nextZero(a, O);
              var H = l.readASCII(a, O, B - O);
              O = B + 1, a[O], a[O + 1], O += 2, B = l.nextZero(a, O), l.readASCII(a, O, B - O), O = B + 1, B = l.nextZero(a, O), l.readUTF8(a, O, B - O), O = B + 1;
              var re = l.readUTF8(a, O, b - (O - s));
              u.tabs[_][H] = re;
            } else if (_ == "PLTE")
              u.tabs[_] = l.readBytes(a, s, b);
            else if (_ == "hIST") {
              var X = u.tabs.PLTE.length / 3;
              u.tabs[_] = [];
              for (var g = 0; g < X; g++) u.tabs[_].push(h(a, s + g * 2));
            } else if (_ == "tRNS")
              u.ctype == 3 ? u.tabs[_] = l.readBytes(a, s, b) : u.ctype == 0 ? u.tabs[_] = h(a, s) : u.ctype == 2 && (u.tabs[_] = [h(a, s), h(a, s + 2), h(a, s + 4)]);
            else if (_ == "gAMA") u.tabs[_] = l.readUint(a, s) / 1e5;
            else if (_ == "sRGB") u.tabs[_] = a[s];
            else if (_ == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[_] = [h(a, s)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[_] = [h(a, s), h(a, s + 2), h(a, s + 4)] : u.ctype == 3 && (u.tabs[_] = a[s]);
            else if (_ == "IEND") {
              if (p != 0) {
                var E = u.frames[u.frames.length - 1];
                E.data = r.decode._decompress(u, c.slice(0, p), E.rect.width, E.rect.height), p = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            s += b, l.readUint(a, s), s += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, a, s, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, s, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return o.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var s = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, u = Math.ceil(s * h / 8), f = new Uint8Array(l * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], x = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var _ = x[b], E = g[b], I = 0, L = 0, A = c[b]; A < l; )
              A += _, L++;
            for (var B = p[b]; B < s; )
              B += E, I++;
            var H = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, L);
            for (var re = 0, O = c[b]; O < l; ) {
              for (var X = p[b], z = m + re * H << 3; X < s; ) {
                if (h == 1) {
                  var C = i[z >> 3];
                  C = C >> 7 - (z & 7) & 1, f[O * u + (X >> 3)] |= C << 7 - ((X & 3) << 0);
                }
                if (h == 2) {
                  var C = i[z >> 3];
                  C = C >> 6 - (z & 7) & 3, f[O * u + (X >> 2)] |= C << 6 - ((X & 3) << 1);
                }
                if (h == 4) {
                  var C = i[z >> 3];
                  C = C >> 4 - (z & 7) & 15, f[O * u + (X >> 1)] |= C << 4 - ((X & 1) << 2);
                }
                if (h >= 8)
                  for (var T = O * u + X * v, F = 0; F < v; F++) f[T + F] = i[(z >> 3) + F];
                z += h, X += E;
              }
              re++, O += _;
            }
            I * L != 0 && (m += L * (1 + H)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, s, l, h) {
          var v = r.decode._getBPP(a), u = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = s + m * u, p = c + m + 1, x = i[p - 1];
            if (x == 0) for (var g = 0; g < u; g++) i[c + g] = i[p + g];
            else if (x == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              for (var g = v; g < u; g++) i[c + g] = i[p + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              if (x == 2) for (var g = v; g < u; g++) i[c + g] = i[p + g] & 255;
              if (x == 3) for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - v] >> 1) & 255;
              if (x == 4) for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (x == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[p + g] + i[c + g - u] & 255;
              if (x == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (x == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, s) {
          var l = i + a - s, h = Math.abs(l - i), v = Math.abs(l - a), u = Math.abs(l - s);
          return h <= v && h <= u ? i : v <= u ? a : s;
        }, r.decode._IHDR = function(i, a, s) {
          var l = r._bin;
          s.width = l.readUint(i, a), a += 4, s.height = l.readUint(i, a), a += 4, s.depth = i[a], a++, s.ctype = i[a], a++, s.compress = i[a], a++, s.filter = i[a], a++, s.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, s) {
            i[a] = s >> 8 & 255, i[a + 1] = s & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, s) {
            i[a] = s >> 24 & 255, i[a + 1] = s >> 16 & 255, i[a + 2] = s >> 8 & 255, i[a + 3] = s & 255;
          },
          readASCII: function(i, a, s) {
            for (var l = "", h = 0; h < s; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, s) {
            for (var l = 0; l < s.length; l++) i[a + l] = s.charCodeAt(l);
          },
          readBytes: function(i, a, s) {
            for (var l = [], h = 0; h < s; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, s) {
            for (var l = "", h, v = 0; v < s; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, s);
            }
            return h;
          }
        }, r._copyTile = function(i, a, s, l, h, v, u, f, m) {
          for (var c = Math.min(a, h), p = Math.min(s, v), x = 0, g = 0, b = 0; b < p; b++)
            for (var _ = 0; _ < c; _++)
              if (u >= 0 && f >= 0 ? (x = b * a + _ << 2, g = (f + b) * h + u + _ << 2) : (x = (-f + b) * a - u + _ << 2, g = b * h + _ << 2), m == 0)
                l[g] = i[x], l[g + 1] = i[x + 1], l[g + 2] = i[x + 2], l[g + 3] = i[x + 3];
              else if (m == 1) {
                var E = i[x + 3] * 0.00392156862745098, I = i[x] * E, L = i[x + 1] * E, A = i[x + 2] * E, B = l[g + 3] * (1 / 255), H = l[g] * B, re = l[g + 1] * B, O = l[g + 2] * B, X = 1 - E, z = E + B * X, C = z == 0 ? 0 : 1 / z;
                l[g + 3] = 255 * z, l[g + 0] = (I + H * X) * C, l[g + 1] = (L + re * X) * C, l[g + 2] = (A + O * X) * C;
              } else if (m == 2) {
                var E = i[x + 3], I = i[x], L = i[x + 1], A = i[x + 2], B = l[g + 3], H = l[g], re = l[g + 1], O = l[g + 2];
                E == B && I == H && L == re && A == O ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = I, l[g + 1] = L, l[g + 2] = A, l[g + 3] = E);
              } else if (m == 3) {
                var E = i[x + 3], I = i[x], L = i[x + 1], A = i[x + 2], B = l[g + 3], H = l[g], re = l[g + 1], O = l[g + 2];
                if (E == B && I == H && L == re && A == O) continue;
                if (E < 220 && B > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, s, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, p = r._bin, x = r.crc.crc, g = p.writeUint, b = p.writeUshort, _ = p.writeASCII, E = r.encode.compressPNG(i, a, s, l, v);
          g(u, c, 13), c += 4, _(u, c, "IHDR"), c += 4, g(u, c, a), c += 4, g(u, c, s), c += 4, u[c] = E.depth, c++, u[c] = E.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, x(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, _(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, x(u, c - 5, 5)), c += 4;
          var I = i.length > 1;
          if (I && (g(u, c, 8), c += 4, _(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, x(u, c - 12, 12)), c += 4), E.ctype == 3) {
            var L = E.plte.length;
            g(u, c, L * 3), c += 4, _(u, c, "PLTE"), c += 4;
            for (var m = 0; m < L; m++) {
              var A = m * 3, B = E.plte[m], H = B & 255, re = B >> 8 & 255, O = B >> 16 & 255;
              u[c + A + 0] = H, u[c + A + 1] = re, u[c + A + 2] = O;
            }
            if (c += L * 3, g(u, c, x(u, c - L * 3 - 4, L * 3 + 4)), c += 4, E.gotAlpha) {
              g(u, c, L), c += 4, _(u, c, "tRNS"), c += 4;
              for (var m = 0; m < L; m++) u[c + m] = E.plte[m] >> 24 & 255;
              c += L, g(u, c, x(u, c - L - 4, L + 4)), c += 4;
            }
          }
          for (var X = 0, z = 0; z < E.frames.length; z++) {
            var C = E.frames[z];
            I && (g(u, c, 26), c += 4, _(u, c, "fcTL"), c += 4, g(u, c, X++), c += 4, g(u, c, C.rect.width), c += 4, g(u, c, C.rect.height), c += 4, g(u, c, C.rect.x), c += 4, g(u, c, C.rect.y), c += 4, b(u, c, h[z]), c += 2, b(u, c, 1e3), c += 2, u[c] = C.dispose, c++, u[c] = C.blend, c++, g(u, c, x(u, c - 30, 30)), c += 4);
            var T = C.cimg, L = T.length;
            g(u, c, L + (z == 0 ? 0 : 4)), c += 4;
            var F = c;
            _(u, c, z == 0 ? "IDAT" : "fdAT"), c += 4, z != 0 && (g(u, c, X++), c += 4);
            for (var m = 0; m < L; m++) u[c + m] = T[m];
            c += L, g(u, c, x(u, F, c - F)), c += 4;
          }
          return g(u, c, 0), c += 4, _(u, c, "IEND"), c += 4, g(u, c, x(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, a, s, l, h) {
          for (var v = r.encode.compress(i, a, s, l, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, p = f.bpp, x = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, p, c, x);
          }
          return v;
        }, r.encode.compress = function(i, a, s, l, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, p = 0; p < i.length; p++)
            for (var x = new Uint8Array(i[p]), g = x.length, b = 0; b < g; b += 4) c &= x[b + 3];
          var _ = c != 255, E = {}, I = [];
          if (i.length != 0 && (E[0] = 0, I.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var A = L.plte[b].est.rgba;
              E[A] == null && (E[A] = I.length, I.push(A));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var B = new Uint32Array(i[p]), g = B.length, b = 0; b < g; b++) {
                var A = B[b];
                if ((b < a || A != B[b - 1] && A != B[b - a]) && E[A] == null && (E[A] = I.length, I.push(A), I.length >= 300))
                  break;
              }
          var H = _ ? h : !1, re = I.length;
          re <= 256 && v == !1 && (re <= 2 ? f = 1 : re <= 4 ? f = 2 : re <= 16 ? f = 4 : f = 8, h && (f = 8), _ = !0);
          for (var O = [], p = 0; p < i.length; p++) {
            var X = new Uint8Array(i[p]), z = new Uint32Array(X.buffer), C = 0, T = 0, F = a, V = s, q = 0;
            if (p != 0 && !H) {
              for (var Y = h || p == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, U = 0, oe = 1e9, ae = 0; ae < Y; ae++) {
                for (var Ne = new Uint8Array(i[p - 1 - ae]), fe = new Uint32Array(i[p - 1 - ae]), be = a, Se = s, de = -1, ye = -1, Ae = 0; Ae < s; Ae++) for (var Oe = 0; Oe < a; Oe++) {
                  var b = Ae * a + Oe;
                  z[b] != fe[b] && (Oe < be && (be = Oe), Oe > de && (de = Oe), Ae < Se && (Se = Ae), Ae > ye && (ye = Ae));
                }
                var We = de == -1 ? 1 : (de - be + 1) * (ye - Se + 1);
                We < oe && (oe = We, U = ae, de == -1 ? (C = T = 0, F = V = 1) : (C = be, T = Se, F = de - be + 1, V = ye - Se + 1));
              }
              var Ne = new Uint8Array(i[p - 1 - U]);
              U == 1 && (O[O.length - 1].dispose = 2);
              var ue = new Uint8Array(F * V * 4);
              new Uint32Array(ue.buffer), r._copyTile(Ne, a, s, ue, F, V, -C, -T, 0), r._copyTile(X, a, s, ue, F, V, -C, -T, 3) ? (r._copyTile(X, a, s, ue, F, V, -C, -T, 2), q = 1) : (r._copyTile(X, a, s, ue, F, V, -C, -T, 0), q = 0), X = ue, z = new Uint32Array(X.buffer);
            }
            var Fe = 4 * F;
            if (re <= 256 && v == !1) {
              Fe = Math.ceil(f * F / 8);
              for (var ue = new Uint8Array(Fe * V), Ae = 0; Ae < V; Ae++) {
                var b = Ae * Fe, qe = Ae * F;
                if (f == 8) for (var Oe = 0; Oe < F; Oe++) ue[b + Oe] = E[z[qe + Oe]];
                else if (f == 4) for (var Oe = 0; Oe < F; Oe++) ue[b + (Oe >> 1)] |= E[z[qe + Oe]] << 4 - (Oe & 1) * 4;
                else if (f == 2) for (var Oe = 0; Oe < F; Oe++) ue[b + (Oe >> 2)] |= E[z[qe + Oe]] << 6 - (Oe & 3) * 2;
                else if (f == 1) for (var Oe = 0; Oe < F; Oe++) ue[b + (Oe >> 3)] |= E[z[qe + Oe]] << 7 - (Oe & 7) * 1;
              }
              X = ue, u = 3, m = 1;
            } else if (_ == !1 && i.length == 1) {
              for (var ue = new Uint8Array(F * V * 3), je = F * V, b = 0; b < je; b++) {
                var Xe = b * 3, Ve = b * 4;
                ue[Xe] = X[Ve], ue[Xe + 1] = X[Ve + 1], ue[Xe + 2] = X[Ve + 2];
              }
              X = ue, u = 2, m = 3, Fe = 3 * F;
            }
            O.push({ rect: { x: C, y: T, width: F, height: V }, img: X, bpl: Fe, bpp: m, blend: q, dispose: H ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: I, gotAlpha: _, frames: O };
        }, r.encode._filterZero = function(i, a, s, l, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(a * l > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, s, u);
              if (v.push(o.deflate(h)), s == 1) break;
            }
          for (var m, c = 1e9, p = 0; p < v.length; p++) v[p].length < c && (m = p, c = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, s, l, h, v) {
          var u = s * l, f = u + s, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < l; c++) i[f + c] = a[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            for (var c = h; c < l; c++) i[f + c] = a[u + c] - a[u + c - h] + 256 & 255;
          } else if (s == 0) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            if (v == 2) for (var c = h; c < l; c++) i[f + c] = a[u + c];
            if (v == 3) for (var c = h; c < l; c++) i[f + c] = a[u + c] - (a[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < l; c++) i[f + c] = a[u + c] - m(a[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < l; c++) i[f + c] = a[u + c] + 256 - a[u + c - l] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] >> 1) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] + a[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - m(0, a[u + c - l], 0) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - m(a[u + c - h], a[u + c - l], a[u + c - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var s = a, l = 0; l < 8; l++)
                s & 1 ? s = 3988292384 ^ s >>> 1 : s = s >>> 1;
              i[a] = s;
            }
            return i;
          })(),
          update: function(i, a, s, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[s + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, s) {
            return r.crc.update(4294967295, i, a, s) ^ 4294967295;
          }
        }, r.quantize = function(i, a, s) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), s)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var c = l[v], p = c.length, x = 0; x < p; x++) u[m + x] = c[x];
            m += p;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var _ = 0, E = 0, v = 0; v < b.length; v++) b[v].est.L > _ && (_ = b[v].est.L, E = v);
            if (_ < 1e-3) break;
            var I = b[E], L = r.quantize.splitPixels(u, f, I.i0, I.i1, I.est.e, I.est.eMq255), A = { i0: I.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            A.bst = r.quantize.stats(u, A.i0, A.i1), A.est = r.quantize.estats(A.bst);
            var B = { i0: L, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            B.bst = { R: [], m: [], N: I.bst.N - A.bst.N };
            for (var v = 0; v < 16; v++) B.bst.R[v] = I.bst.R[v] - A.bst.R[v];
            for (var v = 0; v < 4; v++) B.bst.m[v] = I.bst.m[v] - A.bst.m[v];
            B.est = r.quantize.estats(B.bst), I.left = A, I.right = B, b[E] = A, b.push(B);
          }
          b.sort(function(Y, U) {
            return U.bst.N - Y.bst.N;
          });
          for (var H = 0; H < l.length; H++) {
            for (var re = r.quantize.planeDst, O = new Uint8Array(l[H].buffer), X = new Uint32Array(l[H].buffer), z = O.length, v = 0; v < z; v += 4) {
              for (var C = O[v] * 0.00392156862745098, T = O[v + 1] * (1 / 255), F = O[v + 2] * (1 / 255), V = O[v + 3] * (1 / 255), q = g; q.left; ) q = re(q.est, C, T, F, V) <= 0 ? q.left : q.right;
              X[v >> 2] = q.est.rgba;
            }
            l[H] = X.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, s, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, s, l, h), i;
          var v = r.quantize.planeDst(i.est, a, s, l, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, a, s, l, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, a, s, l, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, a, s, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * s + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, s, l, h) {
          var v = a - i[0], u = s - i[1], f = l - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, s, l, h, v) {
          var u = r.quantize.vecDot;
          for (l -= 4; s < l; ) {
            for (; u(i, s, h) <= v; ) s += 4;
            for (; u(i, l, h) > v; ) l -= 4;
            if (s >= l) break;
            var f = a[s >> 2];
            a[s >> 2] = a[l >> 2], a[l >> 2] = f, s += 4, l -= 4;
          }
          for (; u(i, s, h) > v; ) s -= 4;
          return s + 4;
        }, r.quantize.vecDot = function(i, a, s) {
          return i[a] * s[0] + i[a + 1] * s[1] + i[a + 2] * s[2] + i[a + 3] * s[3];
        }, r.quantize.stats = function(i, a, s) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = s - a >> 2, u = a; u < s; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), p = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * c, l[3] += f * p, l[5] += m * m, l[6] += m * c, l[7] += m * p, l[10] += c * c, l[11] += c * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, s = i.m, l = i.N, h = s[0], v = s[1], u = s[2], f = s[3], m = l == 0 ? 0 : 1 / l, c = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * u * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * u * m,
            a[7] - v * f * m,
            a[8] - u * h * m,
            a[9] - u * v * m,
            a[10] - u * u * m,
            a[11] - u * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * u * m,
            a[15] - f * f * m
          ], p = c, x = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, _ = 0;
          if (l != 0)
            for (var E = 0; E < 10 && (g = x.multVec(p, g), _ = Math.sqrt(x.dot(g, g)), g = x.sml(1 / _, g), !(Math.abs(_ - b) < 1e-9)); E++)
              b = _;
          var I = [h * m, v * m, u * m, f * m], L = x.dot(x.sml(255, I), g), A = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: c,
            q: I,
            e: g,
            L: b,
            eMq255: L,
            eMq: x.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * A) << 16 | Math.round(255 * I[1] * A) << 8 | Math.round(255 * I[0] * A) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var s = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, u = i[v + 3];
            a && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            s[v + 0] = i[v + 0] * f, s[v + 1] = i[v + 1] * f, s[v + 2] = i[v + 2] * f, s[v + 3] = u;
          }
          return s;
        };
      })(t, n);
    })();
  })(Lr)), Lr.exports;
}
var Vh = zh();
const Hh = /* @__PURE__ */ Lh(Vh), Uh = () => ya() ? Pa("NuxtImg") : "img", qh = ["alt", "src"], d2 = /* @__PURE__ */ ke({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ct("wrapper"), i = Uh(), a = ge(!0), s = W(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = W(() => o.value?.clientHeight ?? 0), h = W(() => o.value?.clientWidth ?? 0), v = W(() => e.loading || a.value), u = W(() => {
      if (!e.blurHash) return;
      const m = Ah(e.blurHash, 32, 32), c = new Uint8Array(m), p = Hh.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + xh(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, c) => ($(), j("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Et({ "--image-aspect-ratio": s.value })
    }, [
      ($(), we(Ft(Z(i)), Ce({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? ($(), we(xn, {
        key: 0,
        name: "lc-image__transition",
        persisted: ""
      }, {
        default: _e(() => [
          Qt(te("img", Ce({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, qh), [
            [ui, v.value]
          ])
        ]),
        _: 1
      })) : se("", !0)
    ], 4));
  }
}), jh = "medium", Zh = "medium", f2 = ["center", "top"], h2 = ["medium", "small"], Wh = {
  key: 1,
  class: "lc-info-text__content"
}, Xh = {
  key: 0,
  class: "lc-info-text__text"
}, v2 = /* @__PURE__ */ ke({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: () => jh },
    size: { default: () => Zh },
    text: {}
  },
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = W(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (o, i) => ($(), j("article", {
      class: pe(n.value)
    }, [
      Re(Z(Je), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      te("section", null, [
        e.headline ? ($(), j("span", {
          key: 0,
          class: pe(r.value)
        }, Ie(e.headline), 3)) : se("", !0),
        e.text || o.$slots.default ? ($(), j("div", Wh, [
          he(o.$slots, "default", {}, () => [
            e.text ? ($(), j("p", Xh, Ie(e.text), 1)) : se("", !0)
          ])
        ])) : se("", !0)
      ])
    ], 2));
  }
}), Yh = { class: "lc-link-list" }, m2 = /* @__PURE__ */ ke({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), j("ul", Yh, [
      he(t.$slots, "default")
    ]));
  }
}), Gh = { key: 0 }, Kh = { class: "lc-link-list-item__headline" }, Jh = {
  key: 0,
  class: "lc-link-list-item__text"
}, g2 = /* @__PURE__ */ ke({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), j("li", {
      class: pe(t.value)
    }, [
      Re(Z(fi), Ce({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: _e(() => [
          n.$slots.default ? ($(), j("div", Gh, [
            he(n.$slots, "default")
          ])) : ($(), j(at, { key: 1 }, [
            e.icon ? ($(), we(Z(Je), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : se("", !0),
            te("div", null, [
              te("span", Kh, Ie(e.headline), 1),
              e.text ? ($(), j("p", Jh, Ie(e.text), 1)) : se("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Qh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", ev = { class: "lc-lottery-cutoff-time__headline" }, tv = ["src"], nv = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, av = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, rv = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, iv = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, lv = 1e3, jl = /* @__PURE__ */ ke({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => Ze.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => Ze.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => Ze.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => Ze.lcLotteryCutoffTime.textTimeToCutoff },
    timeZone: {},
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = Uo(), o = ge(!1), i = ge(/* @__PURE__ */ new Date());
    xo(
      () => {
        i.value = /* @__PURE__ */ new Date();
      },
      lv,
      { immediate: !r }
    );
    const a = W(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": u.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), s = W(() => new Date(e.cutoffTime)), l = W(
      () => jo({
        date: f.value,
        format: "drawingShort",
        locale: e.locale,
        timeZone: e.timeZone
      })
    ), h = W(
      () => qa(s.value) && s.value.getTime() <= i.value.getTime()
    ), v = W(() => m("days") === 0), u = W(() => {
      const p = m("minutes");
      return v.value && p ? p < e.startAnimationTime : !1;
    }), f = W(
      () => h.value && e.nextCutoffTime ? new Date(e.nextCutoffTime) : s.value
    ), m = (p) => {
      if (!qa(s.value)) return null;
      const { days: x = 0, hours: g = 0, minutes: b = 0 } = qo(i.value, s.value);
      switch (p) {
        case "days":
          return x;
        case "minutes":
          return x * 24 + g * 60 + b;
      }
    }, c = () => {
      r || o.value || (o.value = !0, n("cutoff-time-reached"));
    };
    return He(
      [() => e.cutoffTime, h],
      ([p], [x]) => {
        p !== x && (o.value = !1), h.value && c();
      },
      { immediate: !0 }
    ), (p, x) => ($(), j("div", {
      class: pe(a.value)
    }, [
      te("span", ev, [
        u.value ? ($(), j("img", {
          key: 0,
          alt: "",
          height: "16",
          src: Z(Qh),
          width: "16"
        }, null, 8, tv)) : ($(), we(Z(Je), {
          key: 1,
          name: v.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        he(p.$slots, "title", {}, () => [
          te("span", nv, Ie(v.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          te("span", av, Ie(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), j("span", rv, " : ")) : se("", !0),
      te("div", iv, [
        v.value ? ($(), we(Z(wf), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": f.value,
          variant: e.countdownVariant,
          onExpired: c
        }, null, 8, ["expires-at", "variant"])) : ($(), we(Z(Oo), Ce({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...Z(yi).drawingShort }, { datetime: f.value }), {
          default: _e(() => [
            kt(Ie(l.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), b2 = ["default", "expressive"], ov = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, sv = {
  key: 1,
  class: "lc-lottery-numbers__value"
}, cv = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, uv = "extra", dv = /* @__PURE__ */ ke({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = W(() => o.value.flat().length), r = W(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), o = W(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: s, ignored: l, matching: h, value: v }) => ({
          empty: !s && !l && (v === void 0 || v === ""),
          icon: s,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), j("article", {
      class: pe(t.value),
      style: Et({ "--items-per-row": r.value })
    }, [
      te("ol", {
        class: pe(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), j(at, null, yt(o.value, (s, l) => ($(), j(at, { key: l }, [
          ($(!0), j(at, null, yt(s, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, p) => ($(), j(at, {
            key: `${l}-${p}`
          }, [
            te("li", {
              class: "lc-lottery-numbers__list-item",
              style: Et({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              he(i.$slots, `highlight-${m}`),
              te("div", {
                class: pe(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === uv,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? ($(), j("div", ov, [
                  Re(Z(Je), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : se("", !0),
                he(i.$slots, `number-${m}`, Ce({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? ($(), we(Z(Je), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), j("span", sv, Ie(u ? "X" : c), 1))
                ])
              ], 2)
            ], 4),
            l < o.value.length - 1 && p === s.length - 1 && i.$slots["field-divider"] ? ($(), j("li", cv, [
              he(i.$slots, "field-divider")
            ])) : se("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), p2 = ["large", "medium", "small"], y2 = ["medium", "small"], w2 = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(Zt || {});
const fv = ["id"], hv = { class: "lc-lottery-number-selector__label" }, vv = ["for"], mv = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], x2 = /* @__PURE__ */ ke({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    highlightedNumbers: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    numberClass: { type: Function },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = er(), o = ct("numberInputs"), i = $t(e.id), a = ge(e.fixedColumns ?? 0), s = ge(0), l = W(() => E(s.value)), h = W(
      () => u.value ? c.value : f.value
    ), v = W(() => L(s.value)), u = W(() => e.value.length >= e.selectableMax), f = W(() => {
      const U = Array.from({ length: b.value }, () => []);
      return m.value.map((oe, ae) => {
        U[L(ae)].push(ae);
      }), C(U);
    }), m = W(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (U, oe) => e.min + oe);
    }), c = W(
      () => f.value.map(
        (U) => U.map(
          (oe) => p.value.includes(oe) ? oe : -1
        )
      )
    ), p = W(() => e.value.map((U) => m.value.indexOf(U))), x = W(() => Math.min(g.value, a.value)), g = W(() => m.value.length), b = W(() => Math.ceil(g.value / x.value)), _ = (U) => {
      const oe = h.value.length, ae = h.value[0].length;
      let fe = v.value, be = l.value;
      do
        switch (U) {
          case "down":
            fe = (fe + 1) % oe, fe === 0 && (be = (be + 1) % ae);
            break;
          case "left":
            be = (be - 1 + ae) % ae, be === ae - 1 && (fe = (fe - 1 + oe) % oe);
            break;
          case "right":
            be = (be + 1) % ae, be === 0 && (fe = (fe + 1) % oe);
            break;
          case "up":
            fe = (fe - 1 + oe) % oe, fe === oe - 1 && (be = (be - 1 + ae) % ae);
            break;
        }
      while (h.value[fe][be] === -1);
      return h.value[fe][be];
    }, E = (U) => U % x.value, I = (U) => [
      {
        "lc-lottery-number-selector__number": !0,
        "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
        "lc-lottery-number-selector__number--checked": T(U),
        "lc-lottery-number-selector__number--disabled": V(U),
        "lc-lottery-number-selector__number--highlighted": F(U)
      },
      e.numberClass?.(U) ?? ""
    ], L = (U) => Math.floor(U / x.value), A = () => {
      if (u.value) {
        const ae = f.value[v.value].filter(
          (fe) => fe > s.value && p.value.includes(fe)
        ).reverse();
        if (!ae.length) return;
        s.value = ae[0];
        return;
      }
      const U = f.value[v.value];
      s.value = U.at(-1) ?? 0;
    }, B = () => {
      if (u.value) {
        const ae = f.value[v.value].filter(
          (fe) => fe < s.value && p.value.includes(fe)
        );
        if (!ae.length) return;
        s.value = ae[0];
        return;
      }
      const U = f.value[v.value];
      s.value = U[0];
    }, H = () => {
      s.value = u.value ? p.value[0] : 0;
    }, re = () => {
      const U = p.value.at(-1) ?? 0;
      s.value = u.value ? U : g.value - 1;
    }, O = (U) => {
      tn(U.key, Zt) && (U.preventDefault(), U.stopPropagation(), U.ctrlKey ? X(U.key) : z(U.key));
    }, X = (U) => {
      switch (U) {
        case Zt.End:
          re();
          break;
        case Zt.Home:
          H();
          break;
      }
    }, z = (U) => {
      switch (U) {
        case Zt.ArrowDown:
          s.value = _("down");
          break;
        case Zt.ArrowLeft:
          s.value = _("left");
          break;
        case Zt.ArrowRight:
          s.value = _("right");
          break;
        case Zt.ArrowUp:
          s.value = _("up");
          break;
        case Zt.End:
          A();
          break;
        case Zt.Home:
          B();
          break;
      }
    }, C = (U) => {
      const oe = Math.max(...U.map((ae) => ae.length));
      return U.map((ae) => {
        const fe = [...ae];
        for (; fe.length < oe; )
          fe.push(-1);
        return fe;
      });
    }, T = (U) => e.value.includes(U), F = (U) => !!e.highlightedNumbers?.includes(U), V = (U) => e.disabled || !T(U) && u.value || e.allNumbersToggled, q = (U) => {
      const oe = [...e.value], ae = oe.indexOf(U);
      ae > -1 ? oe.splice(ae, 1) : u.value || (oe.push(U), oe.sort((fe, be) => m.value.indexOf(fe) - m.value.indexOf(be))), n("update:value", oe);
    };
    He(
      () => e.allNumbersToggled,
      () => {
        const U = e.allNumbersToggled ? m.value : [];
        n("update:value", U);
      }
    ), He(s, (U) => {
      o.value?.[U].focus();
    }), He(u, (U) => {
      U && n("complete");
    });
    const Y = oc(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const U = o.value;
      if (!r || !U?.length) return;
      const oe = U[0].getBoundingClientRect().top;
      let ae = 0;
      for (const fe of U) {
        if (fe.getBoundingClientRect().top !== oe) break;
        ae++;
      }
      a.value = ae;
    }, 100);
    return He(() => e.fixedColumns, Y), St(Y), qt(window, "resize", Y), (U, oe) => ($(), j("fieldset", Ce(U.$attrs, {
      id: Z(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      te("legend", hv, Ie(e.label), 1),
      ($(!0), j(at, null, yt(m.value, (ae, fe) => ($(), j("label", {
        key: ae,
        class: pe(I(ae)),
        for: `gridcell-${E(fe)}-${L(fe)}-${Z(i)}`
      }, [
        te("input", {
          id: `gridcell-${E(fe)}-${L(fe)}-${Z(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: T(ae),
          class: "lc-lottery-number-selector__input",
          disabled: V(ae),
          tabindex: s.value === fe || T(ae) ? 0 : -1,
          type: "checkbox",
          onChange: () => q(ae),
          onFocusin: (be) => s.value = fe,
          onKeydown: [
            O,
            ci(() => q(ae), ["enter"])
          ]
        }, null, 40, mv),
        he(U.$slots, "cell", Ce({ ref_for: !0 }, {
          checked: T(ae),
          disabled: V(ae),
          number: ae
        }), () => [
          kt(Ie(ae), 1)
        ])
      ], 10, vv))), 128))
    ], 16, fv));
  }
}), gv = { class: "w-full" }, bv = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, pv = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, yv = { class: "lc-lottery-teaser__button-container" }, wv = { class: "lc-lottery-teaser__button-wrap" }, xv = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, kv = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Sv = { class: "lc-lottery-teaser__draw-date-headline" }, k2 = /* @__PURE__ */ ke({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => Ze.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": o.value
      }
    ]), r = W(
      () => jo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), o = W(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (a, s) => ($(), we(Z(ir), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Ka({
      header: _e(() => [
        he(a.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        e.variant === "expressive" ? ($(), we(Z(jl), Ce({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: s[0] || (s[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : se("", !0),
        te("section", gv, [
          ($(), we(Ft(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), j("strong", bv, Ie(e.headline), 1)) : se("", !0),
              Re(Z(Qo), Ce(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), j("strong", pv, Ie(e.subline), 1)) : se("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        te("section", yv, [
          te("div", wv, [
            he(a.$slots, "primary-button", {}, () => [
              Re(Z(Tt), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: o.value ? "primary-ghost" : "primary",
                onClick: s[1] || (s[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          o.value ? ($(), j("div", xv, [
            he(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), we(Z(Tt), Ce({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: s[2] || (s[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : se("", !0)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: _e(() => [
          ["default", "badge"].includes(e.variant) ? ($(), j("div", kv, [
            te("div", Sv, [
              Re(Z(Je), {
                name: "calendar",
                size: "small"
              }),
              te("span", null, Ie(e.drawDateHeadline), 1)
            ]),
            Re(Z(Oo), Ce({ locale: e.locale, ...Z(yi).drawingShort }, { datetime: e.drawDate }), {
              default: _e(() => [
                kt(Ie(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : se("", !0),
          Re(Z(jl), Ce({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: s[3] || (s[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), S2 = [...ts, "expressive"], _v = { class: "lc-masked-value-display" }, _2 = /* @__PURE__ */ ke({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), j("span", _v, [
      ($(!0), j(at, null, yt(e.parts, (r) => ($(), j("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), j(at, null, yt(e.masksPerPart, (o) => ($(), j("span", {
          key: o,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      he(t.$slots, "default")
    ]));
  }
}), ei = Math.min, zn = Math.max, Za = Math.round, Oa = Math.floor, Jt = (e) => ({
  x: e,
  y: e
}), Cv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zn(e) {
  return e.split("-")[0];
}
function lr(e) {
  return e.split("-")[1];
}
function Ev(e) {
  return e === "x" ? "y" : "x";
}
function ss(e) {
  return e === "y" ? "height" : "width";
}
function wn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function cs(e) {
  return Ev(wn(e));
}
function Tv(e, t, n) {
  n === void 0 && (n = !1);
  const r = lr(e), o = cs(e), i = ss(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Wa(a)), [a, Wa(a)];
}
function Av(e) {
  const t = Wa(e);
  return [ti(e), t, ti(t)];
}
function ti(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Zl = ["left", "right"], Wl = ["right", "left"], Lv = ["top", "bottom"], $v = ["bottom", "top"];
function Iv(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Wl : Zl : t ? Zl : Wl;
    case "left":
    case "right":
      return t ? Lv : $v;
    default:
      return [];
  }
}
function Dv(e, t, n, r) {
  const o = lr(e);
  let i = Iv(Zn(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(ti)))), i;
}
function Wa(e) {
  const t = Zn(e);
  return Cv[t] + e.slice(t.length);
}
function Ov(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function Mv(e) {
  return typeof e != "number" ? Ov(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xa(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Xl(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = wn(t), a = cs(t), s = ss(a), l = Zn(t), h = i === "y", v = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = lr(t);
  return c && (m[a] += f * (c === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function Rv(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = xi(t, e), c = Mv(m), x = s[f ? u === "floating" ? "reference" : "floating" : u], g = Xa(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), E = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  }, I = Xa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: _,
    strategy: l
  }) : b);
  return {
    top: (g.top - I.top + c.top) / E.y,
    bottom: (I.bottom - g.bottom + c.bottom) / E.y,
    left: (g.left - I.left + c.left) / E.x,
    right: (I.right - g.right + c.right) / E.x
  };
}
const Fv = 50, Nv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = a.detectOverflow ? a : {
    ...a,
    detectOverflow: Rv
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: v,
    y: u
  } = Xl(h, r, l), f = r, m = 0;
  const c = {};
  for (let p = 0; p < i.length; p++) {
    const x = i[p];
    if (!x)
      continue;
    const {
      name: g,
      fn: b
    } = x, {
      x: _,
      y: E,
      data: I,
      reset: L
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: c,
      rects: h,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = _ ?? v, u = E ?? u, c[g] = {
      ...c[g],
      ...I
    }, L && m < Fv && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : L.rects), {
      x: v,
      y: u
    } = Xl(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: o,
    middlewareData: c
  };
}, Pv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: p = !0,
        ...x
      } = xi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = Zn(o), b = wn(s), _ = Zn(s) === s, E = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), I = f || (_ || !p ? [Wa(s)] : Av(s)), L = c !== "none";
      !f && L && I.push(...Dv(s, p, c, E));
      const A = [s, ...I], B = await l.detectOverflow(t, x), H = [];
      let re = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && H.push(B[g]), u) {
        const C = Tv(o, a, E);
        H.push(B[C[0]], B[C[1]]);
      }
      if (re = [...re, {
        placement: o,
        overflows: H
      }], !H.every((C) => C <= 0)) {
        var O, X;
        const C = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, T = A[C];
        if (T && (!(u === "alignment" ? b !== wn(T) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        re.every((q) => wn(q.placement) === b ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: C,
              overflows: re
            },
            reset: {
              placement: T
            }
          };
        let F = (X = re.filter((V) => V.overflows[0] <= 0).sort((V, q) => V.overflows[1] - q.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!F)
          switch (m) {
            case "bestFit": {
              var z;
              const V = (z = re.filter((q) => {
                if (L) {
                  const Y = wn(q.placement);
                  return Y === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((Y) => Y > 0).reduce((Y, U) => Y + U, 0)]).sort((q, Y) => q[1] - Y[1])[0]) == null ? void 0 : z[0];
              V && (F = V);
              break;
            }
            case "initialPlacement":
              F = s;
              break;
          }
        if (o !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
}, Bv = /* @__PURE__ */ new Set(["left", "top"]);
async function zv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Zn(n), s = lr(n), l = wn(n) === "y", h = Bv.has(a) ? -1 : 1, v = i && l ? -1 : 1, u = xi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof c == "number" && (m = s === "end" ? c * -1 : c), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const Vv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await zv(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function or() {
  return typeof window < "u";
}
function In(e) {
  return ki(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Mt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (ki(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ki(e) {
  return or() ? e instanceof Node || e instanceof Mt(e).Node : !1;
}
function Xt(e) {
  return or() ? e instanceof Element || e instanceof Mt(e).Element : !1;
}
function fn(e) {
  return or() ? e instanceof HTMLElement || e instanceof Mt(e).HTMLElement : !1;
}
function Yl(e) {
  return !or() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Mt(e).ShadowRoot;
}
function sr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function Hv(e) {
  return /^(table|td|th)$/.test(In(e));
}
function cr(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Uv = /transform|translate|scale|rotate|perspective|filter/, qv = /paint|layout|strict|content/, pn = (e) => !!e && e !== "none";
let zr;
function Si(e) {
  const t = Xt(e) ? Yt(e) : e;
  return pn(t.transform) || pn(t.translate) || pn(t.scale) || pn(t.rotate) || pn(t.perspective) || !_i() && (pn(t.backdropFilter) || pn(t.filter)) || Uv.test(t.willChange || "") || qv.test(t.contain || "");
}
function jv(e) {
  let t = Tn(e);
  for (; fn(t) && !ma(t); ) {
    if (Si(t))
      return t;
    if (cr(t))
      return null;
    t = Tn(t);
  }
  return null;
}
function _i() {
  return zr == null && (zr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), zr;
}
function ma(e) {
  return /^(html|body|#document)$/.test(In(e));
}
function Yt(e) {
  return Mt(e).getComputedStyle(e);
}
function ur(e) {
  return Xt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Tn(e) {
  if (In(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yl(e) && e.host || // Fallback.
    nn(e)
  );
  return Yl(t) ? t.host : t;
}
function us(e) {
  const t = Tn(e);
  return ma(t) ? (e.ownerDocument || e).body : fn(t) && sr(t) ? t : us(t);
}
function ga(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = us(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Mt(o);
  if (i) {
    const s = ni(a);
    return t.concat(a, a.visualViewport || [], sr(o) ? o : [], s && n ? ga(s) : []);
  } else
    return t.concat(o, ga(o, [], n));
}
function ni(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ds(e) {
  const t = Yt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = fn(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Za(n) !== i || Za(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Ci(e) {
  return Xt(e) ? e : e.contextElement;
}
function Vn(e) {
  const t = Ci(e);
  if (!fn(t))
    return Jt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = ds(t);
  let a = (i ? Za(n.width) : n.width) / r, s = (i ? Za(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Zv = /* @__PURE__ */ Jt(0);
function fs(e) {
  const t = Mt(e);
  return !_i() || !t.visualViewport ? Zv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Wv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Mt(e);
}
function An(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Ci(e);
  let a = Jt(1);
  t && (r ? Xt(r) && (a = Vn(r)) : a = Vn(e));
  const s = Wv(i, n, r) ? fs(i) : Jt(0);
  let l = (o.left + s.x) / a.x, h = (o.top + s.y) / a.y, v = o.width / a.x, u = o.height / a.y;
  if (i && r) {
    const f = Mt(i), m = Xt(r) ? Mt(r) : r;
    let c = f, p = ni(c);
    for (; p && m !== c; ) {
      const x = Vn(p), g = p.getBoundingClientRect(), b = Yt(p), _ = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * x.x, E = g.top + (p.clientTop + parseFloat(b.paddingTop)) * x.y;
      l *= x.x, h *= x.y, v *= x.x, u *= x.y, l += _, h += E, c = Mt(p), p = ni(c);
    }
  }
  return Xa({
    width: v,
    height: u,
    x: l,
    y: h
  });
}
function dr(e, t) {
  const n = ur(e).scrollLeft;
  return t ? t.left + n : An(nn(e)).left + n;
}
function hs(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - dr(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Xv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = nn(r), s = t ? cr(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Jt(1);
  const v = Jt(0), u = fn(r);
  if ((u || !i) && ((In(r) !== "body" || sr(a)) && (l = ur(r)), u)) {
    const m = An(r);
    h = Vn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !u && !i ? hs(a, l) : Jt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function Yv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Gv(e) {
  const t = ur(e), n = e.ownerDocument.body, r = zn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = zn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + dr(e);
  const a = -t.scrollTop;
  return Yt(n).direction === "rtl" && (i += zn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: a
  };
}
const Kv = 25;
function Jv(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = Mt(e), i = nn(e), a = o.visualViewport;
  let s = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !_i() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (s = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (dr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, x = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? x / 2 : x;
    g <= Kv && (s -= g);
  }
  return {
    width: s,
    height: l,
    x: h,
    y: v
  };
}
function Qv(e, t) {
  const n = An(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Vn(e), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, h = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: h
  };
}
function Gl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = Jv(e, n, t);
  else if (t === "document")
    r = Gv(nn(e));
  else if (Xt(t))
    r = Qv(t, n);
  else {
    const o = fs(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Xa(r);
}
function em(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ga(e, [], !1).filter((s) => Xt(s) && In(s) !== "body"), o = null;
  const i = Yt(e).position === "fixed";
  let a = i ? Tn(e) : e;
  for (; Xt(a) && !ma(a); ) {
    const s = Yt(a), l = Si(a), h = o ? o.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && s.position === "static") ? r = r.filter((u) => u !== a) : o = s, a = Tn(a);
  }
  return t.set(e, r), r;
}
function tm(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? cr(t) ? [] : em(t, this._c) : [].concat(n), r], s = Gl(t, a[0], o);
  let l = s.top, h = s.right, v = s.bottom, u = s.left;
  for (let f = 1; f < a.length; f++) {
    const m = Gl(t, a[f], o);
    l = zn(m.top, l), h = ei(m.right, h), v = ei(m.bottom, v), u = zn(m.left, u);
  }
  return {
    width: h - u,
    height: v - l,
    x: u,
    y: l
  };
}
function nm(e) {
  const {
    width: t,
    height: n
  } = ds(e);
  return {
    width: t,
    height: n
  };
}
function am(e, t, n) {
  const r = fn(t), o = nn(t), i = n === "fixed", a = An(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if ((r || !i) && ((In(t) !== "body" || sr(o)) && (s = ur(t)), r)) {
    const f = An(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && o && (l.x = dr(o));
  const h = o && !r && !i ? hs(o, s) : Jt(0), v = a.left + s.scrollLeft - l.x - h.x, u = a.top + s.scrollTop - l.y - h.y;
  return {
    x: v,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Vr(e) {
  return Yt(e).position === "static";
}
function Kl(e, t) {
  if (!fn(e) || Yt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return nn(e) === n && (n = n.ownerDocument.body), n;
}
function vs(e, t) {
  const n = Mt(e);
  if (cr(e))
    return n;
  if (!fn(e)) {
    let o = Tn(e);
    for (; o && !ma(o); ) {
      if (Xt(o) && !Vr(o))
        return o;
      o = Tn(o);
    }
    return n;
  }
  let r = Kl(e, t);
  for (; r && Hv(r) && Vr(r); )
    r = Kl(r, t);
  return r && ma(r) && Vr(r) && !Si(r) ? n : r || jv(e) || n;
}
const rm = async function(e) {
  const t = this.getOffsetParent || vs, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: am(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function im(e) {
  return Yt(e).direction === "rtl";
}
const lm = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xv,
  getDocumentElement: nn,
  getClippingRect: tm,
  getOffsetParent: vs,
  getElementRects: rm,
  getClientRects: Yv,
  getDimensions: nm,
  getScale: Vn,
  isElement: Xt,
  isRTL: im
};
function ms(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function om(e, t, n) {
  let r = null, o;
  const i = nn(e);
  function a() {
    var v;
    clearTimeout(o), (v = r) == null || v.disconnect(), r = null;
  }
  function s(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: p,
      height: x
    } = f;
    if (v || t(), !p || !x)
      return;
    const g = Oa(c), b = Oa(i.clientWidth - (m + p)), _ = Oa(i.clientHeight - (c + x)), E = Oa(m), L = {
      rootMargin: -g + "px " + -b + "px " + -_ + "px " + -E + "px",
      threshold: zn(0, ei(1, u)) || 1
    };
    let A = !0;
    function B(H) {
      const re = H[0].intersectionRatio;
      if (!ms(f, e.getBoundingClientRect()))
        return s();
      if (re !== u) {
        if (!A)
          return s();
        re ? s(!1, re) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      r = new IntersectionObserver(B, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(B, L);
    }
    r.observe(e);
  }
  const l = Mt(e), h = () => s(n);
  return l.addEventListener("resize", h), s(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function gs(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = Ci(e), v = o || i ? [...h ? ga(h) : [], ...t ? ga(t) : []] : [];
  v.forEach((g) => {
    o && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const u = h && s ? om(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var _;
      (_ = m) == null || _.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let c, p = l ? An(e) : null;
  l && x();
  function x() {
    const g = An(e);
    p && !ms(p, g) && n(), p = g, c = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(c);
  };
}
const bs = Vv, ps = Pv, sm = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, i = {
    ...lm,
    ...o.platform,
    _c: r
  };
  return Nv(e, t, {
    ...o,
    platform: i
  });
};
function cm(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Jl(e) {
  if (cm(e)) {
    const t = e.$el;
    return ki(t) && In(t) === "#comment" ? null : t;
  }
  return e;
}
function ys(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ql(e, t) {
  const n = ys(e);
  return Math.round(t * n) / n;
}
function ws(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, o = W(() => {
    var A;
    return (A = nt(n.open)) != null ? A : !0;
  }), i = W(() => nt(n.middleware)), a = W(() => {
    var A;
    return (A = nt(n.placement)) != null ? A : "bottom";
  }), s = W(() => {
    var A;
    return (A = nt(n.strategy)) != null ? A : "absolute";
  }), l = W(() => {
    var A;
    return (A = nt(n.transform)) != null ? A : !0;
  }), h = W(() => Jl(e.value)), v = W(() => Jl(t.value)), u = ge(0), f = ge(0), m = ge(s.value), c = ge(a.value), p = Sn({}), x = ge(!1), g = W(() => {
    const A = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return A;
    const B = Ql(v.value, u.value), H = Ql(v.value, f.value);
    return l.value ? {
      ...A,
      transform: "translate(" + B + "px, " + H + "px)",
      ...ys(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: B + "px",
      top: H + "px"
    };
  });
  let b;
  function _() {
    if (h.value == null || v.value == null)
      return;
    const A = o.value;
    sm(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: s.value
    }).then((B) => {
      u.value = B.x, f.value = B.y, m.value = B.strategy, c.value = B.placement, p.value = B.middlewareData, x.value = A !== !1;
    });
  }
  function E() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (E(), r === void 0) {
      _();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, _);
      return;
    }
  }
  function L() {
    o.value || (x.value = !1);
  }
  return He([i, a, s, o], _, {
    flush: "sync"
  }), He([h, v], I, {
    flush: "sync"
  }), He(o, L, {
    flush: "sync"
  }), Xs() && Ys(E), {
    x: On(u),
    y: On(f),
    strategy: On(m),
    placement: On(c),
    middlewareData: On(p),
    isPositioned: On(x),
    floatingStyles: g,
    update: _
  };
}
const Fa = ge(!1);
let Hn, Un, qn, ai = 0;
const Ei = () => (St(() => {
  ai += 1, um();
}), Ln(() => {
  ai -= 1, dm();
}), Fa), um = () => {
  typeof window > "u" || (Hn || (Hn = () => Fa.value = !0, window.addEventListener("keydown", Hn, !0)), Un || (Un = () => Fa.value = !1, window.addEventListener("mousedown", Un, !0)), qn || (qn = () => Fa.value = !1, window.addEventListener("pointerdown", qn, !0)));
}, dm = () => {
  typeof window > "u" || ai || (Hn && (window.removeEventListener("keydown", Hn, !0), Hn = null), Un && (window.removeEventListener("mousedown", Un, !0), Un = null), qn && (window.removeEventListener("pointerdown", qn, !0), qn = null));
}, xs = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, C2 = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ut = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ut || {});
const fm = {
  ref: "container",
  class: "lc-menu-button"
}, hm = ["id", "aria-activedescendant"], vm = ["id", "aria-selected", "onClick"], E2 = /* @__PURE__ */ ke({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ct("button"), i = ct("menu"), a = ge(null), s = ge(!1), { floatingStyles: l } = ws(o, i, {
      middleware: [
        bs({
          alignmentAxis: 4
        }),
        ps(),
        xs
      ],
      placement: () => e.placement,
      whileElementsMounted: gs
    }), h = $t(e.id), v = Ei(), u = W(() => {
      if (!(!s.value || !Lt(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = W(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      s.value && (a.value = null, s.value = !1);
    }, c = () => {
      if (s.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, x = (b) => {
      if (!tn(b.key, Ut)) return;
      b.key !== Ut.Tab && (b.preventDefault(), b.stopPropagation());
      const _ = e.options.length - 1;
      switch (b.key) {
        case Ut.ArrowDown:
          if (s.value && Lt(a.value)) {
            a.value = Math.min(_, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.ArrowUp:
          if (s.value && Lt(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = _, g();
          break;
        case Ut.End:
          if (!s.value) return;
          a.value = _;
          break;
        case Ut.Enter:
        case Ut.Space:
          if (s.value && Lt(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.Escape:
        case Ut.Tab:
          m();
          break;
        case Ut.Home:
          if (!s.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      s.value || (s.value = !0, e.value && (a.value = f.value));
    };
    return Ja(i, m, {
      ignore: [o, ...nt(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), St(() => {
      e.value && (a.value = f.value);
    }), (b, _) => ($(), j("div", fm, [
      Re(Z(Tt), Ce({
        id: Z(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${Z(h)}-menu`,
        "aria-expanded": s.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: x
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), we(pa, { to: "body" }, [
        s.value ? ($(), we(Z(wa), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Et({ ...Z(l), zIndex: e.zIndex })
        }, {
          default: _e(() => [
            te("ul", {
              id: `${Z(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), j(at, null, yt(e.options, (E, I) => ($(), j("li", {
                key: `${E.label}-${"value" in E ? E.value : "action"}`,
                class: pe(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && Z(v),
                  "lc-menu-button__menu-item--selected": "value" in E && E.value === e.value
                }])
              }, [
                te("button", {
                  id: `${Z(h)}-menuitem-${I}`,
                  "aria-selected": "value" in E && E.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(E)
                }, [
                  Re(Z(Je), {
                    name: E.icon
                  }, null, 8, ["name"]),
                  te("span", null, Ie(E.label), 1),
                  "value" in E && E.value === e.value ? ($(), we(Z(Je), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 8, vm)
              ], 2))), 128))
            ], 8, hm)
          ]),
          _: 1
        }, 8, ["style"])) : se("", !0)
      ]))
    ], 512));
  }
}), mm = "medium", gm = "default", T2 = ["medium", "small"], A2 = ["default", "info", "warning"], bm = { class: "lc-message-box__headline" }, pm = {
  key: 0,
  class: "lc-message-box__text"
}, L2 = /* @__PURE__ */ ke({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ _n({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: () => mm },
    text: {},
    variant: { default: () => gm }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Ya(e, "modelValue"), r = W(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (o, i) => ($(), we(Z(Gf), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: pe(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: _e(() => [
        te("span", bm, [
          Re(Z(Je), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          te("span", null, Ie(e.headline), 1)
        ])
      ]),
      default: _e(() => [
        he(o.$slots, "default", {}, () => [
          e.text ? ($(), j("p", pm, Ie(e.text), 1)) : se("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
});
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var on;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(on || (on = {}));
const Na = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ks = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Hr = (e, t) => (e.match(new RegExp(Na(t), "g")) || []).length, ym = (e, t) => e.substring(0, e.indexOf(t)), Ss = [
  ",",
  ".",
  "٫",
  "。"
], eo = "(0|[1-9]\\d*)";
class wm {
  constructor(t) {
    var n, r, o, i, a, s;
    const { currency: l, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), p = c.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (o = p.find(({ type: b }) => b === "group")) === null || o === void 0 ? void 0 : o.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (a = u?.min) !== null && a !== void 0 ? a : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (s = u?.max) !== null && s !== void 0 ? s : c.resolvedOptions().maximumFractionDigits);
    const x = (b) => ym(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = x(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = x(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Na(this.decimalSymbol)}(\\d*))?` : "", o = this.stripGroupingSeparator(t).match(new RegExp(`^${eo}${r}$`));
      if (o && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(o[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(o[1])}.${this.onlyDigits(o[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${eo}${Na(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Na(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return Ss.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class _s {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class xm extends _s {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), o = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (c) => {
      if (o(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const s = i(a);
    if (s != null)
      return this.currencyFormat.insertCurrency(s, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = ks(this.currencyFormat.onlyDigits(l)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || o(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class km extends _s {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), o = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${ks(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: o,
      fractionDigits: o.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Sm = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class _m {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Sm,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new wm(this.options), this.numberMask = this.options.autoDecimalDigits ? new km(this.currencyFormat) : new xm(this.currencyFormat);
    const n = {
      [on.precision]: this.currencyFormat.maximumFractionDigits,
      [on.thousands]: 3,
      [on.tenThousands]: 4,
      [on.millions]: 6,
      [on.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== on.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let o;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: s, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(s, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = s = 0), o = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: s
        });
      } else
        o = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(o) && this.currencyFormat.parse(o) !== 0 && (o = o.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = o, this.numberValue = this.currencyFormat.parse(o);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, o = t;
      if (r && o.data && Ss.includes(o.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: s, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Hr(this.formattedValue, v) === Hr(n, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, s.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const o = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(o);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: o, suffix: i, negativeSuffix: a, groupingSymbol: s, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? o : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < u)
        return u;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= u && l !== void 0 && v.includes(l) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && s !== void 0 && (f -= Hr(t.substring(0, n), s)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const Cm = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Em(e, t) {
  var n, r, o, i;
  let a;
  const s = ge(null), l = ge(null), h = ge(null), v = li();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((o = v?.proxy) === null || o === void 0 ? void 0 : o.$props), f = Gs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = W(() => u?.[f ? "modelValue" : "value"]);
  return He(s, (c) => {
    var p;
    if (c) {
      const x = Cm((p = c?.$el) !== null && p !== void 0 ? p : c);
      x ? (a = new _m({
        el: x,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: s,
    numberValue: h,
    formattedValue: l,
    setValue: (c) => a?.setValue(c),
    setOptions: (c) => a?.setOptions(c)
  };
}
const to = 2, $2 = /* @__PURE__ */ ke({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => Ze.general.currency },
    locale: { default: () => Ze.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ba(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: o, inputRef: i, numberValue: a, setValue: s } = Em(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: to,
        valueRange: e.valueRange
      }
    ), l = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = W(
      () => Lt(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (u) => {
      s(Lt(u) ? parseFloat((u / 100).toFixed(to)) : null);
    };
    return St(async () => {
      Lt(e.value) && (await Ga(), v(e.value));
    }), He(h, (u) => {
      n("update:value", u);
    }), He(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => ($(), we(Z(rr), Ce({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: Z(o)
    }), Ka({
      prefix: _e(() => [
        kt(Ie(l.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: _e(() => [
          he(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Tm = ["aria-checked", "aria-label"], I2 = /* @__PURE__ */ ke({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => Ze.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ba(e, ["toggleAriaLabel"]), n = ge("password"), r = W(() => o.value ? "eye-off" : "eye"), o = W(() => n.value === "text"), i = () => {
      n.value = o.value ? "password" : "text";
    };
    return (a, s) => ($(), we(Z(rr), Ce({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: _e(() => [
        te("button", {
          "aria-checked": o.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Re(Z(Je), { name: r.value }, null, 8, ["name"])
        ], 40, Tm),
        he(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), D2 = ["password", "text"], Am = 0, Lm = "medium", O2 = ["medium", "small"], M2 = ["info", "success"], $m = ["aria-valuenow"], R2 = /* @__PURE__ */ ke({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: () => Am },
    size: { default: () => Lm },
    variant: { default: "info" }
  },
  setup(e) {
    const t = W(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), j("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: pe([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Re(Z(Fo), Ce({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Re(xn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: _e(() => [
          ($(), we(Z(Je), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, $m));
  }
}), Ti = /* @__PURE__ */ Symbol(), Im = ["for"], Dm = { class: "lc-radio__control" }, Om = ["id", "aria-labelledby", "data-click-name", "name"], Mm = ["id"], Rm = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Xn(Ti), o = $t(e.id), i = W(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!nt(r?.disabled) || e.disabled,
        "lc-radio--error": !!nt(r?.hasError)
      }
    ]), a = W(() => e.value === nt(r?.value) || e.checked), s = W({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = W(() => {
      if (nt(r?.value))
        return a.value ? 0 : -1;
    }), h = W(() => nt(r?.name) ?? e.name);
    return (v, u) => ($(), j("label", {
      class: pe([i.value, v.$attrs.class]),
      for: Z(o)
    }, [
      te("div", Dm, [
        Qt(te("input", Ce({ id: Z(o) }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => s.value = f),
          "aria-labelledby": e.label ? `${Z(o)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, Om), [
          [Ks, s.value]
        ])
      ]),
      e.label ? ($(), j("span", {
        key: 0,
        id: `${Z(o)}-label`,
        class: pe(["lc-radio__label", e.labelClass])
      }, Ie(e.label), 11, Mm)) : se("", !0)
    ], 10, Im));
  }
}), Fm = { class: "lc-radio-card__main" }, F2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = ct("radio"), n = Xn(Ti), r = W(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), o = W(() => e.value === nt(n?.value) || e.checked), i = W(() => e.disabled || nt(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const s = t.value?.$el?.querySelector("input");
      if (!s) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      s.dispatchEvent(l), s.dispatchEvent(h);
    };
    return (s, l) => ($(), we(Z(wa), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: pe([r.value, s.$attrs.class]),
      onClick: a
    }, {
      default: _e(() => [
        te("div", Fm, [
          Re(Z(Rm), Ce({ ref: "radio" }, {
            ...en(s.$attrs, ["class"]),
            ...s.$props
          }), null, 16),
          he(s.$slots, "default", {
            checked: o.value,
            disabled: i.value
          })
        ]),
        Qt(te("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = ca(() => {
          }, ["stop"]))
        }, [
          he(s.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ui, o.value && s.$slots.underneath]
        ]),
        he(s.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), Nm = ["id", "aria-labelledby"], Pm = ["id"], N2 = /* @__PURE__ */ ke({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), o = W(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = W(() => !!e.errorMessage);
    return St(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), si(Ti, {
      disabled: () => e.disabled,
      hasError: vo(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, s) => ($(), j("fieldset", Ce({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: Z(r),
      "aria-labelledby": e.label ? `${Z(r)}-label` : void 0,
      class: o.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), j("legend", {
        key: 0,
        id: `${Z(r)}-label`,
        class: "lc-radio-group__label"
      }, Ie(e.label), 9, Pm)) : se("", !0),
      te("div", {
        class: pe(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        he(a.$slots, "default")
      ], 2),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, Nm));
  }
}), P2 = ["horizontal", "vertical"], Bm = { class: "lc-rating" }, B2 = /* @__PURE__ */ ke({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), j("div", Bm, [
      ($(!0), j(at, null, yt(new Array(e.max), (r, o) => ($(), j("svg", {
        key: o,
        class: pe(["lc-rating__star", o < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        te("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        te("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), zm = /* @__PURE__ */ ke({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      "aria-hidden": "true",
      class: pe(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Et({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), z2 = ["full", "half", "large", "medium", "none", "small"], Vm = { class: "lc-remote-list__content" }, Hm = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, V2 = /* @__PURE__ */ ke({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = W(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), o = W(() => e.count < e.total), i = () => {
      o.value && n("fetch-more");
    };
    return (a, s) => ($(), j("section", {
      class: pe(r.value)
    }, [
      te("ul", Vm, [
        he(a.$slots, "default"),
        e.loading ? he(a.$slots, "loading", {}, () => [
          ($(!0), j(at, null, yt(e.numberOfSkeletons, (l) => ($(), we(Z(zm), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : se("", !0)
      ]),
      !e.loading && o.value ? ($(), j("div", Hm, [
        he(a.$slots, "load-more", Ot(Pt({ fetchMore: i })), () => [
          Re(Z(Tt), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: _e(() => [
              kt(Ie(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? se("", !0) : ($(), we(Z(hi), { key: 0 }))
      ])) : se("", !0)
    ], 2));
  }
}), Um = { class: "lc-scratchcard-teaser__button-wrap" }, H2 = /* @__PURE__ */ ke({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), we(Z(ir), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: _e(() => [
        Re(Z(fi), Ce({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: _e(() => [
            he(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        te("div", Um, [
          Re(Z(Tt), Ce({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: _e(() => [
              kt(Ie(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), U2 = [...ts];
var Gt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Gt || {});
const qm = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], jm = ["id"], Zm = { class: "lc-select__input" }, Wm = ["id", "aria-activedescendant", "aria-labelledby"], Xm = ["id", "aria-selected", "onClickPassive"], q2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [Ze.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ct("button"), o = ct("container"), i = ct("menu"), a = ct("options"), s = ge(null), l = ge(!1), h = ii({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = ws(r, i, {
      middleware: [ps(), xs, bs(2)],
      whileElementsMounted: gs
    }), { width: u } = Nn(o), f = $t(e.id), m = Ei(), c = W(() => {
      if (!(!l.value || !Lt(s.value)))
        return `${f}-option-${s.value}`;
    }), p = W(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--fixed-value": b.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), x = W(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = W(() => e.options.findIndex((T) => T.value === e.value)), b = W(() => e.notNullable && e.options.length === 1 && !!e.value), _ = W(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), E = W(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = W(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), L = () => {
      l.value && (s.value = null, l.value = !1, e.onBlur?.(), A("focusout"));
    }, A = (T) => {
      const F = r.value;
      if (!F) return;
      h[T] = !0;
      const V = new Event(T, { bubbles: !0 });
      F.dispatchEvent(V);
    }, B = async () => {
      l.value || await z();
    }, H = (T) => {
      const F = T.type;
      if (!X(F)) return;
      h[F] ? h[F] = !1 : T.stopPropagation();
    }, re = async (T) => {
      if (!tn(T.key, Gt)) return;
      T.key !== Gt.Tab && (T.preventDefault(), T.stopPropagation());
      const F = e.options.length - 1;
      switch (T.key) {
        case Gt.ArrowDown:
          if (l.value && Lt(s.value)) {
            s.value = Math.min(F, s.value + 1), C();
            break;
          }
          s.value = 0, await z();
          break;
        case Gt.ArrowUp:
          if (l.value && Lt(s.value)) {
            s.value = Math.max(0, s.value - 1), C();
            break;
          }
          s.value = F, await z();
          break;
        case Gt.Enter:
        case Gt.Space:
          if (l.value && Lt(s.value)) {
            O(e.options[s.value].value);
            break;
          }
          await z();
          break;
        case Gt.Escape:
          L();
          break;
        case Gt.Tab:
          if (!l.value || !Lt(s.value)) break;
          O(e.options[s.value].value);
          break;
      }
    }, O = (T) => {
      const F = e.value === T ? null : T;
      e.notNullable && F === null || (n("update:value", F), L());
    }, X = (T) => T === "focusin" || T === "focusout", z = async () => {
      l.value || (l.value = !0, e.value && (s.value = g.value), A("focusin"), await Ga(), C());
    }, C = () => {
      if (!Lt(s.value)) return;
      a.value?.[s.value]?.scrollIntoView({ block: "center" });
    };
    return Ja(i, L, {
      ignore: [r, ...nt(e.ignoreOutsideClickOn)]
    }), St(() => {
      e.autofocus && r.value?.focus(), e.value && (s.value = g.value);
    }), (T, F) => ($(), j("div", {
      ref: "container",
      class: pe([p.value, T.$attrs.class])
    }, [
      te("button", Ce({
        id: Z(f),
        ref: "button"
      }, en(T.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${Z(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${Z(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: B,
        onFocusin: H,
        onFocusout: H,
        onKeydown: re
      }), [
        !b.value && e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(f)}-label`,
          class: pe(_.value)
        }, Ie(e.label), 11, jm)) : se("", !0),
        te("div", Zm, Ie(x.value), 1),
        b.value ? se("", !0) : ($(), we(Z(Je), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, qm),
      b.value ? se("", !0) : ($(), we(Z(Au), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: _e(() => [
          l.value ? ($(), j("div", {
            key: 0,
            ref: "menu",
            class: pe(E.value),
            style: Et(I.value)
          }, [
            te("ul", {
              id: `${Z(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${Z(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), j(at, null, yt(e.options, (V, q) => ($(), j("li", {
                key: `${V.label}-${V.value}`,
                class: pe(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": s.value === q && Z(m),
                  "lc-select__menu-item--selected": V.value === e.value
                }])
              }, [
                te("button", {
                  id: `${Z(f)}-option-${q}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": V.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (Y) => O(V.value)
                }, [
                  te("span", null, Ie(V.label), 1),
                  V.value === e.value ? ($(), we(Z(Je), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 40, Xm)
              ], 2))), 128))
            ], 8, Wm)
          ], 6)) : se("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), j2 = ["default", "discreet"];
var Wt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Wt || {});
const Ym = ["id", "aria-activedescendant"], Z2 = /* @__PURE__ */ ke({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ct("list"), o = ge(null), i = $t(e.id), a = Ei(), s = W(() => {
      if (Lt(o.value))
        return `${i}-option-${o.value}`;
    }), l = W(() => !r.value || !Lt(o.value) ? null : r.value.querySelectorAll('[role="option"]')[o.value]), h = W(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = W(
      () => e.options.findIndex((E) => E.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (E) => e.optionComponent ? g(E) ? "span" : e.optionComponent : x(E) ? g(E) ? "span" : Yn(E.to) : "button", f = () => {
      a.value && (o.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (o.value = null);
    }, c = (E) => {
      if (!tn(E.key, Wt) || !Lt(o.value))
        return;
      E.preventDefault(), E.stopPropagation();
      const I = e.options.length - 1;
      switch (E.key) {
        case Wt.ArrowDown:
        case Wt.ArrowRight:
          o.value = Math.min(I, o.value + 1);
          break;
        case Wt.ArrowLeft:
        case Wt.ArrowUp:
          o.value = Math.max(0, o.value - 1);
          break;
        case Wt.End:
          o.value = I;
          break;
        case Wt.Enter:
        case Wt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Wt.Home:
          o.value = 0;
          break;
      }
    }, p = (E) => {
      let I;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        I = L.includes(E) ? L.filter((A) => A !== E) : _([...L, E]);
      } else
        I = e.value === E ? void 0 : E;
      n("update:value", I);
    }, x = ({ href: E, to: I }) => !!(E || I), g = (E) => Array.isArray(e.value) ? e.value.includes(E.value) : e.value === E.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, _ = (E) => {
      const I = new Map(e.options.map((L, A) => [L.value, A]));
      return [...E].sort(
        (L, A) => (I.get(L) ?? 1 / 0) - (I.get(A) ?? 1 / 0)
      );
    };
    return St(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), He(o, (E) => {
      E !== null && b();
    }), (E, I) => ($(), j("div", {
      class: pe(h.value)
    }, [
      te("ul", {
        id: Z(i),
        ref: "list",
        "aria-activedescendant": s.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        ($(!0), j(at, null, yt(e.options, (L, A) => ($(), j("li", {
          key: `${L.label}-${L.value}`,
          class: pe(["lc-select-list__item", {
            "lc-select-list__item--focused": o.value === A && Z(a),
            "lc-select-list__item--selected": g(L)
          }]),
          role: "presentation"
        }, [
          ($(), we(Ft(u(L)), Ce({
            id: `${Z(i)}-option-${A}`
          }, { ref_for: !0 }, {
            ...pu(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText || void 0,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: x(L) && !g(L) ? void 0 : "button",
            onClickPassive: (B) => p(L.value)
          }), {
            default: _e(() => [
              te("span", null, Ie(L.label), 1),
              g(L) ? ($(), we(Z(Je), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : se("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, Ym)
    ], 2));
  }
});
function Ma(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function Gm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Cs(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var no = Cs((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function o(c, p) {
      return c.substring(0, p.length) === p;
    }
    function i(c, p) {
      return c.slice(-1 * p.length) === p;
    }
    function a(c, p, x) {
      if ((c[p] || c[x]) && c[p] === c[x]) throw new Error(p);
    }
    function s(c) {
      return typeof c == "number" && isFinite(c);
    }
    function l(c, p) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + p : p)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - p : -p))).toFixed(p);
    }
    function h(c, p, x, g, b, _, E, I, L, A, B, H) {
      var re, O, X, z = H, C = "", T = "";
      return _ && (H = _(H)), !!s(H) && (c !== !1 && parseFloat(H.toFixed(c)) === 0 && (H = 0), H < 0 && (re = !0, H = Math.abs(H)), c !== !1 && (H = l(H, c)), (H = H.toString()).indexOf(".") !== -1 ? (X = (O = H.split("."))[0], x && (C = x + O[1])) : X = H, p && (X = r(X).match(/.{1,3}/g), X = r(X.join(r(p)))), re && I && (T += I), g && (T += g), re && L && (T += L), T += X, T += C, b && (T += b), A && (T = A(T, z)), T);
    }
    function v(c, p, x, g, b, _, E, I, L, A, B, H) {
      var re, O = "";
      return B && (H = B(H)), !(!H || typeof H != "string") && (I && o(H, I) && (H = H.replace(I, ""), re = !0), g && o(H, g) && (H = H.replace(g, "")), L && o(H, L) && (H = H.replace(L, ""), re = !0), b && i(H, b) && (H = H.slice(0, -1 * b.length)), p && (H = H.split(p).join("")), x && (H = H.replace(x, ".")), re && (O += "-"), (O = (O += H).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), E && (O = E(O)), !!s(O) && O));
    }
    function u(c) {
      var p, x, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), p = 0; p < n.length; p += 1) if ((g = c[x = n[p]]) === void 0) x !== "negative" || b.negativeBefore ? x === "mark" && b.thousand !== "." ? b[x] = "." : b[x] = !1 : b[x] = "-";
      else if (x === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(x);
        b[x] = g;
      } else if (x === "encoder" || x === "decoder" || x === "edit" || x === "undo") {
        if (typeof g != "function") throw new Error(x);
        b[x] = g;
      } else {
        if (typeof g != "string") throw new Error(x);
        b[x] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(c, p, x) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(c[n[g]]);
      return b.push(x), p.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(p) {
        return f(c, h, p);
      }, this.from = function(p) {
        return f(c, v, p);
      });
    }
    return m;
  })();
})), Km = Gm(Cs((function(e, t) {
  (function(n) {
    function r(R) {
      return o(R) && typeof R.from == "function";
    }
    function o(R) {
      return typeof R == "object" && typeof R.to == "function";
    }
    function i(R) {
      R.parentElement.removeChild(R);
    }
    function a(R) {
      return R != null;
    }
    function s(R) {
      R.preventDefault();
    }
    function l(R) {
      return R.filter((function(S) {
        return !this[S] && (this[S] = !0);
      }), {});
    }
    function h(R, S) {
      return Math.round(R / S) * S;
    }
    function v(R, S) {
      var w = R.getBoundingClientRect(), K = R.ownerDocument, M = K.documentElement, ie = _(K);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (ie.x = 0), S ? w.top + ie.y - M.clientTop : w.left + ie.x - M.clientLeft;
    }
    function u(R) {
      return typeof R == "number" && !isNaN(R) && isFinite(R);
    }
    function f(R, S, w) {
      w > 0 && (x(R, S), setTimeout((function() {
        g(R, S);
      }), w));
    }
    function m(R) {
      return Math.max(Math.min(R, 100), 0);
    }
    function c(R) {
      return Array.isArray(R) ? R : [R];
    }
    function p(R) {
      var S = (R = String(R)).split(".");
      return S.length > 1 ? S[1].length : 0;
    }
    function x(R, S) {
      R.classList && !/\s/.test(S) ? R.classList.add(S) : R.className += " " + S;
    }
    function g(R, S) {
      R.classList && !/\s/.test(S) ? R.classList.remove(S) : R.className = R.className.replace(new RegExp("(^|\\b)" + S.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(R, S) {
      return R.classList ? R.classList.contains(S) : new RegExp("\\b" + S + "\\b").test(R.className);
    }
    function _(R) {
      var S = window.pageXOffset !== void 0, w = (R.compatMode || "") === "CSS1Compat";
      return { x: S ? window.pageXOffset : w ? R.documentElement.scrollLeft : R.body.scrollLeft, y: S ? window.pageYOffset : w ? R.documentElement.scrollTop : R.body.scrollTop };
    }
    function E() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var R = !1;
      try {
        var S = Object.defineProperty({}, "passive", { get: function() {
          R = !0;
        } });
        window.addEventListener("test", null, S);
      } catch {
      }
      return R;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function A(R, S) {
      return 100 / (S - R);
    }
    function B(R, S, w) {
      return 100 * S / (R[w + 1] - R[w]);
    }
    function H(R, S) {
      return B(R, R[0] < 0 ? S + Math.abs(R[0]) : S - R[0], 0);
    }
    function re(R, S) {
      return S * (R[1] - R[0]) / 100 + R[0];
    }
    function O(R, S) {
      for (var w = 1; R >= S[w]; ) w += 1;
      return w;
    }
    function X(R, S, w) {
      if (w >= R.slice(-1)[0]) return 100;
      var K = O(w, R), M = R[K - 1], ie = R[K], D = S[K - 1], J = S[K];
      return D + H([M, ie], w) / A(D, J);
    }
    function z(R, S, w) {
      if (w >= 100) return R.slice(-1)[0];
      var K = O(w, S), M = R[K - 1], ie = R[K], D = S[K - 1];
      return re([M, ie], (w - D) * A(D, S[K]));
    }
    function C(R, S, w, K) {
      if (K === 100) return K;
      var M = O(K, R), ie = R[M - 1], D = R[M];
      return w ? K - ie > (D - ie) / 2 ? D : ie : S[M - 1] ? R[M - 1] + h(K - R[M - 1], S[M - 1]) : K;
    }
    var T, F;
    n.PipsMode = void 0, (F = n.PipsMode || (n.PipsMode = {})).Range = "range", F.Steps = "steps", F.Positions = "positions", F.Count = "count", F.Values = "values", n.PipsType = void 0, (T = n.PipsType || (n.PipsType = {}))[T.None = -1] = "None", T[T.NoValue = 0] = "NoValue", T[T.LargeValue = 1] = "LargeValue", T[T.SmallValue = 2] = "SmallValue";
    var V = (function() {
      function R(S, w, K) {
        var M;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [K || !1], this.xNumSteps = [!1], this.snap = w;
        var ie = [];
        for (Object.keys(S).forEach((function(D) {
          ie.push([c(S[D]), D]);
        })), ie.sort((function(D, J) {
          return D[0][0] - J[0][0];
        })), M = 0; M < ie.length; M++) this.handleEntryPoint(ie[M][1], ie[M][0]);
        for (this.xNumSteps = this.xSteps.slice(0), M = 0; M < this.xNumSteps.length; M++) this.handleStepPoint(M, this.xNumSteps[M]);
      }
      return R.prototype.getDistance = function(S) {
        for (var w = [], K = 0; K < this.xNumSteps.length - 1; K++) w[K] = B(this.xVal, S, K);
        return w;
      }, R.prototype.getAbsoluteDistance = function(S, w, K) {
        var M, ie = 0;
        if (S < this.xPct[this.xPct.length - 1]) for (; S > this.xPct[ie + 1]; ) ie++;
        else S === this.xPct[this.xPct.length - 1] && (ie = this.xPct.length - 2);
        K || S !== this.xPct[ie + 1] || ie++, w === null && (w = []);
        var D = 1, J = w[ie], y = 0, ce = 0, Te = 0, d = 0;
        for (M = K ? (S - this.xPct[ie]) / (this.xPct[ie + 1] - this.xPct[ie]) : (this.xPct[ie + 1] - S) / (this.xPct[ie + 1] - this.xPct[ie]); J > 0; ) y = this.xPct[ie + 1 + d] - this.xPct[ie + d], w[ie + d] * D + 100 - 100 * M > 100 ? (ce = y * M, D = (J - 100 * M) / w[ie + d], M = 1) : (ce = w[ie + d] * y / 100 * D, D = 0), K ? (Te -= ce, this.xPct.length + d >= 1 && d--) : (Te += ce, this.xPct.length - d >= 1 && d++), J = w[ie + d] * D;
        return S + Te;
      }, R.prototype.toStepping = function(S) {
        return S = X(this.xVal, this.xPct, S);
      }, R.prototype.fromStepping = function(S) {
        return z(this.xVal, this.xPct, S);
      }, R.prototype.getStep = function(S) {
        return S = C(this.xPct, this.xSteps, this.snap, S);
      }, R.prototype.getDefaultStep = function(S, w, K) {
        var M = O(S, this.xPct);
        return (S === 100 || w && S === this.xPct[M - 1]) && (M = Math.max(M - 1, 1)), (this.xVal[M] - this.xVal[M - 1]) / K;
      }, R.prototype.getNearbySteps = function(S) {
        var w = O(S, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, R.prototype.countStepDecimals = function() {
        var S = this.xNumSteps.map(p);
        return Math.max.apply(null, S);
      }, R.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, R.prototype.convert = function(S) {
        return this.getStep(this.toStepping(S));
      }, R.prototype.handleEntryPoint = function(S, w) {
        var K;
        if (!u(K = S === "min" ? 0 : S === "max" ? 100 : parseFloat(S)) || !u(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(K), this.xVal.push(w[0]);
        var M = Number(w[1]);
        K ? this.xSteps.push(!isNaN(M) && M) : isNaN(M) || (this.xSteps[0] = M), this.xHighestCompleteStep.push(0);
      }, R.prototype.handleStepPoint = function(S, w) {
        if (w) if (this.xVal[S] !== this.xVal[S + 1]) {
          this.xSteps[S] = B([this.xVal[S], this.xVal[S + 1]], w, 0) / A(this.xPct[S], this.xPct[S + 1]);
          var K = (this.xVal[S + 1] - this.xVal[S]) / this.xNumSteps[S], M = Math.ceil(Number(K.toFixed(3)) - 1), ie = this.xVal[S] + this.xNumSteps[S] * M;
          this.xHighestCompleteStep[S] = ie;
        } else this.xSteps[S] = this.xHighestCompleteStep[S] = this.xVal[S];
      }, R;
    })(), q = { to: function(R) {
      return R === void 0 ? "" : R.toFixed(2);
    }, from: Number }, Y = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, U = { tooltips: ".__tooltips", aria: ".__aria" };
    function oe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'step' is not numeric.");
      R.singleStep = S;
    }
    function ae(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      R.keyboardPageMultiplier = S;
    }
    function fe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      R.keyboardMultiplier = S;
    }
    function be(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      R.keyboardDefaultStep = S;
    }
    function Se(R, S) {
      if (typeof S != "object" || Array.isArray(S)) throw new Error("noUiSlider: 'range' is not an object.");
      if (S.min === void 0 || S.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      R.spectrum = new V(S, R.snap || !1, R.singleStep);
    }
    function de(R, S) {
      if (S = c(S), !Array.isArray(S) || !S.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      R.handles = S.length, R.start = S;
    }
    function ye(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      R.snap = S;
    }
    function Ae(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      R.animate = S;
    }
    function Oe(R, S) {
      if (typeof S != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      R.animationDuration = S;
    }
    function We(R, S) {
      var w, K = [!1];
      if (S === "lower" ? S = [!0, !1] : S === "upper" && (S = [!1, !0]), S === !0 || S === !1) {
        for (w = 1; w < R.handles; w++) K.push(S);
        K.push(!1);
      } else {
        if (!Array.isArray(S) || !S.length || S.length !== R.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        K = S;
      }
      R.connect = K;
    }
    function Ne(R, S) {
      switch (S) {
        case "horizontal":
          R.ort = 0;
          break;
        case "vertical":
          R.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function ue(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      S !== 0 && (R.margin = R.spectrum.getDistance(S));
    }
    function Fe(R, S) {
      if (!u(S)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (R.limit = R.spectrum.getDistance(S), !R.limit || R.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function qe(R, S) {
      var w;
      if (!u(S) && !Array.isArray(S)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(S) && S.length !== 2 && !u(S[0]) && !u(S[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (S !== 0) {
        for (Array.isArray(S) || (S = [S, S]), R.padding = [R.spectrum.getDistance(S[0]), R.spectrum.getDistance(S[1])], w = 0; w < R.spectrum.xNumSteps.length - 1; w++) if (R.padding[0][w] < 0 || R.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var K = S[0] + S[1], M = R.spectrum.xVal[0];
        if (K / (R.spectrum.xVal[R.spectrum.xVal.length - 1] - M) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function je(R, S) {
      switch (S) {
        case "ltr":
          R.dir = 0;
          break;
        case "rtl":
          R.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function Xe(R, S) {
      if (typeof S != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = S.indexOf("tap") >= 0, K = S.indexOf("drag") >= 0, M = S.indexOf("fixed") >= 0, ie = S.indexOf("snap") >= 0, D = S.indexOf("hover") >= 0, J = S.indexOf("unconstrained") >= 0, y = S.indexOf("drag-all") >= 0, ce = S.indexOf("smooth-steps") >= 0;
      if (M) {
        if (R.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        ue(R, R.start[1] - R.start[0]);
      }
      if (J && (R.margin || R.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      R.events = { tap: w || ie, drag: K, dragAll: y, smoothSteps: ce, fixed: M, snap: ie, hover: D, unconstrained: J };
    }
    function Ve(R, S) {
      if (S !== !1) if (S === !0 || o(S)) {
        R.tooltips = [];
        for (var w = 0; w < R.handles; w++) R.tooltips.push(S);
      } else {
        if ((S = c(S)).length !== R.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        S.forEach((function(K) {
          if (typeof K != "boolean" && !o(K)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), R.tooltips = S;
      }
    }
    function Pe(R, S) {
      if (S.length !== R.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      R.handleAttributes = S;
    }
    function rt(R, S) {
      if (!o(S)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      R.ariaFormat = S;
    }
    function ut(R, S) {
      if (!r(S)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      R.format = S;
    }
    function me(R, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      R.keyboardSupport = S;
    }
    function Be(R, S) {
      R.documentElement = S;
    }
    function ze(R, S) {
      if (typeof S != "string" && S !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      R.cssPrefix = S;
    }
    function Ke(R, S) {
      if (typeof S != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof R.cssPrefix == "string" ? (R.cssClasses = {}, Object.keys(S).forEach((function(w) {
        R.cssClasses[w] = R.cssPrefix + S[w];
      }))) : R.cssClasses = S;
    }
    function Qe(R) {
      var S = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: q, format: q }, w = { step: { r: !1, t: oe }, keyboardPageMultiplier: { r: !1, t: ae }, keyboardMultiplier: { r: !1, t: fe }, keyboardDefaultStep: { r: !1, t: be }, start: { r: !0, t: de }, connect: { r: !0, t: We }, direction: { r: !0, t: je }, snap: { r: !1, t: ye }, animate: { r: !1, t: Ae }, animationDuration: { r: !1, t: Oe }, range: { r: !0, t: Se }, orientation: { r: !1, t: Ne }, margin: { r: !1, t: ue }, limit: { r: !1, t: Fe }, padding: { r: !1, t: qe }, behaviour: { r: !0, t: Xe }, ariaFormat: { r: !1, t: rt }, format: { r: !1, t: ut }, tooltips: { r: !1, t: Ve }, keyboardSupport: { r: !0, t: me }, documentElement: { r: !1, t: Be }, cssPrefix: { r: !0, t: ze }, cssClasses: { r: !0, t: Ke }, handleAttributes: { r: !1, t: Pe } }, K = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: Y, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      R.format && !R.ariaFormat && (R.ariaFormat = R.format), Object.keys(w).forEach((function(y) {
        if (a(R[y]) || K[y] !== void 0) w[y].t(S, a(R[y]) ? R[y] : K[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), S.pips = R.pips;
      var M = document.createElement("div"), ie = M.style.msTransform !== void 0, D = M.style.transform !== void 0;
      S.transformRule = D ? "transform" : ie ? "msTransform" : "webkitTransform";
      var J = [["left", "top"], ["right", "bottom"]];
      return S.style = J[S.dir][S.ort], S;
    }
    function ht(R, S, w) {
      var K, M, ie, D, J, y = E(), ce = L() && I(), Te = R, d = S.spectrum, ne = [], ee = [], k = [], N = 0, Q = {}, $e = R.ownerDocument, xe = S.documentElement || $e.documentElement, Le = $e.body, Ye = $e.dir === "rtl" || S.ort === 1 ? 0 : 100;
      function wt(P, G) {
        var le = $e.createElement("div");
        return G && x(le, G), P.appendChild(le), le;
      }
      function lt(P, G) {
        var le = wt(P, S.cssClasses.origin), ve = wt(le, S.cssClasses.handle);
        if (wt(ve, S.cssClasses.touchArea), ve.setAttribute("data-handle", String(G)), S.keyboardSupport && (ve.setAttribute("tabindex", "0"), ve.addEventListener("keydown", (function(Ee) {
          return Ms(Ee, G);
        }))), S.handleAttributes !== void 0) {
          var De = S.handleAttributes[G];
          Object.keys(De).forEach((function(Ee) {
            ve.setAttribute(Ee, De[Ee]);
          }));
        }
        return ve.setAttribute("role", "slider"), ve.setAttribute("aria-orientation", S.ort ? "vertical" : "horizontal"), G === 0 ? x(ve, S.cssClasses.handleLower) : G === S.handles - 1 && x(ve, S.cssClasses.handleUpper), le;
      }
      function Ge(P, G) {
        return !!G && wt(P, S.cssClasses.connect);
      }
      function mt(P, G) {
        var le = wt(G, S.cssClasses.connects);
        M = [], (ie = []).push(Ge(le, P[0]));
        for (var ve = 0; ve < S.handles; ve++) M.push(lt(G, ve)), k[ve] = ve, ie.push(Ge(le, P[ve + 1]));
      }
      function _t(P) {
        return x(P, S.cssClasses.target), S.dir === 0 ? x(P, S.cssClasses.ltr) : x(P, S.cssClasses.rtl), S.ort === 0 ? x(P, S.cssClasses.horizontal) : x(P, S.cssClasses.vertical), x(P, getComputedStyle(P).direction === "rtl" ? S.cssClasses.textDirectionRtl : S.cssClasses.textDirectionLtr), wt(P, S.cssClasses.base);
      }
      function At(P, G) {
        return !(!S.tooltips || !S.tooltips[G]) && wt(P.firstChild, S.cssClasses.tooltip);
      }
      function hn() {
        return Te.hasAttribute("disabled");
      }
      function an(P) {
        return M[P].hasAttribute("disabled");
      }
      function ot() {
        J && (Gn("update" + U.tooltips), J.forEach((function(P) {
          P && i(P);
        })), J = null);
      }
      function It() {
        ot(), J = M.map(At), gr("update" + U.tooltips, (function(P, G, le) {
          if (J && S.tooltips && J[G] !== !1) {
            var ve = P[G];
            S.tooltips[G] !== !0 && (ve = S.tooltips[G].to(le[G])), J[G].innerHTML = ve;
          }
        }));
      }
      function xt() {
        Gn("update" + U.aria), gr("update" + U.aria, (function(P, G, le, ve, De) {
          k.forEach((function(Ee) {
            var Ue = M[Ee], Me = Sa(ee, Ee, 0, !0, !0, !0), bt = Sa(ee, Ee, 100, !0, !0, !0), ft = De[Ee], it = String(S.ariaFormat.to(le[Ee]));
            Me = d.fromStepping(Me).toFixed(1), bt = d.fromStepping(bt).toFixed(1), ft = d.fromStepping(ft).toFixed(1), Ue.children[0].setAttribute("aria-valuemin", Me), Ue.children[0].setAttribute("aria-valuemax", bt), Ue.children[0].setAttribute("aria-valuenow", ft), Ue.children[0].setAttribute("aria-valuetext", it);
          }));
        }));
      }
      function Vt(P) {
        if (P.mode === n.PipsMode.Range || P.mode === n.PipsMode.Steps) return d.xVal;
        if (P.mode === n.PipsMode.Count) {
          if (P.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var G = P.values - 1, le = 100 / G, ve = []; G--; ) ve[G] = G * le;
          return ve.push(100), Nt(ve, P.stepped);
        }
        return P.mode === n.PipsMode.Positions ? Nt(P.values, P.stepped) : P.mode === n.PipsMode.Values ? P.stepped ? P.values.map((function(De) {
          return d.fromStepping(d.getStep(d.toStepping(De)));
        })) : P.values : [];
      }
      function Nt(P, G) {
        return P.map((function(le) {
          return d.fromStepping(G ? d.getStep(le) : le);
        }));
      }
      function ka(P) {
        function G(ft, it) {
          return Number((ft + it).toFixed(7));
        }
        var le = Vt(P), ve = {}, De = d.xVal[0], Ee = d.xVal[d.xVal.length - 1], Ue = !1, Me = !1, bt = 0;
        return (le = l(le.slice().sort((function(ft, it) {
          return ft - it;
        }))))[0] !== De && (le.unshift(De), Ue = !0), le[le.length - 1] !== Ee && (le.push(Ee), Me = !0), le.forEach((function(ft, it) {
          var st, tt, Ct, Dt, pt, Ni, yr, Pi, Bi, zi, wr = ft, Dn = le[it + 1], Vi = P.mode === n.PipsMode.Steps;
          for (Vi && (st = d.xNumSteps[it]), st || (st = Dn - wr), Dn === void 0 && (Dn = wr), st = Math.max(st, 1e-7), tt = wr; tt <= Dn; tt = G(tt, st)) {
            for (Pi = (pt = (Dt = d.toStepping(tt)) - bt) / (P.density || 1), zi = pt / (Bi = Math.round(Pi)), Ct = 1; Ct <= Bi; Ct += 1) ve[(Ni = bt + Ct * zi).toFixed(5)] = [d.fromStepping(Ni), 0];
            yr = le.indexOf(tt) > -1 ? n.PipsType.LargeValue : Vi ? n.PipsType.SmallValue : n.PipsType.NoValue, !it && Ue && tt !== Dn && (yr = 0), tt === Dn && Me || (ve[Dt.toFixed(5)] = [tt, yr]), bt = Dt;
          }
        })), ve;
      }
      function Ts(P, G, le) {
        var ve, De, Ee = $e.createElement("div"), Ue = ((ve = {})[n.PipsType.None] = "", ve[n.PipsType.NoValue] = S.cssClasses.valueNormal, ve[n.PipsType.LargeValue] = S.cssClasses.valueLarge, ve[n.PipsType.SmallValue] = S.cssClasses.valueSub, ve), Me = ((De = {})[n.PipsType.None] = "", De[n.PipsType.NoValue] = S.cssClasses.markerNormal, De[n.PipsType.LargeValue] = S.cssClasses.markerLarge, De[n.PipsType.SmallValue] = S.cssClasses.markerSub, De), bt = [S.cssClasses.valueHorizontal, S.cssClasses.valueVertical], ft = [S.cssClasses.markerHorizontal, S.cssClasses.markerVertical];
        function it(tt, Ct) {
          var Dt = Ct === S.cssClasses.value, pt = Dt ? Ue : Me;
          return Ct + " " + (Dt ? bt : ft)[S.ort] + " " + pt[tt];
        }
        function st(tt, Ct, Dt) {
          if ((Dt = G ? G(Ct, Dt) : Dt) !== n.PipsType.None) {
            var pt = wt(Ee, !1);
            pt.className = it(Dt, S.cssClasses.marker), pt.style[S.style] = tt + "%", Dt > n.PipsType.NoValue && ((pt = wt(Ee, !1)).className = it(Dt, S.cssClasses.value), pt.setAttribute("data-value", String(Ct)), pt.style[S.style] = tt + "%", pt.innerHTML = String(le.to(Ct)));
          }
        }
        return x(Ee, S.cssClasses.pips), x(Ee, S.ort === 0 ? S.cssClasses.pipsHorizontal : S.cssClasses.pipsVertical), Object.keys(P).forEach((function(tt) {
          st(tt, P[tt][0], P[tt][1]);
        })), Ee;
      }
      function fr() {
        D && (i(D), D = null);
      }
      function hr(P) {
        fr();
        var G = ka(P), le = P.filter, ve = P.format || { to: function(De) {
          return String(Math.round(De));
        } };
        return D = Te.appendChild(Ts(G, le, ve));
      }
      function Li() {
        var P = K.getBoundingClientRect(), G = "offset" + ["Width", "Height"][S.ort];
        return S.ort === 0 ? P.width || K[G] : P.height || K[G];
      }
      function vn(P, G, le, ve) {
        var De = function(Ue) {
          var Me = As(Ue, ve.pageOffset, ve.target || G);
          return !!Me && !(hn() && !ve.doNotReject) && !(b(Te, S.cssClasses.tap) && !ve.doNotReject) && !(P === y.start && Me.buttons !== void 0 && Me.buttons > 1) && (!ve.hover || !Me.buttons) && (ce || Me.preventDefault(), Me.calcPoint = Me.points[S.ort], void le(Me, ve));
        }, Ee = [];
        return P.split(" ").forEach((function(Ue) {
          G.addEventListener(Ue, De, !!ce && { passive: !0 }), Ee.push([Ue, De]);
        })), Ee;
      }
      function As(P, G, le) {
        var ve = P.type.indexOf("touch") === 0, De = P.type.indexOf("mouse") === 0, Ee = P.type.indexOf("pointer") === 0, Ue = 0, Me = 0;
        if (P.type.indexOf("MSPointer") === 0 && (Ee = !0), P.type === "mousedown" && !P.buttons && !P.touches) return !1;
        if (ve) {
          var bt = function(st) {
            var tt = st.target;
            return tt === le || le.contains(tt) || P.composed && P.composedPath().shift() === le;
          };
          if (P.type === "touchstart") {
            var ft = Array.prototype.filter.call(P.touches, bt);
            if (ft.length > 1) return !1;
            Ue = ft[0].pageX, Me = ft[0].pageY;
          } else {
            var it = Array.prototype.find.call(P.changedTouches, bt);
            if (!it) return !1;
            Ue = it.pageX, Me = it.pageY;
          }
        }
        return G = G || _($e), (De || Ee) && (Ue = P.clientX + G.x, Me = P.clientY + G.y), P.pageOffset = G, P.points = [Ue, Me], P.cursor = De || Ee, P;
      }
      function $i(P) {
        var G = 100 * (P - v(K, S.ort)) / Li();
        return G = m(G), S.dir ? 100 - G : G;
      }
      function Ls(P) {
        var G = 100, le = !1;
        return M.forEach((function(ve, De) {
          if (!an(De)) {
            var Ee = ee[De], Ue = Math.abs(Ee - P);
            (Ue < G || Ue <= G && P > Ee || Ue === 100 && G === 100) && (le = De, G = Ue);
          }
        })), le;
      }
      function $s(P, G) {
        P.type === "mouseout" && P.target.nodeName === "HTML" && P.relatedTarget === null && vr(P, G);
      }
      function Is(P, G) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && P.buttons === 0 && G.buttonsProperty !== 0) return vr(P, G);
        var le = (S.dir ? -1 : 1) * (P.calcPoint - G.startCalcPoint);
        Ii(le > 0, 100 * le / G.baseSize, G.locations, G.handleNumbers, G.connect);
      }
      function vr(P, G) {
        G.handle && (g(G.handle, S.cssClasses.active), N -= 1), G.listeners.forEach((function(le) {
          xe.removeEventListener(le[0], le[1]);
        })), N === 0 && (g(Te, S.cssClasses.drag), pr(), P.cursor && (Le.style.cursor = "", Le.removeEventListener("selectstart", s))), S.events.smoothSteps && (G.handleNumbers.forEach((function(le) {
          mn(le, ee[le], !0, !0, !1, !1);
        })), G.handleNumbers.forEach((function(le) {
          gt("update", le);
        }))), G.handleNumbers.forEach((function(le) {
          gt("change", le), gt("set", le), gt("end", le);
        }));
      }
      function mr(P, G) {
        if (!G.handleNumbers.some(an)) {
          var le;
          G.handleNumbers.length === 1 && (le = M[G.handleNumbers[0]].children[0], N += 1, x(le, S.cssClasses.active)), P.stopPropagation();
          var ve = [], De = vn(y.move, xe, Is, { target: P.target, handle: le, connect: G.connect, listeners: ve, startCalcPoint: P.calcPoint, baseSize: Li(), pageOffset: P.pageOffset, handleNumbers: G.handleNumbers, buttonsProperty: P.buttons, locations: ee.slice() }), Ee = vn(y.end, xe, vr, { target: P.target, handle: le, listeners: ve, doNotReject: !0, handleNumbers: G.handleNumbers }), Ue = vn("mouseout", xe, $s, { target: P.target, handle: le, listeners: ve, doNotReject: !0, handleNumbers: G.handleNumbers });
          ve.push.apply(ve, De.concat(Ee, Ue)), P.cursor && (Le.style.cursor = getComputedStyle(P.target).cursor, M.length > 1 && x(Te, S.cssClasses.drag), Le.addEventListener("selectstart", s, !1)), G.handleNumbers.forEach((function(Me) {
            gt("start", Me);
          }));
        }
      }
      function Ds(P) {
        P.stopPropagation();
        var G = $i(P.calcPoint), le = Ls(G);
        le !== !1 && (S.events.snap || f(Te, S.cssClasses.tap, S.animationDuration), mn(le, G, !0, !0), pr(), gt("slide", le, !0), gt("update", le, !0), S.events.snap ? mr(P, { handleNumbers: [le] }) : (gt("change", le, !0), gt("set", le, !0)));
      }
      function Os(P) {
        var G = $i(P.calcPoint), le = d.getStep(G), ve = d.fromStepping(le);
        Object.keys(Q).forEach((function(De) {
          De.split(".")[0] === "hover" && Q[De].forEach((function(Ee) {
            Ee.call(Ca, ve);
          }));
        }));
      }
      function Ms(P, G) {
        if (hn() || an(G)) return !1;
        var le = ["Left", "Right"], ve = ["Down", "Up"], De = ["PageDown", "PageUp"], Ee = ["Home", "End"];
        S.dir && !S.ort ? le.reverse() : S.ort && !S.dir && (ve.reverse(), De.reverse());
        var Ue, Me = P.key.replace("Arrow", ""), bt = Me === De[0], ft = Me === De[1], it = Me === ve[0] || Me === le[0] || bt, st = Me === ve[1] || Me === le[1] || ft, tt = Me === Ee[0], Ct = Me === Ee[1];
        if (!(it || st || tt || Ct)) return !0;
        if (P.preventDefault(), st || it) {
          var Dt = it ? 0 : 1, pt = Fi(G)[Dt];
          if (pt === null) return !1;
          pt === !1 && (pt = d.getDefaultStep(ee[G], it, S.keyboardDefaultStep)), pt *= ft || bt ? S.keyboardPageMultiplier : S.keyboardMultiplier, pt = Math.max(pt, 1e-7), pt *= it ? -1 : 1, Ue = ne[G] + pt;
        } else Ue = Ct ? S.spectrum.xVal[S.spectrum.xVal.length - 1] : S.spectrum.xVal[0];
        return mn(G, d.toStepping(Ue), !0, !0), gt("slide", G), gt("update", G), gt("change", G), gt("set", G), !1;
      }
      function Rs(P) {
        P.fixed || M.forEach((function(G, le) {
          vn(y.start, G.children[0], mr, { handleNumbers: [le] });
        })), P.tap && vn(y.start, K, Ds, {}), P.hover && vn(y.move, K, Os, { hover: !0 }), P.drag && ie.forEach((function(G, le) {
          if (G !== !1 && le !== 0 && le !== ie.length - 1) {
            var ve = M[le - 1], De = M[le], Ee = [G], Ue = [ve, De], Me = [le - 1, le];
            x(G, S.cssClasses.draggable), P.fixed && (Ee.push(ve.children[0]), Ee.push(De.children[0])), P.dragAll && (Ue = M, Me = k), Ee.forEach((function(bt) {
              vn(y.start, bt, mr, { handles: Ue, handleNumbers: Me, connect: G });
            }));
          }
        }));
      }
      function gr(P, G) {
        Q[P] = Q[P] || [], Q[P].push(G), P.split(".")[0] === "update" && M.forEach((function(le, ve) {
          gt("update", ve);
        }));
      }
      function Fs(P) {
        return P === U.aria || P === U.tooltips;
      }
      function Gn(P) {
        var G = P && P.split(".")[0], le = G ? P.substring(G.length) : P;
        Object.keys(Q).forEach((function(ve) {
          var De = ve.split(".")[0], Ee = ve.substring(De.length);
          G && G !== De || le && le !== Ee || Fs(Ee) && le !== Ee || delete Q[ve];
        }));
      }
      function gt(P, G, le) {
        Object.keys(Q).forEach((function(ve) {
          var De = ve.split(".")[0];
          P === De && Q[ve].forEach((function(Ee) {
            Ee.call(Ca, ne.map(S.format.to), G, ne.slice(), le || !1, ee.slice(), Ca);
          }));
        }));
      }
      function Sa(P, G, le, ve, De, Ee, Ue) {
        var Me;
        return M.length > 1 && !S.events.unconstrained && (ve && G > 0 && (Me = d.getAbsoluteDistance(P[G - 1], S.margin, !1), le = Math.max(le, Me)), De && G < M.length - 1 && (Me = d.getAbsoluteDistance(P[G + 1], S.margin, !0), le = Math.min(le, Me))), M.length > 1 && S.limit && (ve && G > 0 && (Me = d.getAbsoluteDistance(P[G - 1], S.limit, !1), le = Math.min(le, Me)), De && G < M.length - 1 && (Me = d.getAbsoluteDistance(P[G + 1], S.limit, !0), le = Math.max(le, Me))), S.padding && (G === 0 && (Me = d.getAbsoluteDistance(0, S.padding[0], !1), le = Math.max(le, Me)), G === M.length - 1 && (Me = d.getAbsoluteDistance(100, S.padding[1], !0), le = Math.min(le, Me))), Ue || (le = d.getStep(le)), !((le = m(le)) === P[G] && !Ee) && le;
      }
      function br(P, G) {
        var le = S.ort;
        return (le ? G : P) + ", " + (le ? P : G);
      }
      function Ii(P, G, le, ve, De) {
        var Ee = le.slice(), Ue = ve[0], Me = S.events.smoothSteps, bt = [!P, P], ft = [P, !P];
        ve = ve.slice(), P && ve.reverse(), ve.length > 1 ? ve.forEach((function(st, tt) {
          var Ct = Sa(Ee, st, Ee[st] + G, bt[tt], ft[tt], !1, Me);
          Ct === !1 ? G = 0 : (G = Ct - Ee[st], Ee[st] = Ct);
        })) : bt = ft = [!0];
        var it = !1;
        ve.forEach((function(st, tt) {
          it = mn(st, le[st] + G, bt[tt], ft[tt], !1, Me) || it;
        })), it && (ve.forEach((function(st) {
          gt("update", st), gt("slide", st);
        })), De != null && gt("drag", Ue));
      }
      function Di(P, G) {
        return S.dir ? 100 - P - G : P;
      }
      function Ns(P, G) {
        ee[P] = G, ne[P] = d.fromStepping(G);
        var le = "translate(" + br(Di(G, 0) - Ye + "%", "0") + ")";
        M[P].style[S.transformRule] = le, Oi(P), Oi(P + 1);
      }
      function pr() {
        k.forEach((function(P) {
          var G = ee[P] > 50 ? -1 : 1, le = 3 + (M.length + G * P);
          M[P].style.zIndex = String(le);
        }));
      }
      function mn(P, G, le, ve, De, Ee) {
        return De || (G = Sa(ee, P, G, le, ve, !1, Ee)), G !== !1 && (Ns(P, G), !0);
      }
      function Oi(P) {
        if (ie[P]) {
          var G = 0, le = 100;
          P !== 0 && (G = ee[P - 1]), P !== ie.length - 1 && (le = ee[P]);
          var ve = le - G, De = "translate(" + br(Di(G, ve) + "%", "0") + ")", Ee = "scale(" + br(ve / 100, "1") + ")";
          ie[P].style[S.transformRule] = De + " " + Ee;
        }
      }
      function Mi(P, G) {
        return P === null || P === !1 || P === void 0 ? ee[G] : (typeof P == "number" && (P = String(P)), (P = S.format.from(P)) !== !1 && (P = d.toStepping(P)), P === !1 || isNaN(P) ? ee[G] : P);
      }
      function _a(P, G, le) {
        var ve = c(P), De = ee[0] === void 0;
        G = G === void 0 || G, S.animate && !De && f(Te, S.cssClasses.tap, S.animationDuration), k.forEach((function(Me) {
          mn(Me, Mi(ve[Me], Me), !0, !1, le);
        }));
        var Ee = k.length === 1 ? 0 : 1;
        if (De && d.hasNoSize() && (le = !0, ee[0] = 0, k.length > 1)) {
          var Ue = 100 / (k.length - 1);
          k.forEach((function(Me) {
            ee[Me] = Me * Ue;
          }));
        }
        for (; Ee < k.length; ++Ee) k.forEach((function(Me) {
          mn(Me, ee[Me], !0, !0, le);
        }));
        pr(), k.forEach((function(Me) {
          gt("update", Me), ve[Me] !== null && G && gt("set", Me);
        }));
      }
      function Ps(P) {
        _a(S.start, P);
      }
      function Bs(P, G, le, ve) {
        if (!((P = Number(P)) >= 0 && P < k.length)) throw new Error("noUiSlider: invalid handle number, got: " + P);
        mn(P, Mi(G, P), !0, !0, ve), gt("update", P), le && gt("set", P);
      }
      function Ri(P) {
        if (P === void 0 && (P = !1), P) return ne.length === 1 ? ne[0] : ne.slice(0);
        var G = ne.map(S.format.to);
        return G.length === 1 ? G[0] : G;
      }
      function zs() {
        for (Gn(U.aria), Gn(U.tooltips), Object.keys(S.cssClasses).forEach((function(P) {
          g(Te, S.cssClasses[P]);
        })); Te.firstChild; ) Te.removeChild(Te.firstChild);
        delete Te.noUiSlider;
      }
      function Fi(P) {
        var G = ee[P], le = d.getNearbySteps(G), ve = ne[P], De = le.thisStep.step, Ee = null;
        if (S.snap) return [ve - le.stepBefore.startValue || null, le.stepAfter.startValue - ve || null];
        De !== !1 && ve + De > le.stepAfter.startValue && (De = le.stepAfter.startValue - ve), Ee = ve > le.thisStep.startValue ? le.thisStep.step : le.stepBefore.step !== !1 && ve - le.stepBefore.highestStep, G === 100 ? De = null : G === 0 && (Ee = null);
        var Ue = d.countStepDecimals();
        return De !== null && De !== !1 && (De = Number(De.toFixed(Ue))), Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(Ue))), [Ee, De];
      }
      function Vs() {
        return k.map(Fi);
      }
      function Hs(P, G) {
        var le = Ri(), ve = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        ve.forEach((function(Ee) {
          P[Ee] !== void 0 && (w[Ee] = P[Ee]);
        }));
        var De = Qe(w);
        ve.forEach((function(Ee) {
          P[Ee] !== void 0 && (S[Ee] = De[Ee]);
        })), d = De.spectrum, S.margin = De.margin, S.limit = De.limit, S.padding = De.padding, S.pips ? hr(S.pips) : fr(), S.tooltips ? It() : ot(), ee = [], _a(a(P.start) ? P.start : le, G);
      }
      function Us() {
        K = _t(Te), mt(S.connect, K), Rs(S.events), _a(S.start), S.pips && hr(S.pips), S.tooltips && It(), xt();
      }
      Us();
      var Ca = { destroy: zs, steps: Vs, on: gr, off: Gn, get: Ri, set: _a, setHandle: Bs, reset: Ps, __moveHandles: function(P, G, le) {
        Ii(P, G, ee, le);
      }, options: w, updateOptions: Hs, target: Te, removePips: fr, removeTooltips: ot, getPositions: function() {
        return ee.slice();
      }, getTooltips: function() {
        return J;
      }, getOrigins: function() {
        return M;
      }, pips: hr };
      return Ca;
    }
    function vt(R, S) {
      if (!R || !R.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + R);
      if (R.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = ht(R, Qe(S), S);
      return R.noUiSlider = w, w;
    }
    var et = { __spectrum: V, cssClasses: Y, create: vt };
    n.create = vt, n.cssClasses = Y, n.default = et, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function ao(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, o) {
    return r === n[o];
  }));
}
var ri = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, s, l) {
    const { value: h, modelValue: v, min: u } = Ea(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = ge(f.value);
    if (Ma(f.value) && (f = ge(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, s, l) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ea(a), m = W((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: W((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((p) => {
        c[p] = Array.isArray(c[p]) ? c[p].filter(((x) => x !== null)).join(" ") : c[p];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), o = (function(a, s, l) {
    const { format: h, step: v } = Ea(a), u = l.value, f = l.classList, m = W((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : no({ ...h.value }) : no({ decimals: v.value >= 0 ? 0 : 2 }))), c = W((() => Array.isArray(u.value) ? u.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (p, x, g) => {
      var b = getComputedStyle(p).direction === "rtl", _ = p.noUiSlider.options.direction === "rtl", E = p.noUiSlider.options.orientation === "vertical", I = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      I.forEach((function(A, B) {
        A && L[B].appendChild(A);
      })), p.noUiSlider.on("update", (function(A, B, H, re, O) {
        var X = [[]], z = [[]], C = [[]], T = 0;
        I[0] && (X[0][0] = 0, z[0][0] = O[0], C[0][0] = m.value.to(parseFloat(A[0])));
        for (var F = 1; F < A.length; F++) (!I[F] || A[F] - A[F - 1] > x) && (X[++T] = [], C[T] = [], z[T] = []), I[F] && (X[T].push(F), C[T].push(m.value.to(parseFloat(A[F]))), z[T].push(O[F]));
        X.forEach((function(V, q) {
          for (var Y = V.length, U = 0; U < Y; U++) {
            var oe = V[U];
            if (U === Y - 1) {
              var ae = 0;
              z[q].forEach((function(de) {
                ae += 1e3 - de;
              }));
              var fe = E ? "bottom" : "right", be = _ ? 0 : Y - 1, Se = 1e3 - z[q][be];
              ae = (b && !E ? 100 : 0) + ae / Y - Se, I[oe].innerHTML = C[q].join(g), I[oe].style.display = "block", I[oe].style[fe] = ae + "%", f.value.tooltipHidden.split(" ").forEach(((de) => {
                I[oe].classList.contains(de) && I[oe].classList.remove(de);
              }));
            } else I[oe].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((de) => {
              I[oe].classList.add(de);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, s, l) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: p, id: x, disabled: g, options: b, classes: _, format: E, lazy: I, ariaLabelledby: L, aria: A } = Ea(a), B = l.value, H = l.initialValue, re = l.tooltipsFormat, O = l.tooltipsMerge, X = l.tooltipFormat, z = l.classList, C = ge(null), T = ge(null), F = ge(!1), V = W((() => {
      let de = { cssPrefix: "", cssClasses: z.value, orientation: h.value, direction: v.value, tooltips: !!u.value && re.value, connect: "lower", start: Ma(B.value) ? m.value : B.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (de.step = f.value), Array.isArray(B.value) && (de.connect = !0), L && L.value || A && Object.keys(A.value).length) {
        let ye = Array.isArray(B.value) ? B.value : [B.value];
        de.handleAttributes = ye.map(((Ae) => Object.assign({}, A.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return E.value && (de.ariaFormat = X.value), de;
    })), q = W((() => {
      let de = { id: x && x.value ? x.value : void 0 };
      return g.value && (de.disabled = !0), de;
    })), Y = W((() => Array.isArray(B.value))), U = () => {
      let de = T.value.get();
      return Array.isArray(de) ? de.map(((ye) => parseFloat(ye))) : parseFloat(de);
    }, oe = function(de) {
      let ye = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      T.value.set(de, ye);
    }, ae = (de) => {
      s.emit("input", de), s.emit("update:modelValue", de), s.emit("update", de);
    }, fe = () => {
      T.value = Km.create(C.value, Object.assign({}, V.value, b.value)), u.value && Y.value && p.value >= 0 && O(C.value, p.value, " - "), T.value.on("set", (() => {
        const de = U();
        s.emit("change", de), s.emit("set", de), I.value && ae(de);
      })), T.value.on("update", (() => {
        if (!F.value) return;
        const de = U();
        Y.value && ao(B.value, de) || !Y.value && B.value == de ? s.emit("update", de) : I.value || ae(de);
      })), T.value.on("start", (() => {
        s.emit("start", U());
      })), T.value.on("end", (() => {
        s.emit("end", U());
      })), T.value.on("slide", (() => {
        s.emit("slide", U());
      })), T.value.on("drag", (() => {
        s.emit("drag", U());
      })), C.value.querySelectorAll("[data-handle]").forEach(((de) => {
        de.onblur = () => {
          C.value && z.value.focused.split(" ").forEach(((ye) => {
            C.value.classList.remove(ye);
          }));
        }, de.onfocus = () => {
          z.value.focused.split(" ").forEach(((ye) => {
            C.value.classList.add(ye);
          }));
        };
      })), F.value = !0;
    }, be = () => {
      T.value.off(), T.value.destroy(), T.value = null;
    }, Se = (de, ye) => {
      F.value = !1, be(), fe();
    };
    return St(fe), Ln(be), He(Y, Se, { immediate: !1 }), He(m, Se, { immediate: !1 }), He(c, Se, { immediate: !1 }), He(f, Se, { immediate: !1 }), He(h, Se, { immediate: !1 }), He(v, Se, { immediate: !1 }), He(u, Se, { immediate: !1 }), He(p, Se, { immediate: !1 }), He(E, Se, { immediate: !1, deep: !0 }), He(b, Se, { immediate: !1, deep: !0 }), He(_, Se, { immediate: !1, deep: !0 }), He(B, ((de, ye) => {
      ye && (typeof ye == "object" && typeof de == "object" && de && Object.keys(ye) > Object.keys(de) || typeof ye == "object" && typeof de != "object" || Ma(de)) && Se();
    }), { immediate: !1 }), He(B, ((de) => {
      if (Ma(de)) return void oe(m.value, !1);
      let ye = U();
      Y.value && !Array.isArray(ye) && (ye = [ye]), (Y.value && !ao(de, ye) || !Y.value && de != ye) && oe(de, !1);
    }), { deep: !0 }), { slider: C, slider$: T, isRange: Y, sliderProps: q, init: fe, destroy: be, refresh: Se, update: oe, reset: () => {
      ae(H.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: o.tooltipFormat, tooltipsFormat: o.tooltipsFormat, tooltipsMerge: o.tooltipsMerge, classList: r.classList });
  return { ...r, ...o, ...i };
} };
ri.render = function(e, t, n, r, o, i) {
  return $(), j("div", Ce(e.sliderProps, { ref: "slider" }), null, 16);
}, ri.__file = "src/Slider.vue";
const Jm = ["data-click-name"], Qm = { class: "lc-slider__wrap" }, e1 = {
  key: 0,
  class: "lc-slider__min"
}, t1 = {
  key: 0,
  class: "lc-slider__slider-marks"
}, n1 = ["data-testid"], a1 = {
  key: 1,
  class: "lc-slider__max"
}, r1 = 1, W2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = ge(!1), r = ct("slider"), o = t, i = W({
      get: () => e.value,
      set: (f) => o("update:value", f)
    }), a = W(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), s = W(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + r1;
      return Array.from({ length: f }, (m, c) => c);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), j("div", {
      ref: "slider",
      class: pe(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      te("div", Qm, [
        e.hideMin ? se("", !0) : ($(), j("span", e1, [
          he(f.$slots, "min", Ot(Pt({ min: e.min })), () => [
            kt(Ie(e.format(e.min)), 1)
          ])
        ])),
        te("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = ca(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = ca(() => v("focusout"), ["stop"]))
        }, [
          Re(Z(ri), Ce({
            ...en(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? se("", !0) : ($(), j("div", t1, [
            ($(!0), j(at, null, yt(s.value, (c) => ($(), j("span", {
              key: c,
              class: pe(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: Et(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, n1))), 128))
          ]))
        ], 32),
        e.hideMax ? se("", !0) : ($(), j("span", a1, [
          he(f.$slots, "max", Ot(Pt({ max: e.max })), () => [
            kt(Ie(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, Jm));
  }
});
function kn() {
  return kn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(this, arguments);
}
var i1 = 0.996, l1 = function(t, n) {
  return n === void 0 && (n = i1), t * n / (1 - n);
};
function o1(e) {
  return e[e.length - 1];
}
function s1(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var c1 = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Ur(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function ro(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Wn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Wn(t);
  }), e;
}
function u1() {
  var e = {};
  function t(o, i) {
    return e[o] = (e[o] || []).concat(i), function() {
      return n(o, i);
    };
  }
  function n(o, i) {
    e[o] = (e[o] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(o, i) {
    o in e && e[o].forEach(function(a) {
      return a(i);
    });
  }
  return Wn({
    on: t,
    off: n,
    dispatch: r
  });
}
function d1(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(s) {
      return s !== a;
    });
  }, o = function() {
    t.forEach(r);
  };
  return Wn({
    observe: n,
    unobserve: r,
    disconnect: o
  });
}
var f1 = 16 * 1.125, h1 = typeof window < "u" && window.innerHeight || 800, qr = [1, f1, h1];
function v1(e) {
  var t = e.deltaX * qr[e.deltaMode], n = e.deltaY * qr[e.deltaMode], r = (e.deltaZ || 0) * qr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var m1 = [-1, -1, -1];
function g1(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? m1 : t.map(function(r) {
    return r ? -1 : 1;
  });
  return kn({}, e, {
    axisDelta: e.axisDelta.map(function(r, o) {
      return r * n[o];
    })
  });
}
var io = 700, b1 = function(t) {
  return kn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return c1(n, -io, io);
    })
  });
}, jr = process.env.NODE_ENV !== "production", p1 = 0.6, y1 = 0.96, w1 = 2, lo = 5, oo = /* @__PURE__ */ Wn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), x1 = 400;
function so() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: x1
  };
}
function k1(e) {
  e === void 0 && (e = {});
  var t = u1(), n = t.on, r = t.off, o = t.dispatch, i = oo, a = so(), s, l = !1, h, v = function(C) {
    Array.isArray(C) ? C.forEach(function(T) {
      return c(T);
    }) : c(C);
  }, u = function(C) {
    return C === void 0 && (C = {}), Object.values(C).some(function(T) {
      return T == null;
    }) ? (jr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Wn(kn({}, oo, i, C));
  }, f = function(C) {
    var T = kn({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Ur(T.axisMovement, T.axisVelocity.map(function(F) {
          return l1(F);
        }));
      }
    }, C);
    o("wheel", kn({}, T, {
      previous: h
    })), h = T;
  }, m = function(C, T) {
    var F = i, V = F.preventWheelAction, q = T[0], Y = T[1], U = T[2];
    if (typeof V == "boolean") return V;
    switch (V) {
      case "x":
        return Math.abs(q) >= C;
      case "y":
        return Math.abs(Y) >= C;
      case "z":
        return Math.abs(U) >= C;
      default:
        return jr && console.warn("unsupported preventWheelAction value: " + V, "warn"), !1;
    }
  }, c = function(C) {
    var T = b1(g1(v1(C), i.reverseSign)), F = T.axisDelta, V = T.timeStamp, q = ro(F);
    if (C.preventDefault && m(q, F) && C.preventDefault(), a.isStarted ? a.isMomentum && q > Math.max(2, a.lastAbsDelta * 2) && (B(!0), L()) : L(), q === 0 && Object.is && Object.is(C.deltaX, -0)) {
      l = !0;
      return;
    }
    s = C, a.axisMovement = Ur(a.axisMovement, F), a.lastAbsDelta = q, a.scrollPointsToMerge.push({
      axisDelta: F,
      timeStamp: V
    }), p(), f({
      axisDelta: F,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, A();
  }, p = function() {
    a.scrollPointsToMerge.length === w1 ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(C) {
        return C.axisDelta;
      }).reduce(Ur),
      timeStamp: s1(a.scrollPointsToMerge.map(function(C) {
        return C.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || E()) : a.isStartPublished || x();
  }, x = function() {
    a.axisVelocity = o1(a.scrollPointsToMerge).axisDelta.map(function(C) {
      return C / a.willEndTimeout;
    });
  }, g = function() {
    var C = a.scrollPoints, T = C[0], F = C[1];
    if (!(!F || !T)) {
      var V = T.timeStamp - F.timeStamp;
      if (V <= 0) {
        jr && console.warn("invalid deltaTime");
        return;
      }
      var q = T.axisDeltaSum.map(function(U) {
        return U / V;
      }), Y = q.map(function(U, oe) {
        return U / (a.axisVelocity[oe] || 1);
      });
      a.axisVelocity = q, a.accelerationFactors.push(Y), b(V);
    }
  }, b = function(C) {
    var T = Math.ceil(C / 10) * 10 * 1.2;
    a.isMomentum || (T = Math.max(100, T * 2)), a.willEndTimeout = Math.min(1e3, Math.round(T));
  }, _ = function(C) {
    return C === 0 ? !0 : C <= y1 && C >= p1;
  }, E = function() {
    if (a.accelerationFactors.length >= lo) {
      if (l && (l = !1, ro(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var C = a.accelerationFactors.slice(lo * -1), T = C.every(function(F) {
        var V = !!F.reduce(function(Y, U) {
          return Y && Y < 1 && Y === U ? 1 : 0;
        }), q = F.filter(_).length === F.length;
        return V || q;
      });
      T && I(), a.accelerationFactors = C;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = so(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, A = /* @__PURE__ */ (function() {
    var z;
    return function() {
      clearTimeout(z), z = setTimeout(B, a.willEndTimeout);
    };
  })(), B = function(C) {
    C === void 0 && (C = !1), a.isStarted && (a.isMomentum && C ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, H = d1(v), re = H.observe, O = H.unobserve, X = H.disconnect;
  return u(e), Wn({
    on: n,
    off: r,
    observe: re,
    unobserve: O,
    disconnect: X,
    feedWheel: v,
    updateOptions: u
  });
}
var S1 = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Ai.globalOptions = void 0;
var _1 = process.env.NODE_ENV !== "production";
function Ai(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var s, l, h = a.mergeOptions, v = a.optionsAtMedia, u = h(S1, Ai.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (s = t.target) != null ? s : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, x = k1({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      A = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = x.observe(c), _ = x.on("wheel", q), E = !1, I, L = 0, A = 0, B = !1;
    g(), i.on("resize", g);
    function H(Y) {
      try {
        I = new MouseEvent("mousedown", Y.event), T(I);
      } catch {
        return _1 && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      E = !0, L = 0, O(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function re(Y) {
      E = !1, T(C("mouseup", Y)), X(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", z, !0), document.documentElement.addEventListener("mouseup", z, !0), document.documentElement.addEventListener("mousedown", z, !0);
    }
    function X() {
      document.documentElement.removeEventListener("mousemove", z, !0), document.documentElement.removeEventListener("mouseup", z, !0), document.documentElement.removeEventListener("mousedown", z, !0);
    }
    function z(Y) {
      E && Y.isTrusted && Y.stopImmediatePropagation();
    }
    function C(Y, U) {
      var oe, ae;
      if (p === m.options.axis) {
        var fe = U.axisMovement;
        oe = fe[0], ae = fe[1];
      } else {
        var be = U.axisMovement;
        ae = be[0], oe = be[1];
      }
      var Se = F(U), de = Se.isAtBoundary;
      if (de) {
        var ye = Math.min(L / A, 1), Ae = 0.25 + ye * 0.5, Oe = oe > 0 ? -1 : 1, We = L * Oe, Ne = We * Ae;
        oe += Ne, ae += Ne;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var ue = m.containerRect.width, Fe = m.containerRect.height;
        oe = oe < 0 ? Math.max(oe, -ue) : Math.min(oe, ue), ae = ae < 0 ? Math.max(ae, -Fe) : Math.min(ae, Fe);
      }
      return new MouseEvent(Y, {
        clientX: I.clientX + oe,
        clientY: I.clientY + ae,
        screenX: I.screenX + oe,
        screenY: I.screenY + ae,
        movementX: oe,
        movementY: ae,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function T(Y) {
      i.containerNode().dispatchEvent(Y);
    }
    function F(Y) {
      var U = Y.axisDelta, oe = U[0], ae = U[1], fe = i.scrollProgress(), be = fe < 1, Se = fe > 0, de = p === "x" ? oe : ae, ye = de < 0, Ae = de > 0, Oe = ye && !be || Ae && !Se;
      return {
        isAtBoundary: Oe,
        primaryAxisDelta: de
      };
    }
    function V(Y) {
      var U = F(Y), oe = U.isAtBoundary, ae = U.primaryAxisDelta;
      if (oe && !Y.isMomentum) {
        if (L += Math.abs(ae), L > A)
          return B = !0, re(Y), !0;
      } else
        L = 0;
      return !1;
    }
    function q(Y) {
      var U = Y.axisDelta, oe = U[0], ae = U[1], fe = p === "x" ? oe : ae, be = p === "x" ? ae : oe, Se = Y.isMomentum && Y.previous && !Y.previous.isMomentum, de = Y.isEnding && !Y.isMomentum || Se, ye = Math.abs(fe) > Math.abs(be);
      ye && !E && !Y.isMomentum && !B && H(Y), B && Y.isEnding && (B = !1), E && (V(Y) || (de ? re(Y) : T(C("mousemove", Y))));
    }
    n = function() {
      b(), _(), i.off("resize", g), X();
    };
  }
  var o = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return o;
}
const C1 = { class: "lc-slot-wheel__wrap" }, X2 = /* @__PURE__ */ ke({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      tr({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      Ai()
    ], [a, s] = ar(
      {
        ...o,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = Xn(Qr, () => null, !0), h = yo(), v = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !1
      });
    }, u = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((A) => A.value === L)
    ), m = (L) => !L || h.value === "reduce", c = (L, A = !0) => {
      s.value?.scrollTo(f(L), m(A));
    }, p = () => {
      I(), r("ready");
    }, x = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      I(), r("reInit");
    }, _ = () => {
      const L = s.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, E = () => {
      r("optionsChanged");
    }, I = () => {
      if (!s.value) return;
      const { rootNode: L, slideNodes: A } = s.value, H = L().getBoundingClientRect(), re = H.top + H.height / 2;
      A().forEach((O) => {
        const X = O.getBoundingClientRect(), T = (X.top + X.height / 2 - re) / (H.height / 2), F = Math.max(-1, Math.min(1, T)), V = 1 - Math.abs(F) * 0.3, q = O.style.transform.split(" ").filter((Y) => !Y.startsWith("scale("));
        q.push(`scale(${V})`), O.style.transform = q.join(" ");
      });
    };
    return St(() => {
      s.value && s.value.on("init", p).on("pointerDown", x).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", _).on("slidesChanged", E);
    }), He(
      () => e.value,
      (L) => c(L)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), (L, A) => ($(), j("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      te("div", C1, [
        ($(!0), j(at, null, yt(e.options, (B, H) => ($(), j("div", {
          key: `${B.label}-${B.value}`,
          className: "lc-slot-wheel__option"
        }, [
          he(L.$slots, "option", Ce({ ref_for: !0 }, { index: H, option: B }), () => [
            kt(Ie(B.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), E1 = "checkmark", Y2 = ["info", "success"], T1 = ["for"], A1 = ["id", "aria-label", "data-click-name"], L1 = { class: "lc-switch__toggle" }, G2 = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: () => E1 },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: o } = wo(), i = W(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), j("label", {
      class: pe([i.value, s.$attrs.class]),
      for: Z(r)
    }, [
      Qt(te("input", Ce({
        ...en(s.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: Z(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = ci((h) => a.value = !a.value, ["enter"]))
      }), null, 16, A1), [
        [ho, a.value]
      ]),
      l[2] || (l[2] = te("div", { class: "lc-switch__track" }, null, -1)),
      te("div", L1, [
        Re(Z(Je), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, T1));
  }
}), K2 = /* @__PURE__ */ ke({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), j("table", {
      class: pe(t.value)
    }, [
      he(n.$slots, "default")
    ], 2));
  }
}), J2 = ["medium", "small", "none"], Q2 = ["column", "row"], eb = ["bottom", "top"], tb = ["automatic", "manual"], nb = ["default", "divider"], ab = /* @__PURE__ */ Symbol();
var Pn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Pn || {});
const $1 = ["id"], I1 = { class: "lc-tabs__tablist-inner" }, D1 = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], O1 = {
  key: 1,
  class: "lc-tabs__header"
}, M1 = ["aria-labelledby"], R1 = ["id", "aria-labelledby"], rb = /* @__PURE__ */ ke({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ct("carousel"), i = ct("container"), a = ct("tabs"), s = $t(e.id), l = ge(0), h = ge(0), v = ge(null), u = ge(null), f = ge(!1), m = ge(!1);
    let c = null;
    const p = W(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), x = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = a.value?.[l.value];
      O && (v.value = `${O.offsetWidth}px`, u.value = `${O.offsetLeft}px`);
    };
    qt(window, "resize", [g, x]), sc(i, g);
    const b = W(() => e.tabs.length <= 1), _ = (O, X) => {
      O !== l.value && (l.value = O, X?.skipCarousel || o.value?.moveToIndex(O), X?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, E = (O) => {
      a.value?.[O].focus();
    }, I = (O) => {
      if (O !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, A = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, B = (O) => e.tabs.findIndex((X) => X.name === O), H = (O) => {
      if (!tn(O.key, Pn)) return;
      O.preventDefault(), O.stopPropagation();
      let X;
      switch (O.key) {
        case Pn.ArrowLeft:
          X = A();
          break;
        case Pn.ArrowRight:
          X = L();
          break;
        case Pn.End:
          X = e.tabs.length - 1;
          break;
        case Pn.Home:
          X = 0;
          break;
      }
      h.value = X, e.trigger === "automatic" && _(X);
    }, re = () => {
      const O = B(e.value);
      O !== -1 && (l.value = O, h.value = O);
    };
    return Js(re), Qs(re), St(() => {
      g(), b.value || (f.value = !0);
    }), He(l, g), He(h, E), He(
      () => e.value,
      (O) => {
        if (!O) return;
        const X = B(O);
        X !== -1 && _(X, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, X) => ($(), j("section", {
      id: Z(s),
      class: pe(p.value)
    }, [
      he(O.$slots, "top"),
      b.value ? se("", !0) : ($(), j("div", {
        key: 0,
        ref: "container",
        class: pe(["lc-tabs__nav_container", e.containerClass])
      }, [
        te("nav", {
          class: pe(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Et({
            "--active-tab-index": l.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          te("div", I1, [
            ($(!0), j(at, null, yt(e.tabs, (z, C) => ($(), j("button", {
              id: `${Z(s)}-tab-${C}`,
              key: z.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${Z(s)}-tabpanel-${C}`,
              "aria-selected": l.value === C,
              class: pe(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== C ? -1 : void 0,
              type: "button",
              onClickPassive: (T) => _(C),
              onKeydown: H
            }, [
              O.$slots.tab ? he(O.$slots, "tab", Ce({ ref_for: !0 }, { tab: z, index: C }), void 0, void 0, 0) : ($(), j(at, { key: 1 }, [
                z.icon ? ($(), we(Z(Je), {
                  key: 0,
                  name: z.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : se("", !0),
                kt(" " + Ie(z.title ?? z.name), 1)
              ], 64))
            ], 42, D1))), 128))
          ])
        ], 6),
        he(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? ($(), j("header", O1, [
        he(O.$slots, "header")
      ])) : se("", !0),
      !f.value && e.tabs.length > 0 ? ($(), j("div", {
        key: 2,
        "aria-labelledby": `${Z(s)}-tab-${l.value}`,
        class: pe(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        he(O.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, M1)) : se("", !0),
      b.value ? se("", !0) : ($(), we(Z(hf), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: pe(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: X[0] || (X[0] = (z) => _(z, { skipCarousel: !0 })),
        onReady: X[1] || (X[1] = (z) => f.value = !0)
      }, {
        slide: _e(({ index: z, isVisible: C, slide: T }) => [
          te("div", Ce({
            id: `${Z(s)}-tabpanel-${z}`
          }, I(z), {
            "aria-labelledby": `${Z(s)}-tab-${z}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || C || z === l.value ? he(O.$slots, "tab-panel", Ot(Pt({ tab: T, index: z })), void 0, void 0, 0) : se("", !0)
          ], 16, R1)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, $1));
  }
}), F1 = ["for"], N1 = ["id"], P1 = ["id", "aria-labelledby", "data-click-error", "data-click-name"], B1 = { class: "lc-textarea__feedback-wrap" }, z1 = { class: "lc-textarea__counter" }, ib = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ct("textarea"), o = $t(e.id), i = ge(!1), a = W(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), s = W(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = W(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = W({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return St(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => ($(), j("div", {
      class: pe([a.value, v.$attrs.class])
    }, [
      te("label", {
        class: "lc-textarea__wrap",
        for: Z(o)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(o)}-label`,
          class: pe(l.value)
        }, Ie(e.label), 11, N1)) : se("", !0),
        Qt(te("textarea", Ce({
          id: Z(o),
          ref: "textarea"
        }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${Z(o)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, P1), [
          [ec, h.value]
        ])
      ], 8, F1),
      te("div", B1, [
        e.noFeedback ? se("", !0) : ($(), we(Z($n), Ce({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        te("span", z1, [
          te("span", null, Ie(s.value) + "/" + Ie(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), V1 = "info", lb = ["danger", "info", "success", "warning", "win"], H1 = { class: "lc-toast__indicator" }, U1 = { class: "lc-toast__content" }, q1 = {
  key: 0,
  class: "lc-toast__title"
}, j1 = {
  key: 0,
  class: "lc-toast__text"
}, ob = /* @__PURE__ */ ke({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: () => V1 }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), j("article", {
      class: pe(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      te("aside", H1, [
        Re(Z(Je), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      te("section", U1, [
        e.headline ? ($(), j("span", q1, Ie(e.headline), 1)) : se("", !0),
        he(n.$slots, "default", {}, () => [
          e.text ? ($(), j("p", j1, Ie(e.text), 1)) : se("", !0)
        ])
      ]),
      e.closable ? ($(), we(Z(Tt), {
        key: 0,
        "aria-label": Z(Ze).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (o) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : se("", !0)
    ], 2));
  }
}), Z1 = ["left", "right"], Es = 0.4, W1 = 0.75, co = 0.85, X1 = 0.2, uo = 150, Y1 = 8, G1 = Es, K1 = 400, J1 = 1800, Q1 = 300, eg = "cubic-bezier(0.22, 1, 0.36, 1)", tg = "cubic-bezier(0.4, 0, 0.2, 1)", ng = {
  key: 1,
  class: "lc-swipeable__action-label"
}, sb = /* @__PURE__ */ ke({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ct("lcSwipeableRef"), i = cn(), a = ge(null), s = ge(0), l = ge(0), h = ge(0), v = ge(!1), u = ge(!1), f = ge(!1), m = ge(!1), c = ge(!1), p = ge(null), x = ge(!1), g = ge(null);
    let b = 0, _ = null, E = null, I = 0;
    const { direction: L, distanceX: A } = cc(o, {
      onSwipe: () => {
        if (g.value === null || e.disabled || c.value || !o.value)
          return;
        v.value || ae();
        const me = o.value.clientWidth, Be = l.value - A.value, ze = Y(Be);
        if (ze && !C(ze)) {
          s.value = 0;
          return;
        }
        const Ke = F(ze), Qe = q(Be, me, T(ze));
        m.value = U(me, Ke), h.value = Math.min(1, Math.abs(A.value) / (me * Ke));
        const ht = !!(ze && z(ze)?.fullSwipe && m.value);
        fe(ht), be(ze), s.value = ht && ze ? oe(ze, me) : Qe, ze && ze !== a.value && Se(ze);
      },
      onSwipeEnd: (me, Be) => qe(Be),
      pointerTypes: e.pointerTypes,
      threshold: Y1
    }), B = W(() => Z1.map((me) => ({ action: z(me), side: me }))), H = W(() => v.value && !u.value), re = W(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": H.value }
    ]), O = W(() => ({
      transform: `translateX(${s.value}px)`,
      ...p.value === null ? {} : { transition: p.value }
    })), X = W(() => co + (1 - co) * h.value), z = (me) => me === "left" ? e.leftAction : me === "right" ? e.rightAction : void 0, C = (me) => !!(z(me) || i[`${me}-action`]), T = (me) => z(me)?.resistanceThreshold ?? W1, F = (me) => {
      const Be = z(me);
      return Be?.fullSwipe ? T(me) : Be?.activationThreshold ?? Es;
    }, V = () => {
      if (!o.value) return 0;
      const me = o.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!me) return 0;
      const Be = getComputedStyle(me).transform;
      if (!Be || Be === "none") return 0;
      const ze = new DOMMatrix(Be).m41;
      return Number.isFinite(ze) ? ze : 0;
    }, q = (me, Be, ze) => {
      const Ke = Be * ze, Qe = Math.abs(me);
      if (Qe <= Ke) return me;
      const ht = Be * X1, et = (1 - 1 / ((Qe - Ke) / ht + 1)) * ht;
      return Math.sign(me) * (Ke + et);
    }, Y = (me) => me < 0 ? "left" : me > 0 ? "right" : null, U = (me, Be) => Math.abs(A.value) >= me * Be, oe = (me, Be) => me === "left" ? -Be : Be, ae = () => {
      l.value = V(), v.value = !0, g.value !== null && Oe(g.value);
    }, fe = (me) => {
      me !== f.value && (f.value = me, u.value = !0, b = performance.now());
    }, be = (me) => {
      !u.value || f.value || !(performance.now() - b >= uo) && me === a.value || (u.value = !1);
    }, Se = (me) => {
      a.value = me, x.value = !0, r("swipe-start", me);
    }, de = () => {
      !x.value || !a.value || (x.value = !1, r("swipe-end", a.value));
    }, ye = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, Ae = (me) => !e.pointerTypes || e.pointerTypes.includes(me.pointerType), Oe = (me) => {
      o.value?.setPointerCapture?.(me);
    }, We = (me) => {
      o.value?.hasPointerCapture?.(me) && o.value.releasePointerCapture(me);
    }, Ne = () => {
      _ !== null && (clearTimeout(_), _ = null);
    }, ue = () => {
      Ne(), g.value === null && (a.value = null);
    }, Fe = () => {
      Ne(), _ = setTimeout(ue, uo);
    }, qe = (me) => {
      if (g.value === null) return;
      We(g.value), g.value = null, de();
      const Be = f.value;
      ye(), m.value = !1;
      const ze = !e.disabled && (me === "left" || me === "right") && C(me) && o.value !== null && U(o.value.clientWidth, F(me));
      (!ze || !Be) && (s.value = 0), (!ze || !Be) && Fe(), ze && r("trigger", me);
    }, je = () => {
      u.value = !1, g.value === null && s.value === 0 && ue();
    }, Xe = () => {
      E !== null && (clearTimeout(E), E = null);
    }, Ve = () => {
      I += 1, Xe(), c.value = !1, p.value = null;
    }, Pe = (me) => new Promise((Be) => {
      E = setTimeout(() => {
        E = null, Be();
      }, me);
    }), rt = async (me, Be = {}) => {
      const ze = o.value;
      if (!ze || !C(me)) return;
      const {
        distance: Ke = ze.clientWidth * G1,
        hold: Qe = J1,
        slideBack: ht = Q1,
        slideOut: vt = K1
      } = Be;
      Ve();
      const et = ++I;
      Ne(), c.value = !0, a.value = me, p.value = `transform ${vt}ms ${eg}`, s.value = (me === "left" ? -1 : 1) * Ke, await Pe(vt + Qe), et === I && (p.value = `transform ${ht}ms ${tg}`, s.value = 0, await Pe(ht), et === I && (c.value = !1, p.value = null, ue()));
    }, ut = () => {
      Ve();
      const me = a.value, Be = x.value;
      g.value !== null && (We(g.value), g.value = null), ye(), s.value = 0, m.value = !1, x.value = !1, Be && me && r("swipe-end", me), Fe();
    };
    return qt(o, "pointerdown", (me) => {
      Ae(me) && (Ne(), Ve(), g.value = me.pointerId);
    }), qt(window, ["pointerup", "pointercancel"], (me) => {
      me.pointerId === g.value && qe(L.value);
    }), qt(window, "pointermove", (me) => {
      g.value !== null && (me.pointerType !== "mouse" || me.buttons !== 0 || qe(L.value));
    }), qt(o, "pointercancel", ut), He(
      () => e.disabled,
      (me) => {
        me && ut();
      }
    ), oi(() => {
      Ne(), Ve();
    }), t({ close: ut, preview: rt }), (me, Be) => ($(), j("div", {
      ref_key: "lcSwipeableRef",
      ref: o,
      class: pe([
        "lc-swipeable",
        {
          "lc-swipeable--disabled": e.disabled,
          "lc-swipeable--dragging": H.value
        }
      ])
    }, [
      ($(!0), j(at, null, yt(B.value, ({ side: ze, action: Ke }) => ($(), j(at, { key: ze }, [
        Ke || me.$slots[`${ze}-action`] ? ($(), j("div", {
          key: 0,
          class: pe([
            "lc-swipeable__action",
            `lc-swipeable__action--${ze}`,
            {
              "lc-swipeable__action--hidden": a.value !== ze,
              "lc-swipeable__action--dragging": H.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ze
            }
          ])
        }, [
          he(me.$slots, `${ze}-action`, {}, () => [
            Ke ? ($(), j("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Et(a.value === ze ? { transform: `scale(${X.value})` } : void 0)
            }, [
              Re(Z(Je), {
                name: Ke.icon
              }, null, 8, ["name"])
            ], 4)) : se("", !0),
            Ke?.label ? ($(), j("span", ng, Ie(Ke.label), 1)) : se("", !0)
          ])
        ], 2)) : se("", !0)
      ], 64))), 128)),
      te("div", {
        class: pe(re.value),
        style: Et(O.value),
        onTransitionend: ca(je, ["self"])
      }, [
        he(me.$slots, "default")
      ], 38)
    ], 2));
  }
}), ag = { class: "lc-lottery-remaining-picks__headline" }, rg = { class: "lc-lottery-remaining-picks__done" }, ig = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, lg = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, og = /* @__PURE__ */ ke({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => Ze.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = ge(!1);
    He(
      () => e.complete,
      (r, o) => {
        r && !o ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const o = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === o && (t.value = !1);
    };
    return (r, o) => ($(), j("div", {
      class: pe([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      te("div", ag, [
        he(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      te("div", rg, [
        te("span", ig, [
          Re(Z(Je), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), j("span", lg, Ie(e.doneLabel), 1)) : se("", !0)
      ])
    ], 34));
  }
}), sg = ["aria-hidden"], cg = {
  key: 0,
  class: "lc-lottery-editor-card__warning lc-lottery-editor-card__warning--headline"
}, ug = ["aria-hidden"], dg = {
  key: 0,
  ref: "warning",
  class: "lc-lottery-editor-card__warning"
}, fg = {
  key: 1,
  ref: "labels",
  class: "lc-lottery-editor-card__labels"
}, hg = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, vg = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, mg = { class: "lc-lottery-editor-card__footer" }, gg = "medium", cb = /* @__PURE__ */ ke({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ _n({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => Ze.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    numberClass: { type: Function },
    quickPickLabel: { default: () => Ze.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    removable: { type: Boolean, default: !1 },
    removeAriaLabel: { default: () => Ze.lcLotteryEditorCard.removeAriaLabel },
    toggleAriaLabel: { default: () => Ze.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    warning: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ _n(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "remove", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Ya(e, "expanded"), o = ge();
    tc(() => {
      r.value && (o.value = e.warning);
    });
    const i = () => {
      e.removable && n("remove");
    }, a = ct("summary"), s = ct("numbers"), l = (b) => s.value?.$el?.querySelector(b) ?? void 0, h = W(() => l(".lc-lottery-numbers__number")), { width: v } = Nn(a), { width: u } = Nn(h), { width: f } = Nn(
      W(() => s.value?.$el ?? a.value?.firstElementChild)
    ), { width: m } = Nn(ct("labels")), { width: c } = Nn(ct("warning")), p = W(() => {
      if (!a.value || !c.value) return !1;
      const b = parseFloat(getComputedStyle(a.value).columnGap) || 0;
      return f.value + m.value + c.value + 2 * b <= v.value;
    }), x = W(
      () => e.fields?.reduce((b, { numbers: _ }) => b + _.length, 0) ?? 0
    ), g = W(() => {
      if (!v.value || !u.value || !x.value) return;
      const b = l(".lc-lottery-numbers__list"), _ = b && parseFloat(getComputedStyle(b).columnGap) || 0, E = Math.max(
        1,
        Math.floor((v.value + _) / (u.value + _))
      ), I = Math.ceil(x.value / E);
      return I > 1 ? I : void 0;
    });
    return (b, _) => ($(), we(Z(wa), Ce({
      modelValue: r.value,
      "onUpdate:modelValue": _[2] || (_[2] = (E) => r.value = E),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: [
        "lc-lottery-editor-card",
        {
          "lc-lottery-editor-card--removable": e.removable,
          "lc-lottery-editor-card--separated": e.separated,
          "lc-lottery-editor-card--warning": e.warning && !r.value
        }
      ],
      expandable: !e.removable,
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow }, {
      "toggle-aria-label": e.warning ? `${e.toggleAriaLabel}, ${e.warning}` : e.toggleAriaLabel,
      onCollapse: _[3] || (_[3] = (E) => n("collapse")),
      onCollapsed: _[4] || (_[4] = (E) => n("collapsed")),
      onExpand: _[5] || (_[5] = (E) => n("expand")),
      onExpanded: _[6] || (_[6] = (E) => n("expanded"))
    }), {
      header: _e(() => [
        ($(), we(Ft(e.removable ? "button" : "div"), {
          "aria-label": e.removable ? e.removeAriaLabel : void 0,
          class: pe([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ]),
          type: e.removable ? "button" : void 0,
          onClick: i
        }, {
          default: _e(() => [
            te("div", {
              "aria-hidden": !r.value,
              class: "lc-lottery-editor-card__expanded"
            }, [
              o.value ? ($(), j("span", cg, [
                Re(Z(Je), {
                  name: "edit",
                  size: "small"
                }),
                kt(" " + Ie(o.value), 1)
              ])) : se("", !0),
              Re(Z(og), Ce({
                class: { "lc-lottery-editor-card__remaining--hidden": o.value }
              }, { complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining }), {
                default: _e(({ countClass: E }) => [
                  he(b.$slots, "headline", Ot(Pt({ countClass: E })))
                ]),
                _: 3
              }, 16, ["class"])
            ], 8, sg),
            te("div", {
              ref: "summary",
              "aria-hidden": r.value,
              class: pe([
                "lc-lottery-editor-card__summary",
                { "lc-lottery-editor-card__summary--inline": p.value }
              ])
            }, [
              he(b.$slots, "summary", {}, () => [
                e.fields ? ($(), we(Z(dv), Ce({
                  key: 0,
                  ref: "numbers"
                }, { fields: e.fields, numberClass: e.numberClass }, {
                  rows: g.value,
                  size: gg
                }), null, 16, ["rows"])) : se("", !0)
              ]),
              e.warning ? ($(), j("span", dg, [
                Re(Z(Je), {
                  name: "edit",
                  size: "small"
                }),
                kt(" " + Ie(e.warning), 1)
              ], 512)) : se("", !0),
              e.wager || e.betType ? ($(), j("div", fg, [
                e.wager ? ($(), j("span", hg, Ie(e.wager), 1)) : se("", !0),
                e.betType ? ($(), j("span", vg, Ie(e.betType), 1)) : se("", !0)
              ], 512)) : se("", !0)
            ], 10, ug)
          ]),
          _: 3
        }, 8, ["aria-label", "class", "type"])),
        e.removable ? ($(), we(Z(Je), {
          key: 0,
          class: "lc-lottery-editor-card__remove",
          name: "trash-full"
        })) : se("", !0)
      ]),
      footer: _e(() => [
        te("div", mg, [
          Re(Z(Tt), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "clear",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: _[0] || (_[0] = (E) => n("clear"))
          }, {
            default: _e(() => [
              kt(Ie(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Re(Z(Tt), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: _[1] || (_[1] = (E) => n("quick-pick"))
          }, {
            default: _e(() => [
              kt(Ie(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _e(() => [
        e.separated ? ($(), we(Z(hi), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : se("", !0),
        he(b.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "expandable", "header-class", "toggle-aria-label"]));
  }
});
export {
  Ko as AmplitudeEvents,
  Bt as FORM_FIELD_EVENTS,
  Ng as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  Nu as LC_BUTTON_DEFAULT_ICON_POSITION,
  Pu as LC_BUTTON_DEFAULT_SIZE,
  Bu as LC_BUTTON_DEFAULT_VARIANT,
  Cg as LC_BUTTON_ICON_POSITIONS,
  Eg as LC_BUTTON_SIZES,
  Ag as LC_BUTTON_TRIGGERS,
  Tg as LC_BUTTON_TYPES,
  Lg as LC_BUTTON_VARIANTS,
  Ig as LC_CARD_RADII,
  Dg as LC_CARD_SHADOWS,
  Og as LC_CARD_VARIANTS,
  Bg as LC_CAROUSEL_MOVE_TRIGGERS,
  Pg as LC_CAROUSEL_VARIANTS,
  Vg as LC_COUNTDOWN_VARIANTS,
  wg as LC_COUNT_BUBBLE_VARIANTS,
  e2 as LC_FORM_FIELD_INTERACTION_MODES,
  vc as LC_ICON_DEFAULT_SIZE,
  kg as LC_ICON_NAMES,
  xg as LC_ICON_SIZES,
  r2 as LC_INFO_BUTTON_VARIANTS,
  jh as LC_INFO_TEXT_DEFAULT_ICON_SIZE,
  Zh as LC_INFO_TEXT_DEFAULT_SIZE,
  f2 as LC_INFO_TEXT_ICON_ALIGNMENTS,
  h2 as LC_INFO_TEXT_SIZES,
  jg as LC_INPUT_MODES,
  Zg as LC_INPUT_TYPES,
  b2 as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  a2 as LC_LOTTERY_JACPOT_SIZES,
  w2 as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  p2 as LC_LOTTERY_NUMBER_SIZES,
  y2 as LC_LOTTERY_NUMBER_SPACINGS,
  S2 as LC_LOTTERY_TEASER_VARIANTS,
  C2 as LC_MENU_BUTTON_PLACEMENTS,
  mm as LC_MESSAGE_BOX_DEFAULT_SIZE,
  gm as LC_MESSAGE_BOX_DEFAULT_VARIANT,
  T2 as LC_MESSAGE_BOX_SIZES,
  A2 as LC_MESSAGE_BOX_VARIANTS,
  Mg as LC_MODAL_CLOSE_TRIGGERS,
  Rg as LC_MODAL_SPACINGS,
  D2 as LC_PASSWORD_INPUT_TYPES,
  Am as LC_PROGRESS_INDICATOR_DEFAULT_PROGRESS,
  Lm as LC_PROGRESS_INDICATOR_DEFAULT_SIZE,
  O2 as LC_PROGRESS_INDICATOR_SIZES,
  M2 as LC_PROGRESS_INDICATOR_VARIANTS,
  P2 as LC_RADIO_GROUP_LAYOUTS,
  U2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  j2 as LC_SELECT_LIST_VARIANTS,
  Wu as LC_SEPARATOR_DEFAULT_VARIANT,
  $g as LC_SEPARATOR_VARIANTS,
  z2 as LC_SKELETON_RADII,
  E1 as LC_SWITCH_DEFAULT_ICON,
  Y2 as LC_SWITCH_VARIANTS,
  J2 as LC_TABLE_PADDINGS,
  Q2 as LC_TABS_FLEX_DIRECTIONS,
  eb as LC_TABS_NAVIGATION_POSITIONS,
  tb as LC_TABS_TRIGGERS,
  nb as LC_TABS_VARIANTS,
  i2 as LC_TEASER_BACKGROUND_PATTERNS,
  l2 as LC_TEASER_BADGE_VARIANTS,
  o2 as LC_TEASER_HERO_BADGE_VARIANTS,
  ts as LC_TEASER_VARIANTS,
  V1 as LC_TOAST_DEFAULT_VARIANT,
  lb as LC_TOAST_VARIANTS,
  Sg as LcBadge,
  Fg as LcBottomSheet,
  Tt as LcButton,
  Yr as LcButtonActiveKeys,
  wa as LcCard,
  hf as LcCarousel,
  Ra as LcCarouselActiveKeys,
  zg as LcCheckbox,
  Zr as LcCountBubble,
  wf as LcCountdown,
  Hg as LcDataList,
  Ug as LcDataListItem,
  Wg as LcDateInput,
  Xg as LcDescriptionList,
  Yg as LcDigitInput,
  ln as LcDigitInputActiveKeys,
  Gg as LcDigitInputGroup,
  Gf as LcExpandable,
  Kg as LcExpandableList,
  Jg as LcFlyOut,
  Qg as LcForm,
  t2 as LcFormField,
  n2 as LcHeader,
  g0 as LcHighFrequencyBall,
  Jo as LcHighFrequencyBallBackground,
  s2 as LcHighFrequencyTeaser,
  c2 as LcHighFrequencyTeaserWatch,
  Je as LcIcon,
  d2 as LcImage,
  es as LcInfoButton,
  v2 as LcInfoText,
  rr as LcInput,
  m2 as LcLinkList,
  g2 as LcLinkListItem,
  jl as LcLotteryCutoffTime,
  cb as LcLotteryEditorCard,
  Qo as LcLotteryJackpot,
  x2 as LcLotteryNumberSelector,
  Zt as LcLotteryNumberSelectorActiveKeys,
  dv as LcLotteryNumbers,
  og as LcLotteryRemainingPicks,
  k2 as LcLotteryTeaser,
  _2 as LcMaskedValueDisplay,
  E2 as LcMenuButton,
  Ut as LcMenuButtonActiveKeys,
  L2 as LcMessageBox,
  No as LcModal,
  $2 as LcMoneyInput,
  I2 as LcPasswordInput,
  R2 as LcProgressIndicator,
  Rm as LcRadio,
  F2 as LcRadioCard,
  N2 as LcRadioGroup,
  B2 as LcRating,
  V2 as LcRemoteList,
  H2 as LcScratchcardTeaser,
  q2 as LcSelect,
  Gt as LcSelectActiveKeys,
  Z2 as LcSelectList,
  Wt as LcSelectListActiveKeys,
  hi as LcSeparator,
  zm as LcSkeleton,
  W2 as LcSlider,
  X2 as LcSlotWheel,
  sb as LcSwipeable,
  G2 as LcSwitch,
  K2 as LcTable,
  rb as LcTabs,
  Pn as LcTabsActiveKeys,
  ir as LcTeaser,
  P0 as LcTeaserBadge,
  z0 as LcTeaserHeroBadge,
  ns as LcTeaserHeroBadgeColor,
  ib as LcTextarea,
  ob as LcToast,
  Qr as carouselContext,
  Ze as globalConfig,
  V0 as isHeroBadge,
  wu as nuxtAppContext,
  _g as setGlobalConfig,
  ab as tabContext
};
